// Confirmation d'un geste destructeur : le dialogue du système (src/ui/components/dialog.js), jamais confirm().
// La suite du geste est une fonction, exécutée seulement si l'on accepte. Tant que le composant n'est pas chargé
// (il vient après ce fichier), on exécute : aucune action ne doit se perdre au démarrage.
function confirmerPuis(opts, suite) {
    if (window.dialogue && window.dialogue.confirmer) { window.dialogue.confirmer(opts).then(function(ok) { if (ok) suite(); }); return; }
    suite();
}

// EDN Smart Planner — moteur de l'application, commun à toutes les pages.
// Chaque page HTML déclare window.PAGE puis charge assets/app.bundle.js (src/main.js). Ce fichier est le reste du
// moteur historique en cours de découpage : l'état, le client API, le routage, l'historique, la persistance et
// les aides de base vivent dans src/core/.

// ==========================================
// 1. BASE DE DONNÉES CSV
// ==========================================
// ==========================================
// 1bis. DONNÉES DE VOLUMÉTRIE DES FICHES (mots, PDF, grandes parties)
// Source : mesure au mot près des 367 PDF du dossier fiches_edn (rang C retiré,
// temps de lecture basé sur 130 mots/minute). Clé = numéro d'item officiel.
// ==========================================
// ==========================================
// 2. MOTEUR VANILLA JS COMPLET ET SÉCURISÉ
// ==========================================


// Score d'un item : un rang de priorité. Une seule échelle, du plus dense au plus discret, jamais la
// sémantique de révision (validé / en retard / erreur), qui ne dit pas la même chose.
window.getBadgeStyle = function(score) {
    if (score === 3) return "rang rang-3";
    if (score === 2) return "rang rang-2";
    if (score === 1) return "rang rang-1";
    return "rang rang-0";
};

window.getScoreLabel = function(score) {
    if (score === 3) return "Rang or";
    if (score === 2) return "Incontournable";
    if (score === 1) return "Important";
    return "Secondaire";
};


// Longueur d'une fiche : une échelle de densité, pas un danger. Le fond reste neutre (échelle 1 à 4 dans
// composants.css) ; « très longue » n'est pas une erreur, c'est une séance qui prendra plus de temps.
window.LENGTH_TIERS = [
    { max: 1208, label: 'Courte', class: 'densite densite-1' },
    { max: 1725, label: 'Moyenne', class: 'densite densite-2' },
    { max: 2554, label: 'Longue', class: 'densite densite-3' },
    { max: Infinity, label: 'Très longue', class: 'densite densite-4' }
];
window.getLengthTier = function(words) {
    if (!words) return null;
    for (var i = 0; i < window.LENGTH_TIERS.length; i++) {
        if (words <= window.LENGTH_TIERS[i].max) return window.LENGTH_TIERS[i];
    }
    return window.LENGTH_TIERS[window.LENGTH_TIERS.length - 1];
};

window.getFicheDirectLink = function(itemId) {
    // Fiche PDF déposée sur le serveur (edn_data/fiches_edn/, servie par api.php aux sessions connectées) en priorité, sinon Google Drive
    if (window.LOCAL_FICHES && window.LOCAL_FICHES[itemId.toString()]) return 'api.php?action=fiche_pdf&item=' + encodeURIComponent(itemId);
    var fd = window.getFicheData(itemId);
    if (!fd || !fd.pdf) return null;
    return 'https://drive.google.com/file/d/' + fd.pdf + '/view';
};

// Fiche pathologies d'un item (conduite à tenir de chaque pathologie, en étapes oui/non) : privée, administrateur seul.
// api.php refuse les autres comptes ; ici on ne montre simplement pas l'entrée.
window.fichePathoLien = function(itemId) {
    var n = parseInt(itemId, 10);
    if (!window.estAdmin || !window.estAdmin() || !(n >= 1 && n <= 367)) return null;
    return 'api.php?action=fiche_patho&item=' + n;
};

// ==========================================
// 2bis. GESTION MULTI-PLANNINGS
// ==========================================

// Rendu progressif d'une longue liste (catalogue et QCM : 367 lignes, ~10 000 nœuds). Le premier écran est
// inséré tout de suite, le reste est ajouté par paquets aux images suivantes : le changement d'onglet et la
// frappe dans la recherche restent instantanés. Un nouveau rendu annule le précédent (jeton), et l'ajout
// s'arrête si la liste a été retirée du document (changement d'onglet).
// Catalogue indexé par identifiant. Sans lui, chaque carte de tâche refaisait un parcours complet des ~370
// items : anodin sur le tableau de bord, ruineux dans le calendrier où il y a des milliers de cartes.


// --- TRAITEMENT PAR LOTS (Batches) ------------------------------------------------------------------------
// Les mêmes demandes que les boutons habituels, envoyées d'un coup à l'API Messages Batches de Claude :
// moitié prix sur l'entrée ET la sortie, en échange de l'attente (la plupart des lots aboutissent en moins
// d'une heure, la limite est de 24 h). Rien n'est appliqué tout seul : le lot est mémorisé sur le serveur,
// et l'écran « Lots » laisse choisir item par item ce qu'on garde. Appliquer un découpage passe par
// window.planningAction, donc « Revenir en arrière » l'annule comme n'importe quelle action du planning.
window.LOT_KINDS = {
    split:          { titre: 'Découpage en sous-parties', icone: 'fa-scissors',        court: 'Découpage' },
    podcast_script: { titre: 'Scripts de podcast',        icone: 'fa-microphone-lines', court: 'Scripts' },
    podcast_fiche:  { titre: 'Fiches à suivre',           icone: 'fa-list-check',       court: 'Fiches' },
    flashcards:     { titre: 'Flashcards',                icone: 'fa-layer-group',      court: 'Flashcards' },
    qcm_pedia:      { titre: 'QCM renforcement pédiatrie', icone: 'fa-child-reaching',  court: 'QCM pédiatrie' },
    // Réécriture des renforcements pédiatrie. Ces périmètres ont DÉJÀ leur script (ou leur fiche) : ils sont
    // donc invisibles des onglets normaux, qui ne proposent que ce qui manque. Ils partent avec « force », et
    // le serveur remplace au lieu de refuser. « serveur » dit à quel type de lot ils correspondent vraiment.
    ped_script:     { titre: 'Réécrire les renforcements pédiatrie', icone: 'fa-arrows-rotate', court: 'Réécrire pédiatrie', serveur: 'podcast_script' },
    ped_fiche:      { titre: 'Réécrire les fiches pédiatrie', icone: 'fa-list-check', court: 'Fiches pédiatrie', serveur: 'podcast_fiche', onglet: false },
    // Items regroupés (sous-parties gardées en mémoire) : un script COMPLET de l'item, écrit à partir des scripts
    // déjà générés pour ses sous-parties, qui restent tels quels. Même type serveur qu'un script ordinaire, avec
    // en plus la liste des sous-parties à fusionner.
    regroup_script: { titre: 'Scripts complets des items regroupés', icone: 'fa-object-group', court: 'Regroupés', serveur: 'podcast_script' },
};
// Comment s'appelle ce qu'on coche, dans cet écran-là.
window.lotUnite = function(kind) { return (kind === 'podcast_script' || kind === 'flashcards') ? 'périmètre' : ((kind === 'ped_script' || kind === 'ped_fiche') ? 'renforcement' : 'item'); };
// Items regroupés dont au moins une sous-partie d'origine a son script, et qui n'ont pas encore de script complet :
// la matière première du script fusionné. Les sous-parties sans script sont comptées : le modèle les couvre depuis
// la fiche. Un item qui a déjà son podcast entier n'est pas proposé (pas de doublon, rien d'écrasé).
window.lotPodcastsRegroupes = function() {
    var out = [], A = window.state.subPartsArchive || {};
    Object.keys(A).forEach(function(n) {
        var parts = A[n] || []; if (!parts.length) return;
        if (window.podcastFor(n, '', false, false) || window.podcastFor(n, '', false, true)) return;
        var avec = parts.filter(function(p) { var pc = window.podcastFor(n, p, false, false) || window.podcastFor(n, p, false, true); return pc && (pc.status === 'script' || pc.status === 'audio' || pc.status === 'ready' || pc.turns); });
        if (!avec.length) return;
        var def = window.itemById(n);
        out.push({ key: n + '|fusion', id: String(n), titreItem: def ? def.titre : ('Item ' + n),
            titre: (def ? def.titre : ('Item ' + n)) + ' · ' + avec.length + '/' + parts.length + ' sous-partie' + (parts.length > 1 ? 's' : '') + ' avec script',
            matiere: def ? def.matiere : '', parts: parts, avec: avec });
    });
    return out.sort(function(a, b) { return (parseInt(a.id, 10) || 0) - (parseInt(b.id, 10) || 0); });
};
// Type de lot côté serveur (il n'en connaît que cinq) pour un écran donné.
window.lotKindServeur = function(kind) { return (window.LOT_KINDS[kind] || {}).serveur || kind; };
// Le .catch ne doit couvrir QUE l'appel réseau : s'il enveloppe aussi cb(), la moindre erreur de programmation
// dans le traitement de la réponse ressort en « Erreur réseau », ce qui envoie chercher la panne au mauvais
// endroit. Ici une exception du callback est nommée pour ce qu'elle est.
// Journal des échanges avec le serveur : c'est ce que la console affiche. Il vit en mémoire (200 lignes) et
// ne coûte rien ; sans lui, un lot qui ne part pas ne laisse aucune trace visible.
window.lotJournal = [];
window.lotLog = function(niveau, texte, ms) {
    window.lotJournal.push({ t: Date.now(), niveau: niveau, texte: texte, ms: ms });
    if (window.lotJournal.length > 200) window.lotJournal.shift();
    if (window.state.lots && window.state.lots.console) window.renderModal();
};
window.lotApi = function(action, payload, cb) {
    var t0 = Date.now();
    var taille = 0;
    var corps = JSON.stringify(Object.assign({ action: action }, payload || {}));
    taille = corps.length;
    // Garde-fou de dernier recours contre un envoi qui déraille. Le seuil n'est PAS serré : un paquet
    // légitime de 100 items de découpage pèse 113 Ko (mesuré), et le serveur accepte bien plus
    // (post_max_size 512 Mo, EDN_BATCH_MAX_OCTETS 24 Mo). À 100 Ko, tous les découpages étaient refusés
    // en silence et le paquet disparaissait de la file : on croyait que rien ne partait.
    if (taille > 2000000) { window.lotLog('erreur', 'Envoi refusé, trop volumineux : ' + Math.round(taille / 1024) + ' Ko (plafond 2 Mo)', null); if (cb) cb({ success: false, message: 'Envoi trop volumineux (' + Math.round(taille / 1024) + ' Ko)' }); return; }
    window.lotLog('envoi', action + (taille > 4096 ? ' · ' + Math.round(taille / 1024) + ' Ko envoyés' : ''), null);
    fetch('api.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: corps })
        .then(function(r) { return r.text(); })
        .then(function(t) { try { return JSON.parse(t); } catch (e) { return { success: false, message: window.apiSnippetLot(t) }; } },
              function(e) { return { success: false, message: 'Erreur réseau : ' + e.message }; })
        .then(function(d) {
            var ms = Date.now() - t0;
            if (d && d.success) window.lotLog('ok', action + (d.batch ? ' → lot ' + d.batch.id + ' (' + d.batch.total + ' requêtes)' : '') + ((d.differes || []).length ? ' · ' + d.differes.length + ' différés' : '') + ((d.skipped || []).length ? ' · ' + d.skipped.length + ' écartés' : ''), ms);
            else window.lotLog('erreur', action + ' : ' + ((d && d.message) || 'échec'), ms);
            try { cb(d); }
            catch (e) { console.error('lotApi/' + action, e); window.lotLog('erreur', 'Erreur interne (' + action + ') : ' + e.message, null); window.state.lots.error = 'Erreur interne (' + action + ') : ' + e.message; window.renderModal(); }
        });
};
window.actions.lotConsole = function() { window.state.lots.console = !window.state.lots.console; window.renderModal(); };
window.actions.lotDiagInconnus = function() { window.state.lots.diagInconnus = !window.state.lots.diagInconnus; window.renderModal(); };
window.actions.lotDiag = function() {
    window.lotApi('batch_diag', {}, function(d) {
        window.state.lots.diag = d;
        if (d && d.success) {
            window.lotLog('info', d.message, null);
            // Un lot local n'est enregistré qu'APRÈS qu'Anthropic a renvoyé son identifiant : il est donc
            // forcément parti. Absent de la liste = trop ancien, pas « jamais envoyé ».
            (d.inconnus_chez_anthropic || []).forEach(function(id) { window.lotLog('info', 'Lot ' + id + ' : plus dans la liste d\'Anthropic — trop ancien (résultats gardés 29 jours). Il est parti en son temps.', null); });
            (d.chez_anthropic || []).forEach(function(b) {
                var c = b.counts || {};
                window.lotLog('info', b.id + ' · ' + b.statut + ' · ' + (c.succeeded || 0) + ' réussies / ' + (c.processing || 0) + ' en cours / ' + (c.errored || 0) + ' en erreur' + (b.connu_du_site ? '' : ' · INCONNU DU SITE'), null);
            });
        }
        window.state.lots.console = true;
        window.renderModal();
    });
};
// Ménage : efface du serveur la fiche locale des lots qu'Anthropic ne liste plus. Leurs résultats ne sont de
// toute façon plus téléchargeables ; ce qui a été appliqué au planning, lui, ne bouge pas.
window.actions.lotOublierOrphelins = function() {
    var d = window.state.lots.diag, ids = (d && d.inconnus_chez_anthropic) || [];
    if (!ids.length) return;
    if (!d.fin_de_liste) { window.lotLog('erreur', "Liste d'Anthropic pas lue en entier : on ne supprime rien.", null); window.renderModal(); return; }
    confirmerPuis({
        titre: 'Oublier ' + ids.length + ' lot(s) ?',
        message: "Anthropic n'a plus trace de ces lots : leurs résultats ne sont plus téléchargeables (29 jours). Ce qui a déjà été appliqué à ton planning, tes scripts et tes fiches n'est pas touché.",
        ok: 'Les oublier', danger: true,
    }, function() {
        var reste = ids.length;
        ids.forEach(function(id) {
            window.lotApi('batch_delete', { id: id }, function() {
                if (--reste > 0) return;
                window.lotLog('ok', ids.length + ' lot(s) oublié(s).', null);
                window.actions.lotsRefresh(function() { window.actions.lotDiag(); });
            });
        });
    });
};
window.actions.lotConsoleCopier = function() {
    var txt = window.lotJournal.map(function(l) {
        return new Date(l.t).toLocaleTimeString('fr-FR') + '  [' + l.niveau + '] ' + l.texte + (l.ms ? '  (' + l.ms + ' ms)' : '');
    }).join('\n');
    if (window.state.lots.diag) txt += '\n\n--- diagnostic ---\n' + JSON.stringify(window.state.lots.diag, null, 1);
    if (navigator.clipboard) navigator.clipboard.writeText(txt).then(function() { window.undoMessage('Console copiée'); }, function() {});
};
window.actions.lotConsoleVider = function() { window.lotJournal = []; window.state.lots.diag = null; window.renderModal(); };
window.apiSnippetLot = function(t) {
    return 'Réponse serveur non valide : ' + String(t || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 200);
};
// Un item est « déjà scindé » dès qu'il a des sous-parties enregistrées : le découpage en lot ne le propose pas.
window.lotDejaScinde = function(itemId) {
    var sp = window.state.subParts[String(itemId)];
    return !!(sp && sp.length > 1);
};
// Items candidats à un lot : ceux du planning (donc ceux que l'étudiant révise vraiment), sans doublon.
window.lotItemsPlanning = function() {
    var vus = {}, out = [];
    window.state.tasks.forEach(function(t) {
        var id = String(t.baseItemId || t.itemId).replace(/_p\d+.*$/, '');
        if (vus[id]) return;
        var def = window.itemById(id);
        if (!def) return;
        vus[id] = true;
        out.push({ key: id, id: id, titre: def.titre, matiere: def.matiere });
    });
    return out.sort(function(a, b) { return (parseInt(a.id, 10) || 0) - (parseInt(b.id, 10) || 0); });
};
// Les podcasts ne se raisonnent pas par item mais par PÉRIMÈTRE : un item entier, chacune de ses sous-parties
// quand il est scindé, et son renforcement pédiatrie. Exactement les mêmes périmètres que le bouton
// « Écrire tous les scripts du jour » — un item scindé en quatre donne quatre scripts, pas un seul.
window.lotScopesPodcast = function() {
    return window.podcastScopesFor(window.state.tasks)
        // Un périmètre qui a déjà un podcast n'est plus proposé, quelle que soit la variante : script de
        // révision comme script approfondi, il est couvert, et en redemander un serait payer un doublon.
        .filter(function(sc) { return !window.podcastFor(sc.n, sc.part, sc.pedia, false) && !window.podcastFor(sc.n, sc.part, sc.pedia, true); })
        .map(function(sc) { return { key: sc.n + '|' + (sc.pedia ? '#ped' : sc.part), id: sc.n, titre: sc.itemTitle + (sc.part ? ' · ' + sc.part : '') + (sc.pedia ? ' · renforcement pédiatrie' : ''), sc: sc }; });
};
// Fiches à suivre : un podcast qui a son SCRIPT mais pas sa fiche. Rien à voir avec le planning — on part de
// l'inventaire des podcasts, puisque c'est le script qui sert de matière première.
window.lotScopesFiche = function() {
    var out = [];
    Object.keys(window.state.podcasts || {}).forEach(function(n) {
        (window.state.podcasts[n] || []).forEach(function(p) {
            if (!p.script && p.status !== 'script' && p.status !== 'ready') return;
            if (p.fiche) return; // déjà pourvue
            var def = window.itemById(n);
            out.push({ key: n + '|' + (p.slug || ''), id: String(n),
                titre: (def ? def.titre : ('Item ' + n)) + (p.part ? ' · ' + p.part : '') + (p.pedia ? ' · pédiatrie' : '') + (p.explicatif ? ' · approfondi' : ''),
                matiere: def ? def.matiere : '', pc: p });
        });
    });
    return out.sort(function(a, b) { return (parseInt(a.id, 10) || 0) - (parseInt(b.id, 10) || 0); });
};
// Renforcements pédiatrie DÉJÀ écrits : la matière première de la réécriture. On part de l'inventaire des
// podcasts et non du planning, parce que c'est lui qui dit ce qui existe et dans quelle variante (un
// renforcement peut avoir été écrit en révision ou en approfondi).
window.lotPodcastsPedia = function() {
    var out = [];
    Object.keys(window.state.podcasts || {}).forEach(function(n) {
        (window.state.podcasts[n] || []).forEach(function(p) {
            if (!p.pedia) return;
            if (!p.script && p.status !== 'script' && p.status !== 'ready') return;
            var def = window.itemById(n);
            out.push({ key: n + '|' + (p.slug || ''), id: String(n), titreItem: def ? def.titre : ('Item ' + n),
                titre: (def ? def.titre : ('Item ' + n)) + ' · renforcement pédiatrie' + (p.explicatif ? ' · approfondi' : '') + (p.fiche ? ' · avec fiche' : ''),
                matiere: def ? def.matiere : '', pc: p });
        });
    });
    return out.sort(function(a, b) { return (parseInt(a.id, 10) || 0) - (parseInt(b.id, 10) || 0); });
};
// Les flashcards se raisonnent par PÉRIMÈTRE, comme les podcasts, et non par item : un item resté scindé donne
// une série de cartes PAR SOUS-PARTIE, rangée dans le paquet de cette sous-partie — c'est ainsi qu'on le révise,
// et c'est le paquet que la carte du jour ouvre. Un item non scindé (ou regroupé) donne une seule série.
window.lotScopesFlash = function() {
    var vus = {}, out = [];
    window.state.tasks.forEach(function(t) {
        var id = String(t.baseItemId || t.itemId).replace(/_p\d+.*$/, '');
        var def = window.itemById(id); if (!def) return;
        var parts = window.state.subParts[id];
        if (parts && parts.length > 1) {
            parts.forEach(function(part) {
                var k = id + '|' + part;
                if (vus[k]) return; vus[k] = 1;
                out.push({ key: k, id: id, part: part, titre: def.titre + ' · ' + part, matiere: def.matiere });
            });
            return;
        }
        // Item entier : la clé reste le seul numéro, pour rester compatible avec les paquets déjà en file.
        if (vus[id]) return; vus[id] = 1;
        out.push({ key: id, id: id, part: '', titre: def.titre, matiere: def.matiere });
    });
    return out.sort(function(a, b) {
        return (parseInt(a.id, 10) || 0) - (parseInt(b.id, 10) || 0) || String(a.part).localeCompare(String(b.part), 'fr');
    });
};
// Cartes déjà dans le paquet de ce périmètre. La clé se construit exactement comme addAiCardsToDeck (qcm.js) :
// l'index de la sous-partie, retrouvé par son NOM, ou le numéro seul pour un item entier.
window.lotCartesPerimetre = function(it) {
    var decks = (window.state.learning && window.state.learning.decks) || {};
    var parts = window.state.subParts[it.id] || [];
    var i = it.part ? parts.indexOf(it.part) : -1;
    var d = decks[i < 0 ? String(it.id) : String(it.id) + '#' + i];
    return (d && d.cards) ? d.cards.length : 0;
};
window.lotCandidats = function(kind) {
    if (kind === 'ped_script' || kind === 'ped_fiche') return window.lotPodcastsPedia();
    if (kind === 'podcast_fiche') return window.lotScopesFiche();
    if (kind === 'podcast_script') return window.lotScopesPodcast();
    if (kind === 'regroup_script') return window.lotPodcastsRegroupes();
    if (kind === 'flashcards') return window.lotScopesFlash();
    var tous = window.lotItemsPlanning();
    if (kind === 'split') return tous.filter(function(it) { return !window.lotDejaScinde(it.id); });
    return tous;
};
// Les clés déjà engagées : celles d'un paquet qui attend son tour, et celles d'un lot parti mais pas encore
// terminé. Elles sortent de la liste pour ne pas être demandées — donc payées — deux fois, et y reviennent
// d'elles-mêmes dès que le lot est terminé, à moins d'avoir été appliquées entre-temps : dans ce cas elles ne
// sont de toute façon plus candidates (un script écrit, un item scindé ne se propose plus).
window.lotClesEngagees = function(kind) {
    var pris = {}, parId = {};
    // 1. Ce que le serveur dit encore en cours : c'est la source qui fait foi, elle vaut aussi d'un autre
    // appareil et survit à un vidage du stockage local.
    (window.state.lots.list || []).forEach(function(b) {
        parId[b.id] = b;
        if ((b.ckind || b.kind) !== kind || b.status === 'ended') return;
        (b.keys || []).forEach(function(c) { pris[c] = true; });
    });
    // 2. Ce que la file locale sait : les paquets qui attendent leur tour, et ceux qui viennent de partir
    // (le temps que la liste des lots arrive). Un lot absent de la liste une fois celle-ci chargée a été
    // supprimé : ses items reviennent, ils ne restent pas cachés pour toujours.
    var f = window.fileLire();
    if (f) f.paquets.forEach(function(p) {
        if (p.kind !== kind) return;
        if (p.id) {
            var b = parId[p.id];
            if (b ? b.status === 'ended' : window.state.lots.listeChargee) return;
        }
        (p.cles || []).forEach(function(c) { pris[c] = true; });
    });
    return pris;
};
// Ce que l'écran propose de cocher : les candidats, moins ce qui est déjà engagé.
// La file, elle, résout ses clés sur lotCandidats, sans ce filtre.
window.lotAProposer = function(kind) {
    var pris = window.lotClesEngagees(kind);
    return window.lotCandidats(kind).filter(function(it) { return !pris[it.key]; });
};
window.actions.openLots = function(onglet) {
    var L = window.state.lots;
    L.open = true; L.detail = null; L.error = '';
    if (typeof onglet === 'string' && onglet) L.onglet = onglet;   // sans argument (rail, feuille) : dernier onglet ouvert
    L.choix = {}; L.filtre = '';
    window.renderModal();
    window.actions.lotsRefresh(function() { window.actions.retrouverDecoupagesLot(); });
    window.lotsSurveille();
};
window.actions.closeLots = function() {
    window.state.lots.open = null; window.state.lots.detail = null;
    clearInterval(window.__lotsTimer); window.__lotsTimer = null;
    window.renderModal();
};
// Tant que l'écran est ouvert, on redemande l'état des lots en cours toutes les 30 s : la file avance seule,
// et un lot terminé se signale sans qu'on ait à cliquer sur « Actualiser ».
window.lotsSurveille = function() {
    clearInterval(window.__lotsTimer);
    window.__lotsTimer = setInterval(function() {
        var L = window.state.lots;
        if (!L.open) { clearInterval(window.__lotsTimer); window.__lotsTimer = null; return; }
        if (L.busy || L.detail) return;
        if (window.fileEnAttente().length) { window.filePoussee(); return; }
        var enCours = (L.list || []).filter(function(b) { return b.status === 'in_progress' || b.status === 'canceling'; });
        if (enCours.length) window.actions.lotStatus(enCours[0].id);
    }, 30000);
};
window.actions.lotOnglet = function(k) {
    window.state.lots.devis = null;
    window.state.lots.onglet = k; window.state.lots.choix = {}; window.state.lots.filtre = ''; window.renderModal();
    if (k === 'split') window.actions.retrouverDecoupagesLot();
};
// On coche par RANG dans la liste affichée, pas par clé : une clé de périmètre contient le nom de la
// sous-partie, donc des apostrophes et des accents qui ne passent pas dans un attribut onclick.
// Filtre de la liste. Sur un onglet qui propose des centaines d'éléments, « choisir ceux-là et pas les
// autres » suppose d'abord de pouvoir les retrouver. Le filtre ne touche QUE l'affichage : ce qui est coché
// le reste quand le filtre change ou se vide, et part à l'envoi même si ce n'est plus à l'écran.
window.lotListeAffichee = function(kind) {
    var f = (window.state.lots.filtre || '').trim().toLowerCase(), cands = window.lotAProposer(kind);
    // Onglet Flashcards : ne garder que les périmètres dont le paquet est encore maigre — c'est là que des
    // cartes en lot servent à quelque chose, un paquet déjà fourni n'a pas besoin d'être repayé.
    var seuil = window.state.lots.seuilCartes;
    if (kind === 'flashcards' && seuil) cands = cands.filter(function(it) { return window.lotCartesPerimetre(it) < seuil; });
    if (!f) return cands;
    var mots = f.split(/\s+/);
    return cands.filter(function(it) {
        var t = ('#' + it.id + ' ' + (it.titre || '') + ' ' + (it.matiere || '')).toLowerCase();
        return mots.every(function(m) { return t.indexOf(m) !== -1; });
    });
};
// Saisie du filtre : on ne redessine que la liste, sinon le champ serait recréé à chaque lettre et perdrait
// le curseur.
window.actions.lotSetFiltre = function(v) {
    window.state.lots.filtre = v;
    var c = document.getElementById('lot-liste');
    if (c) c.innerHTML = window.lotListeHtml(window.state.lots.onglet);
    var n = document.getElementById('lot-compteur');
    if (n) n.innerHTML = window.lotCompteurHtml(window.state.lots.onglet);
};
window.actions.lotToggle = function(rang) {
    window.state.lots.devis = null;
    var L = window.state.lots, it = window.lotListeAffichee(L.onglet)[rang];
    if (!it) return;
    if (L.choix[it.key]) delete L.choix[it.key]; else L.choix[it.key] = true;
    window.renderModal();
};
// Coche ou décoche ce qui est AFFICHÉ. Avec un filtre, c'est la façon de sélectionner un lot d'items d'un
// coup (« cardio », tout cocher) sans perdre ce qu'on avait coché ailleurs.
window.actions.lotToggleAll = function() {
    window.state.lots.devis = null;
    var L = window.state.lots, vus = window.lotListeAffichee(L.onglet);
    var tout = vus.length && vus.every(function(it) { return L.choix[it.key]; });
    vus.forEach(function(it) { if (tout) delete L.choix[it.key]; else L.choix[it.key] = true; });
    window.renderModal();
};
// Cocher d'un coup les N suivants, sans jamais rien décocher : sur un onglet qui propose 1 800 périmètres,
// « Tout cocher » dépasse largement la file (15 paquets) et cocher un par un est intenable. Deux clics = 200.
window.actions.lotCocherN = function(n) {
    window.state.lots.devis = null;
    var L = window.state.lots, reste = Math.max(0, parseInt(n, 10) || 0);
    window.lotListeAffichee(L.onglet).forEach(function(it) {
        if (reste <= 0 || L.choix[it.key]) return;
        L.choix[it.key] = true; reste--;
    });
    window.renderModal();
};
window.actions.lotSetParts = function(v) { window.state.lots.parts = parseInt(v, 10) || 0; };
window.actions.lotSetNb = function(v) { window.state.lots.nb = Math.max(1, Math.min(40, parseInt(v, 10) || 15)); };
// La case ne change plus la liste (un périmètre pourvu est écarté dans les deux variantes) : les cases cochées
// sont donc conservées, elle ne décide plus que de la nature des scripts demandés.
window.actions.lotSetExplicatif = function(v) { window.state.lots.explicatif = !!v; window.renderModal(); };
// Ordre des matières du deuxième planning d'après une configuration (intégrée ou sauvegardée), sans toucher au
// premier : seul l'ordre est repris ; les matières cochées du planning 2 restent celles choisies.
window.actions.appliquerOrdrePreset2 = function(id) {
    if (!id) return;
    var preset = window.loadAutoPlanPresetsLocal().find(function(p) { return p.id === id; });
    var ordre = preset && preset.config ? (preset.config.orderedSpecialties || []) : [];
    if (!ordre.length) return;
    var connues = window.allSpecialties || [];
    var propre = ordre.filter(function(m, i, a) { return connues.indexOf(m) !== -1 && a.indexOf(m) === i; });
    window.state.orderedSpecialties2 = propre.concat(connues.filter(function(m) { return propre.indexOf(m) === -1; }));
    window.state.presetOrdre2Id = id;
    window.renderModal();
};
// Depuis la carte d'un item regroupé ou l'ordonnanceur : l'écran des lots, onglet « Regroupés », l'item déjà coché.
window.actions.proposerScriptComplet = function(n) {
    window.actions.openLots('regroup_script');
    var L = window.state.lots; L.filtre = '';
    if (n) { L.choix[String(n) + '|fusion'] = true; window.renderModal(); }
};
window.actions.lotsRefresh = function(apres) {
    // Appelée aussi par data-action="lotsRefresh" (src/ui/modals/lots.js) : le répartiteur de src/core/actions.js
    // ajoute l'élément et l'évènement aux arguments, donc `apres` reçoit alors un nœud DOM. On ne garde que
    // les vraies fonctions — sinon `apres()` levait et window.filePoussee() n'était jamais atteint.
    var suite = typeof apres === 'function' ? apres : null;
    window.lotApi('batch_list', {}, function(d) {
        // listeChargee : tant qu'on n'a jamais eu la liste, un lot inconnu est peut-être en cours — on
        // masque ses items. Une fois la liste connue, un lot absent est un lot supprimé : ses items reviennent.
        if (d && d.success) { window.state.lots.list = d.batches || []; window.state.lots.listeChargee = true; }
        else window.state.lots.error = (d && d.message) || '';
        window.fileNettoie();
        window.renderModal(); window.renderHeader();
        if (!window.state.lots.open) window.renderContent(); // bandeau « Découpages prêts » du tableau de bord
        if (suite) suite();
        window.filePoussee(); // le paquet suivant part dès que le lot précédent est terminé
    });
};
// Plus rien en attente et tous les paquets terminés : la file a fini son travail, elle s'efface.
window.fileNettoie = function() {
    var e = window.filePaquets();
    if (e && e.paquets.every(function(p) { return p.etat === 'ended' || p.etat === 'oublié'; })) window.fileEcrire(null);
};
// Envoi d'un lot : on rassemble pour chaque item exactement ce que le bouton unitaire enverrait.
// Charge utile d'un périmètre / item, identique à ce que le bouton unitaire enverrait.
window.lotPayload = function(kind, it, structure, L) {
    var planInfo = window.buildFichePlanText(it.id, structure);
    if (kind === 'podcast_script') {
        // Même charge utile que « Écrire tous les scripts du jour » : la sous-partie, ses sections du plan
        // (le périmètre exact du script), et le plan entier seulement pour un item non scindé.
        var sc = it.sc, sections = [];
        if (sc.part && !sc.pedia) { var map = window.state.subPartSections[String(sc.n)]; if (map && map[sc.part]) sections = map[sc.part]; }
        return { key: it.key, itemNumber: sc.n, itemTitle: sc.itemTitle, label: sc.label,
            subPartTitle: sc.pedia ? '' : sc.part, pedia: !!sc.pedia, explicatif: !!L.explicatif,
            matieres: sc.matieres || [], sections: sections, plan: (sc.part && !sc.pedia) ? '' : planInfo.plan };
    }
    if (kind === 'ped_script') {
        // Un renforcement pédiatrie porte toujours sur l'item entier (pas de sous-partie) ; on garde la
        // variante du script existant pour réécrire celui-là, et pas fabriquer un doublon dans l'autre.
        return { key: it.key, itemNumber: it.id, itemTitle: it.titreItem, label: '#' + it.id + ' ' + it.titreItem + ' · pédiatrie',
            subPartTitle: '', pedia: true, explicatif: !!it.pc.explicatif,
            matieres: [it.matiere], sections: [], plan: planInfo.plan, force: true };
    }
    if (kind === 'regroup_script') {
        // Script complet de l'item entier : le plan de la fiche pour l'ordre, et « fusion » = ses sous-parties
        // d'origine, dont le serveur relit les scripts existants.
        var def = window.itemById(it.id), mats = def ? [def.matiere].concat(def.collegesSecondaires || []).filter(Boolean) : [it.matiere];
        return { key: it.key, itemNumber: it.id, itemTitle: it.titreItem, label: '#' + it.id + ' ' + it.titreItem + ' · script complet (fusion de ' + it.avec.length + ' sous-partie' + (it.avec.length > 1 ? 's' : '') + ')',
            subPartTitle: '', pedia: false, explicatif: !!L.explicatif, matieres: mats, sections: [], plan: planInfo.plan, fusion: it.parts };
    }
    if (kind === 'ped_fiche') {
        return { key: it.key, itemNumber: it.id, itemTitle: it.titreItem, label: '#' + it.id + ' ' + it.titreItem + ' · fiche pédiatrie',
            subPartTitle: '', pedia: true, explicatif: !!it.pc.explicatif, force: true };
    }
    if (kind === 'podcast_fiche') {
        var p = it.pc;
        return { key: it.key, itemNumber: it.id, itemTitle: it.titre, label: '#' + it.id + ' ' + it.titre,
            subPartTitle: p.part || '', pedia: !!p.pedia, explicatif: !!p.explicatif };
    }
    var base = { key: it.key, itemNumber: it.id, itemTitle: it.titre, label: '#' + it.id + ' ' + it.titre, matieres: [it.matiere], plan: planInfo.plan, totalWords: planInfo.words };
    if (kind === 'split') base.parts = L.parts;
    else if (kind === 'flashcards') {
        base.count = L.nb;
        // Le périmètre exact : pour une sous-partie, ses sections du plan et non le plan entier — sinon l'IA
        // rédige des cartes sur tout l'item et les range dans le paquet de la sous-partie.
        var part = it.part || '';
        var sections = [];
        if (part) { var map = window.state.subPartSections[String(it.id)]; if (map && map[part]) sections = map[part]; }
        base.subPartTitle = part;
        base.itemTitle = window.itemById(it.id) ? window.itemById(it.id).titre : it.titre;
        base.outline = part ? (sections.length ? sections.join('\n') : part) : planInfo.plan;
        // Ce que l'étudiant a déjà sur CE périmètre : sans cette liste, chaque lot refabrique les mêmes cartes.
        if (window.cartesDejaVues) {
            var parts = window.state.subParts[String(it.id)] || [];
            var vues = window.cartesDejaVues(it.id, part ? parts.indexOf(part) : null);
            base.existing = (vues.rectos || []).slice(0, 60);
            base.coveredNotions = (vues.notions || []).slice(0, 120);
        }
    }
    else base.count = L.nb;
    return base;
};

// --- FILE D'ATTENTE ----------------------------------------------------------------------------------------
// Un lot part par paquets de 100 requêtes au plus : au-delà, l'envoi lui-même devient long (chaque requête
// embarque la fiche EDN en PDF) et un échec ferait tout recommencer. Le reste attend son tour et part
// automatiquement dès que le lot précédent est terminé. La file ne garde que les CLÉS des périmètres : la
// charge utile est refabriquée au moment de l'envoi, à partir de l'état du site.
// Taille d'un paquet. Elle n'est pas limitée par l'API (256 Mo, 100 000 requêtes) mais par ce que le SERVEUR
// peut construire avant d'être coupé : une requête de script embarque la fiche EDN en PDF et jusqu'à 160 000
// caractères de collège, soit plusieurs mégaoctets à lire et encoder. En demander 100 d'un coup faisait
// dépasser la limite du serveur web (« Request Timeout »). Le serveur borne de son côté et renvoie ce qui
// n'a pas tenu ; ces valeurs évitent simplement de l'y pousser à chaque fois.
var LOT_TAILLES = { podcast_script: 15, podcast_fiche: 100, flashcards: 40, qcm_pedia: 40, split: 100, ped_script: 15, ped_fiche: 100 };
var LOT_TAILLE = 100;
window.lotTaille = function(kind) { return LOT_TAILLES[kind] || LOT_TAILLE; };
// La file mélange les types : on peut mettre à la suite des scripts, des fiches, des découpages… Elle est
// une simple SUITE DE PAQUETS, chacun avec son type et ses réglages. Un paquet qui porte un identifiant de lot
// est parti ; les autres attendent leur tour. Un seul paquet part à la fois : chaque envoi est lourd à
// construire côté serveur, les empiler ne ferait que rapprocher la coupure.
var FILE_KEY = 'edn_lots_file_v2';
var FILE_MAX_ATTENTE = 15; // paquets en attente au maximum
window.fileMaxAttente = function() { return FILE_MAX_ATTENTE; };
window.fileLire = function() {
    try {
        var f = JSON.parse(localStorage.getItem(FILE_KEY) || 'null');
        return (f && Array.isArray(f.paquets) && f.paquets.length) ? f : null;
    } catch (e) { return null; }
};
window.fileEcrire = function(f) {
    if (!f || !f.paquets.length) { try { localStorage.removeItem(FILE_KEY); } catch (e) {} return null; }
    window.storageSet(FILE_KEY, JSON.stringify(f));
    return f;
};
window.fileAjouter = function(paquets) {
    var f = window.fileLire() || { v: 2, paquets: [] };
    f.paquets = f.paquets.concat(paquets);
    return window.fileEcrire(f);
};
window.fileEnAttente = function() {
    var f = window.fileLire();
    return f ? f.paquets.filter(function(p) { return !p.id; }) : [];
};
// État de chaque paquet, lu sur la liste des lots : c'est ce que la barre affiche.
window.filePaquets = function() {
    var f = window.fileLire();
    if (!f) return null;
    var parId = {};
    (window.state.lots.list || []).forEach(function(b) { parId[b.id] = b; });
    var paquets = f.paquets.map(function(p, i) {
        var b = p.id ? parId[p.id] : null;
        return { rang: i + 1, kind: p.kind, n: p.n || (p.cles || []).length, id: p.id || null,
            etat: p.id ? (b ? b.status : 'oublié') : 'attente',
            fait: b ? b.done : 0, ok: b ? b.ok : 0, applique: b ? b.applied : 0 };
    });
    var total = paquets.reduce(function(n, p) { return n + p.n; }, 0);
    var kinds = {}; paquets.forEach(function(p) { kinds[p.kind] = (kinds[p.kind] || 0) + p.n; });
    return { paquets: paquets, total: total, kinds: kinds,
        attente: paquets.filter(function(p) { return p.etat === 'attente'; }).length,
        termines: paquets.filter(function(p) { return p.etat === 'ended'; }).reduce(function(n, p) { return n + p.n; }, 0) };
};
window.actions.fileVider = function() {
    var n = window.fileEnAttente().length;
    if (!n) return;
    confirmerPuis({
        titre: 'Vider l\'attente ?',
        message: 'Les ' + n + " paquet(s) qui n'ont pas encore été envoyés sont retirés. Ceux qui sont déjà partis continuent.",
        ok: 'Vider l\'attente', danger: true,
    }, function() {
        var f = window.fileLire();
        if (f) { f.paquets = f.paquets.filter(function(p) { return !!p.id; }); window.fileEcrire(f); }
        window.renderModal(); window.renderContent();
        if (window.toast) window.toast(n + ' paquet' + (n > 1 ? 's retirés' : ' retiré') + ' de la file', { icone: 'check' });
    });
};
window.actions.fileRetirer = function(rang) {
    var f = window.fileLire(); if (!f) return;
    var p = f.paquets[rang - 1];
    if (!p || p.id) return; // un paquet déjà parti ne se retire pas
    f.paquets.splice(rang - 1, 1);
    window.fileEcrire(f); window.renderModal(); window.renderContent();
};
// Envoie un paquet : résout les clés en charge utile, poste, et rend la main.
// Un envoi ne doit pas devenir énorme : au-delà, le serveur met trop longtemps à le construire et se fait
// couper. On ne REFUSE pas le paquet pour autant — ce serait le perdre : on n'envoie que ce qui tient et on
// rend le reste comme « différé », que la file remet aussitôt derrière. C'est le mécanisme que le serveur
// utilise déjà quand il s'arrête en cours de construction.
window.ENVOI_MAX_OCTETS = 1000000;
window.lotEnvoyerPaquet = function(kind, cles, opts, cb) {
    window.loadFicheStructure(function(structure) {
        var parCle = {};
        window.lotCandidats(kind).forEach(function(it) { parCle[it.key] = it; });
        var tous = cles.map(function(c) { return parCle[c]; }).filter(Boolean).map(function(it) { return window.lotPayload(kind, it, structure, opts); });
        if (!tous.length) { cb({ success: false, message: 'Plus rien à envoyer pour ce paquet (déjà fait entre-temps ?).' }); return; }
        var items = [], reportes = [], poids = 0;
        tous.forEach(function(it) {
            var t = JSON.stringify(it).length + 1;
            if (items.length && (poids + t > window.ENVOI_MAX_OCTETS || reportes.length)) { reportes.push(it); return; }
            items.push(it); poids += t;
        });
        if (reportes.length) window.lotLog('info', 'Paquet coupé pour l\'envoi : ' + items.length + ' maintenant, ' + reportes.length + ' juste après (' + Math.round(poids / 1024) + ' Ko).', null);
        window.lotApi('batch_create', { kind: window.lotKindServeur(kind), client_kind: kind, items: items,
            label: window.LOT_KINDS[kind].titre + ' · ' + items.length + ' items' }, function(d) {
            // Ce qui n'a pas été envoyé rejoint ce que le serveur a lui-même différé : la file les reprend.
            if (reportes.length && d && d.success) {
                d.differes = (d.differes || []).concat(reportes.map(function(it) { return it.key; }));
            }
            cb(d);
        });
    });
};
// Envoie le paquet en attente le plus ancien, quel que soit son type. On n'attend PAS qu'un lot déjà parti
// soit terminé : un lot peut mettre jusqu'à 24 h, et Anthropic les traite en parallèle. Ce qu'il ne faut pas
// faire, c'est CONSTRUIRE deux envois à la fois (c'est lourd pour le serveur) — d'où le seul verrou : busy.
window.__lastFilePush = 0;
window.filePoussee = function() {
    var now = Date.now(), depuis = now - window.__lastFilePush;
    // Anti-spam : au moins 1 s entre deux envois. On REPORTE, on n'abandonne pas — un appel simplement
    // ignoré laissait le paquet en file jusqu'au prochain sondage (30 s), voire indéfiniment si l'écran des
    // lots était fermé : on croyait que la file s'était arrêtée toute seule.
    if (depuis < 1000) {
        clearTimeout(window.__filePushTimer);
        window.__filePushTimer = setTimeout(window.filePoussee, 1000 - depuis);
        return;
    }
    var f = window.fileLire();
    if (!f || window.state.lots.busy) return;
    var rang = -1;
    for (var i = 0; i < f.paquets.length; i++) if (!f.paquets[i].id) { rang = i; break; }
    if (rang < 0) return;
    var p = f.paquets[rang], L = window.state.lots;
    L.busy = true; window.__lastFilePush = Date.now(); window.renderModal();
    window.lotEnvoyerPaquet(p.kind, p.cles, p.opts || {}, function(d) {
        L.busy = false;
        var f2 = window.fileLire();
        if (f2 && f2.paquets[rang] && !f2.paquets[rang].id) {
            if (d && d.success && d.batch) {
                // On garde les clés après l'envoi : elles disent ce qui est en cours de traitement, donc ce
                // que l'écran doit retirer de la sélection tant que le lot tourne.
                f2.paquets[rang] = { kind: p.kind, opts: p.opts, cles: p.cles, id: d.batch.id, n: d.batch.total, t: Date.now() };
                // Le serveur s'arrête quand la construction devient trop lourde : ce qu'il a différé forme un
                // nouveau paquet, glissé juste après. Rien n'est perdu.
                if ((d.differes || []).length) f2.paquets.splice(rang + 1, 0, { kind: p.kind, opts: p.opts, cles: d.differes, n: d.differes.length, t: Date.now() });
            } else {
                f2.paquets.splice(rang, 1); // envoi refusé : on ne boucle pas dessus indéfiniment
            }
            window.fileEcrire(f2);
        }
        if (!d || !d.success) L.error = (d && d.message) || "Échec de l'envoi du paquet suivant";
        else L.ignores = d.skipped || [];
        window.actions.lotsRefresh();
        // Enchaîner : le paquet suivant part dès que celui-ci est CONSTRUIT, sans attendre qu'il soit traité.
        // Une courte pause laisse respirer le serveur et l'interface.
        if (window.fileEnAttente().length) setTimeout(window.filePoussee, 1500);
    });
};

// Devis avant dépense : on fait compter par l'API les jetons d'entrée de quelques VRAIES requêtes du lot
// (l'endpoint count_tokens est gratuit, rien n'est envoyé au modèle), et on multiplie. La longueur de sortie
// vient de ce qui a déjà été produit, quand il y en a.
window.actions.lotEstimer = function() {
    var L = window.state.lots;
    if (L.busy) return;
    var kind = L.onglet;
    var choisis = window.lotAProposer(kind).filter(function(it) { return L.choix[it.key]; });
    if (!choisis.length) { L.error = 'Coche au moins un élément à estimer.'; window.renderModal(); return; }
    L.busy = true; L.error = ''; L.devis = null; window.renderModal();
    window.loadFicheStructure(function(structure) {
        // Échantillon réparti sur toute la sélection : les items ne se valent pas (un collège gros ou maigre
        // change le résultat du simple au double), prendre les premiers fausserait le devis.
        var pas = Math.max(1, Math.floor(choisis.length / 5)), ech = [];
        for (var i = 0; i < choisis.length && ech.length < 5; i += pas) ech.push(choisis[i]);
        // Combien de requêtes partagent en moyenne un même préambule (fiche + collège) : décide du cache.
        var parPreambule = {};
        choisis.forEach(function(it) {
            var cle = it.id + '|' + (kind === 'podcast_script' ? ((L.explicatif ? 'x' : 'r') + '|' + ((it.sc && it.sc.pedia) ? 'p' : '')) : '');
            parPreambule[cle] = (parPreambule[cle] || 0) + 1;
        });
        var cles = Object.keys(parPreambule);
        var partages = cles.length ? Math.round(choisis.length / cles.length) : 1;
        var items = ech.map(function(it) { return window.lotPayload(kind, it, structure, L); });
        window.lotApi('batch_estimate', { kind: window.lotKindServeur(kind), items: items, total: choisis.length, partages: partages }, function(d) {
            L.busy = false;
            if (!d || !d.success) { L.error = (d && d.message) || "Devis impossible"; window.renderModal(); return; }
            L.devis = d;
            window.renderModal();
        });
    });
};
window.actions.lotFermerDevis = function() { window.state.lots.devis = null; window.renderModal(); };

window.actions.lotSend = function() {
    var L = window.state.lots;
    if (L.busy) return;
    var kind = L.onglet;
    var choisis = window.lotAProposer(kind).filter(function(it) { return L.choix[it.key]; });
    if (!choisis.length) { L.error = 'Coche au moins un ' + window.lotUnite(kind) + '.'; window.renderModal(); return; }
    window.lotMettreEnFile(kind, choisis, { parts: L.parts, nb: L.nb, explicatif: L.explicatif });
};
// Découpe une sélection en paquets et les empile dans la file. Séparé de lotSend parce que d'autres boutons
// envoient une sélection qu'ils constituent eux-mêmes (l'encart des fiches pédiatrie, par exemple).
window.lotMettreEnFile = function(kind, choisis, opts) {
    var L = window.state.lots;
    var taille = window.lotTaille(kind);
    var paquets = [];
    for (var i = 0; i < choisis.length; i += taille) {
        var cles = choisis.slice(i, i + taille).map(function(it) { return it.key; });
        paquets.push({ kind: kind, opts: opts, cles: cles, n: cles.length, t: Date.now() });
    }
    // Plafond de la file : au-delà, on n'accepte que ce qui tient, et on le dit plutôt que d'oublier en silence.
    var place = window.fileMaxAttente() - window.fileEnAttente().length;
    var refuses = 0;
    if (paquets.length > place) {
        if (place <= 0) { L.error = 'File pleine (' + window.fileMaxAttente() + ' paquets en attente). Attends que des paquets partent, ou retires-en.'; window.renderModal(); return; }
        refuses = paquets.length - place;
        var tenus = paquets.slice(0, place);
        confirmerPuis({
            titre: 'File presque pleine',
            message: 'La file ne peut accepter que ' + place + ' paquet(s) de plus sur les ' + paquets.length + ' que fait ta sélection. Envoyer ces ' + place + ' paquets et laisser le reste de côté ?',
            ok: 'Envoyer ces ' + place,
        }, function() { filePoser(tenus, refuses); });
        return;
    }
    filePoser(paquets, refuses);
};
// Mise en file proprement dite : appelée tout de suite, ou après la confirmation quand la file déborde.
function filePoser(paquets, refuses) {
    var L = window.state.lots;
    L.error = refuses ? (refuses + ' paquet(s) non mis en file : plafond de ' + window.fileMaxAttente() + ' atteint.') : '';
    L.choix = {}; L.devis = null;
    window.fileAjouter(paquets);
    window.renderModal();
    window.filePoussee(); // part tout de suite si rien d'autre ne tourne
}
// Encart « Réécrire les fiches » : pas de sélection à cocher, on reprend tous les renforcements pédiatrie qui
// ont un script. La fiche est réécrite À PARTIR DU SCRIPT ENREGISTRÉ : à faire APRÈS avoir appliqué les
// nouveaux scripts, sinon elle serait refaite depuis l'ancien.
// Bouton « Réécrire les scripts pédiatrie » : tout l'écran d'un clic, sans rien cocher. La liste reste là pour
// n'en reprendre qu'une partie ; ce bouton, lui, est le geste courant — on veut les refaire tous.
// Ce que les deux boutons de la page reprennent : les renforcements COCHÉS, ou tout l'écran si rien n'est
// coché. Les deux listes portent les mêmes clés (un renforcement = un podcast), donc une sélection faite
// pour les scripts vaut aussi pour leurs fiches.
window.pedChoisis = function(kind) {
    var L = window.state.lots, tous = window.lotAProposer(kind);
    var coches = tous.filter(function(it) { return L.choix[it.key]; });
    return coches.length ? coches : tous;
};
window.actions.pedScriptsRedo = function() {
    var L = window.state.lots, cands = window.pedChoisis('ped_script');
    if (!cands.length) { L.error = "Aucun renforcement pédiatrie écrit : il n'y a rien à réécrire."; window.renderModal(); return; }
    var t = window.lotTaille('ped_script'), np = Math.ceil(cands.length / t);
    confirmerPuis({
        titre: 'Réécrire ' + cands.length + ' script(s) pédiatrie ?',
        message: "Ils seront remplacés, avec la règle pédiatrie renforcée : collège de pédiatrie seul, rien de ce qui ne change pas chez l'enfant.\n\nAppliquer un nouveau script efface l'audio et la fiche de l'ancien : il faudra les refaire.\n\n" + np + ' paquet(s) en file, à moitié prix.',
        ok: 'Réécrire', danger: true,
    }, function() {
        window.lotMettreEnFile('ped_script', cands, { parts: L.parts, nb: L.nb, explicatif: L.explicatif });
    });
};
window.actions.pedFichesRedo = function() {
    var L = window.state.lots, cands = window.pedChoisis('ped_fiche');
    if (!cands.length) { L.error = "Aucun renforcement pédiatrie avec un script : rien à mettre en fiche."; window.renderModal(); return; }
    var avecFiche = cands.filter(function(it) { return it.pc.fiche; }).length;
    confirmerPuis({
        titre: 'Réécrire ' + cands.length + ' fiche(s) pédiatrie ?',
        message: (avecFiche ? avecFiche + " ont déjà une fiche : elle sera remplacée.\n\n" : '')
            + "La fiche est rédigée à partir du script actuellement enregistré. Si tu viens de réécrire les scripts, applique-les d'abord.",
        ok: 'Réécrire', danger: true,
    }, function() { window.lotMettreEnFile('ped_fiche', cands, {}); });
};
window.actions.lotStatus = function(id) {
    window.lotApi('batch_status', { id: id }, function(d) {
        if (d && d.success) {
            window.state.lots.list = window.state.lots.list.map(function(b) { return b.id === id ? d.batch : b; });
            window.fileNettoie(); // un lot terminé peut être le dernier de la file : elle s'efface alors
            if (window.state.lots.detail && window.state.lots.detail.batch.id === id && d.batch.status === 'ended') { window.actions.lotOpen(id); return; }
        }
        window.renderModal(); window.renderHeader();
    });
};
window.actions.lotOpen = function(id) {
    window.lotApi('batch_get', { id: id }, function(d) {
        if (d && d.success) window.state.lots.detail = d;
        else window.state.lots.error = (d && d.message) || 'Lot illisible';
        window.renderModal();
    });
};
window.actions.lotBack = function() { window.state.lots.detail = null; window.renderModal(); };
window.actions.lotCancel = function(id) {
    confirmerPuis({
        titre: 'Annuler ce lot ?',
        message: 'Les requêtes déjà traitées restent facturées et récupérables ; le reste ne sera ni traité ni facturé.',
        ok: 'Annuler le lot', annuler: 'Le laisser tourner', danger: true,
    }, function() { window.lotApi('batch_cancel', { id: id }, function() { window.actions.lotsRefresh(); }); });
};
// ARRÊT D'URGENCE. Vide la file d'attente locale (rien de plus ne partira) puis demande l'annulation de TOUS
// les lots encore en cours chez Anthropic. À utiliser quand des lots partent en boucle ou que la dépense
// dérape : c'est le seul geste qui coupe l'envoi et le traitement d'un coup.
window.actions.lotToutAnnuler = function() {
    var L = window.state.lots;
    var enCours = (L.list || []).filter(function(b) { return b.status === 'in_progress'; });
    var enFile = window.fileEnAttente().length;
    if (!enCours.length && !enFile) { L.error = "Rien à annuler : aucun lot en cours et aucun paquet en attente."; window.renderModal(); return; }
    confirmerPuis({
        titre: 'Tout annuler ?',
        message: (enFile ? '· ' + enFile + " paquet(s) en attente : retirés, ils ne partiront pas.\n" : '')
            + (enCours.length ? '· ' + enCours.length + " lot(s) en cours : annulation demandée à Anthropic.\n" : '')
            + "\nCe qui a déjà été traité reste facturé et récupérable ; le reste ne sera ni traité ni facturé.",
        ok: 'Tout annuler', annuler: 'Laisser tourner', danger: true,
    }, function() { toutAnnuler(enCours, enFile); });
};
function toutAnnuler(enCours, enFile) {
    var L = window.state.lots;
    // La file d'abord : inutile d'annuler des lots si un paquet repart dans la seconde.
    var f = window.fileLire();
    if (f) { f.paquets = f.paquets.filter(function(p) { return !!p.id; }); window.fileEcrire(f); }
    L.error = ''; L.busy = true; window.renderModal();
    // Puis la liste FRAÎCHE du serveur, pas celle affichée : un paquet de la file parti il y a une seconde est un lot
    // en cours que la page n'a pas encore vu — il doit être annulé lui aussi, sinon il continue à tourner (et à coûter).
    var annuler = function(liste) {
        var cibles = (liste || []).filter(function(b) { return b.status === 'in_progress'; });
        if (!cibles.length) { L.busy = false; window.lotLog('ok', enFile + ' paquet(s) retiré(s) de la file, aucun lot en cours à annuler.', null); window.actions.lotsRefresh(); return; }
        var reste = cibles.length;
        cibles.forEach(function(b) {
            window.lotApi('batch_cancel', { id: b.id }, function() {
                if (--reste > 0) return;
                L.busy = false;
                window.lotLog('ok', 'Tout annuler : ' + cibles.length + ' lot(s) annulé(s), ' + enFile + ' paquet(s) retiré(s) de la file.', null);
                window.actions.lotsRefresh();
            });
        });
    };
    window.lotApi('batch_list', {}, function(d) { annuler((d && d.success && Array.isArray(d.batches)) ? d.batches : L.list); });
}
window.actions.lotForget = function(id) {
    confirmerPuis({
        titre: 'Oublier ce lot ?',
        message: 'Ses résultats non appliqués seront perdus.',
        ok: 'Oublier', danger: true,
    }, function() {
        window.lotApi('batch_delete', { id: id }, function() { window.state.lots.detail = null; window.actions.lotsRefresh(); });
    });
};
// Application d'un résultat. Le découpage et les flashcards touchent aux données du site : le serveur rend le
// contenu et c'est ici qu'on l'applique, en passant par window.planningAction pour rester annulable.
// Le type du lot est passé en argument, jamais relu dans window.state.lots.detail : appliquer 50 résultats
// prend plusieurs dizaines de secondes, pendant lesquelles rien n'interdit de revenir à la liste des lots ou
// de fermer la fenêtre — l'application doit aller au bout quoi qu'il arrive à l'écran.
window.lotAppliqueUn = function(kind, it, d, tachesEnCours) {
    if (kind === 'split') {
        var noms = (d.data.parts || []).map(function(pt) { return pt.name; });
        if (noms.length < 2) return tachesEnCours; // « une seule partie » = ne pas scinder
        var itemId = String(it.info.itemNumber);
        window.state.subParts[itemId] = noms;
        var map = {}; (d.data.parts || []).forEach(function(pt) { if (pt.sections && pt.sections.length) map[pt.name] = pt.sections; });
        window.state.subPartSections[itemId] = map;
        window.storageSet('edn_subpart_sections', JSON.stringify(window.state.subPartSections));
        // Origine du découpage : seuls ceux venus d'un lot sont visés par « Annuler les découpages en lot ».
        window.state.splitLots[itemId] = Date.now();
        window.storageSet('edn_split_lots', JSON.stringify(window.state.splitLots));
        window.rememberSplitProposal(itemId, { t: Date.now(), wanted: 0, source: 'lot', parts: d.data.parts });
        return window.splitRebuildTasks(tachesEnCours, itemId, noms);
    }
    if (kind === 'flashcards' && window.addAiCardsToDeck) window.addAiCardsToDeck(it.info.itemNumber, d.data.cards || [], it.info.subPartTitle || '', !!it.info.pedia);
    return tachesEnCours;
};
// Remet un seul élément en file, dans un paquet à lui : utile quand sa réponse est revenue coupée ou en erreur.
window.actions.lotRefaire = function(cid) {
    var D = window.state.lots.detail; if (!D) return;
    var it = (D.items || []).find(function(x) { return x.cid === cid; }); if (!it) return;
    var cle = it.info.key || String(it.info.itemNumber);
    if (window.fileEnAttente().length >= window.fileMaxAttente()) { window.state.lots.error = 'File pleine : retire un paquet avant.'; window.renderModal(); return; }
    window.fileAjouter([{ kind: D.batch.ckind || D.batch.kind, opts: {}, cles: [cle], n: 1, t: Date.now() }]);
    window.undoMessage('Remis en file : ' + (it.info.label || cle));
    window.renderModal();
    window.filePoussee();
};
window.actions.lotApply = function(cid, remplacer) {
    var D = window.state.lots.detail; if (!D) return;
    var it = (D.items || []).find(function(x) { return x.cid === cid; }); if (!it) return;
    var kind = D.batch.kind;
    window.state.lots.busy = true; window.renderModal();
    window.lotApi('batch_apply', { id: D.batch.id, cid: cid, force: !!remplacer }, function(d) {
        window.state.lots.busy = false;
        // Un script déjà écrit n'est jamais écrasé sans un accord explicite : on garde le refus sur la ligne
        // concernée, avec le bouton qui permet de forcer si c'est bien ce qu'on veut.
        if (d && d.exists) { it.conflit = d.message; window.renderModal(); return; }
        it.conflit = null;
        if (!d || !d.success) { window.state.lots.error = (d && d.message) || "Application impossible"; window.renderModal(); return; }
        var taches = window.lotAppliqueUn(kind, it, d, window.state.tasks);
        it.applied = true;
        if (taches !== window.state.tasks) {
            window.actions.saveSubParts();
            window.planningAction('Découpage en lot : ' + (it.info.label || ('item ' + it.info.itemNumber)));
            window.syncWithServer('save_tasks', { tasks: taches }, function() { window.renderApp(); });
        }
        window.renderApp();
        if (kind === 'podcast_script' || kind === 'podcast_fiche') window.loadPodcastIndex(function() { window.renderModal(); });
    });
};
// Moteur commun d'application en série. « cibles » : [{batchId, kind, it}] — éventuellement de plusieurs lots.
// Les résultats partent un par un (chacun est un aller-retour serveur) mais le planning n'est enregistré
// qu'UNE fois, à la fin : une seule annulation défait tout. Tout est capturé au départ, donc la série survit
// à un retour à la liste ou à la fermeture de la fenêtre.
window.lotApplique = function(cibles, libelle, fini) {
    var L = window.state.lots;
    L.busy = true; L.error = ''; L.progress = { fait: 0, total: cibles.length }; window.renderModal();
    var taches = window.state.tasks, faits = 0, echecs = [];
    var suivant = function(i) {
        if (i >= cibles.length) {
            L.busy = false; L.progress = null;
            if (taches !== window.state.tasks) {
                window.actions.saveSubParts();
                window.planningAction(libelle.replace('{n}', faits));
                window.syncWithServer('save_tasks', { tasks: taches }, function() { window.renderApp(); });
            }
            if (echecs.length) L.error = echecs.length + ' résultat(s) non appliqué(s) : ' + echecs.slice(0, 3).join(' ; ');
            window.renderApp();
            if (fini) fini(faits, echecs);
            return;
        }
        var c = cibles[i], it = c.it;
        window.lotApi('batch_apply', { id: c.batchId, cid: it.cid }, function(d) {
            if (d && d.success) {
                try { taches = window.lotAppliqueUn(c.kind, it, d, taches); it.applied = true; faits++; }
                catch (e) { console.error('lotApplique', e); echecs.push((it.info.label || it.cid) + ' : ' + e.message); }
            } else {
                if (d && d.exists) it.conflit = d.message;
                echecs.push((it.info.label || it.cid) + ' : ' + ((d && d.message) || 'échec'));
            }
            L.progress = { fait: i + 1, total: cibles.length };
            if (L.open) window.renderModal(); else window.renderContent(); // le bandeau du tableau de bord aussi
            suivant(i + 1);
        });
    };
    suivant(0);
};
// Les lots restent en mémoire sur le serveur avec la trace de ce qui a été appliqué : on peut donc retrouver
// après coup quels items ont été scindés par un lot, y compris ceux appliqués avant que cette marque existe.
// Règle prudente : on ne marque un item que si son découpage actuel est EXACTEMENT celui que le lot proposait.
// S'il a été retouché depuis (à la main, ou par une proposition IA appliquée un par un), les noms diffèrent et
// l'item est laissé tranquille — c'est bien le découpage de l'étudiant, plus celui du lot.
window.memesParties = function(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    return a.every(function(x, i) { return String(x).trim() === String(b[i]).trim(); });
};
window.actions.retrouverDecoupagesLot = function(cb) {
    var lots = (window.state.lots.list || []).filter(function(b) { return b.kind === 'split' && b.status === 'ended' && b.applied; });
    if (!lots.length) { if (cb) cb(0); return; }
    var reste = lots.length, marques = 0;
    lots.forEach(function(b) {
        window.lotApi('batch_get', { id: b.id }, function(d) {
            if (d && d.success) (d.items || []).forEach(function(it) {
                if (!it.applied || !it.result || !it.result.ok) return;
                var id = String(it.info.itemNumber);
                if (window.state.splitLots[id]) return;
                var noms = (it.result.data.parts || []).map(function(pt) { return pt.name; });
                if (noms.length > 1 && window.memesParties(window.state.subParts[id], noms)) { window.state.splitLots[id] = Date.now(); marques++; }
            });
            if (--reste) return;
            if (marques) {
                window.storageSet('edn_split_lots', JSON.stringify(window.state.splitLots));
                window.savePrefs();
                window.renderModal();
            }
            if (cb) cb(marques);
        });
    });
};
// Items qui ONT des sous-parties enregistrées mais dont le planning ne les reflète pas : ils y figurent encore
// comme un item entier (une seule séquence), ou avec moins de séquences que de sous-parties. Ça arrive quand
// les sous-parties ont été posées sans que la replanification aboutisse — un enregistrement interrompu, une
// sous-partie ajoutée à la main dans la modale sans revalider.
// Sous-parties réellement présentes dans le planning pour un item, lues dans le titre « Titre [Partie] ».
window.scindagePartiesPlanifiees = function(base) {
    var vues = {};
    base = String(base);
    window.state.tasks.forEach(function(t) {
        if (t.isDouble || String(t.baseItemId || t.itemId) !== base) return;
        var m = (t.titre || '').match(/\[(.+)\]$/);
        if (m) vues[window.podcastNorm(m[1])] = true;
    });
    return vues;
};
// Items scindés qui ont au moins une séance au planning. C'est la population sur laquelle on répartit :
// on ne ressuscite jamais un item qui n'y est plus.
window.scindagesPlanifies = function() {
    var presents = {};
    window.state.tasks.forEach(function(t) { if (!t.isDouble) presents[String(t.baseItemId || t.itemId)] = true; });
    return Object.keys(presents).filter(function(base) {
        return (window.state.subParts[base] || []).length > 1 && !!window.itemById(base);
    }).sort(function(a, b) { return (parseInt(a, 10) || 0) - (parseInt(b, 10) || 0); });
};
window.scindagesARepartir = function() {
    return window.scindagesPlanifies().filter(function(base) {
        var vues = window.scindagePartiesPlanifiees(base);
        // On compare les NOMS des sous-parties, pas leur nombre. Compter les séances laissait passer un item
        // qui a le bon nombre de séances sans porter les bonnes sous-parties — découpage refait, item scindé
        // puis re-scindé autrement, séance renommée : c'est le cas de « certaines ne sont toujours pas
        // réparties », que l'ancien test ne voyait pas.
        return (window.state.subParts[base] || []).some(function(nom) { return !vues[window.podcastNorm(nom)]; });
    });
};
// Répartit ces sous-parties dans le planning : chaque item retrouve une séance par sous-partie, à partir du
// jour où il était prévu, avec les révisions qui suivent. Un seul enregistrement, une seule annulation.
// Reconstruit la séquence de chaque item donné, une séance par sous-partie. Les séances déjà cochées le
// restent : répartir déplace des dates, ce n'est pas une raison de perdre l'avancement.
window.repartirCesScindages = function(ids, libelle) {
    var taches = window.state.tasks, faits = 0;
    var partieDe = function(t) { var m = (t.titre || '').match(/\[(.+)\]$/); return m ? window.podcastNorm(m[1]) : ''; };
    ids.forEach(function(id) {
        var parts = window.state.subParts[id] || [];
        if (parts.length < 2) return;
        var faites = {};
        taches.forEach(function(t) {
            if (t.isDouble || String(t.baseItemId || t.itemId) !== String(id) || t.status !== 'done') return;
            var p = partieDe(t); if (p) faites[p + '|' + t.type] = t.date;
        });
        var nt = window.splitRebuildTasks(taches, id, parts);
        if (!nt) return;
        nt.forEach(function(t) {
            if (t.isDouble || String(t.baseItemId || t.itemId) !== String(id)) return;
            var p = partieDe(t), d = p ? faites[p + '|' + t.type] : null;
            // Une séance faite garde SA date : la répartition réorganise ce qui reste à faire, elle n'a
            // aucune raison de projeter dans le futur une séance déjà cochée (le calendrier deviendrait faux).
            if (d) { t.status = 'done'; t.date = d; }
        });
        taches = nt; faits++;
    });
    if (!faits) return 0;
    window.planningAction(libelle + ' (' + faits + ' items)');
    window.syncWithServer('save_tasks', { tasks: taches }, function() { window.renderApp(); });
    window.renderApp();
    return faits;
};
window.actions.repartirScindages = function() {
    var ids = window.scindagesARepartir();
    if (!ids.length) return;
    window.dialogue.confirmer({ titre: 'Répartir les sous-parties de ' + ids.length + ' item' + (ids.length > 1 ? 's' : '') + ' ?', message: 'Chacun aura une séance par sous-partie, à partir du jour où il était prévu, avec ses révisions. « Revenir en arrière » annule tout d\'un coup.', ok: 'Répartir' }).then(function(ok) {
        if (!ok) return;
        var faits = window.repartirCesScindages(ids, 'Sous-parties réparties dans le planning');
        if (faits) window.undoMessage(faits + ' item' + (faits > 1 ? 's répartis' : ' réparti') + ' en sous-parties dans le planning');
    });
};
// Forcer : on refait la répartition de TOUS les items scindés du planning, même ceux qui ont l'air en règle.
// Un item peut porter le bon nombre de séances sans porter les bonnes sous-parties, ou avoir été déplacé,
// lissé, intensifié depuis son découpage : là, seule une reconstruction remet tout d'aplomb.
window.actions.repartirScindagesForce = function() {
    var ids = window.scindagesPlanifies();
    if (!ids.length) { window.toast('Aucun item scindé dans le planning : rien à répartir'); return; }
    var manquants = window.scindagesARepartir().length;
    window.dialogue.confirmer({ titre: 'Forcer la répartition de ' + ids.length + ' item' + (ids.length > 1 ? 's' : '') + ' scindé' + (ids.length > 1 ? 's' : '') + ' ?',
        message: (manquants ? manquants + ' ne sont pas répartis du tout ; les ' + (ids.length - manquants) + ' autres le sont déjà et seront refaits quand même.\n\n' : 'Ils ont tous l\'air répartis : leurs séquences seront refaites quand même.\n\n')
            + 'Chaque item repart du jour de sa première séance encore à faire, une sous-partie par jour, avec ses révisions. Les séances déjà cochées le restent. Les dates que tu avais déplacées à la main sur ces items seront perdues.\n\n« Revenir en arrière » annule tout d\'un coup.', ok: 'Forcer la répartition', danger: true }).then(function(ok) {
        if (!ok) return;
        var faits = window.repartirCesScindages(ids, 'Répartition forcée des sous-parties');
        if (faits) window.undoMessage('Répartition forcée : ' + faits + ' item' + (faits > 1 ? 's refaits' : ' refait'));
    });
};
// Items dont le découpage vient d'un LOT et qui sont encore scindés. Un item scindé à la main ou par une
// proposition IA appliquée depuis la modale Scinder n'en fait pas partie : window.actions.executeSplit efface
// la marque, parce que le découpage devient alors celui de l'étudiant.
window.splitLotsActifs = function() {
    return Object.keys(window.state.splitLots || {}).filter(function(id) {
        return (window.state.subParts[id] || []).length > 1;
    }).sort(function(a, b) { return (parseInt(a, 10) || 0) - (parseInt(b, 10) || 0); });
};
// Défait uniquement ces découpages-là : les sous-parties sont oubliées et chaque item retrouve une séquence
// unique, à partir du jour de sa première sous-partie encore à faire. Un seul enregistrement, une annulation.
// --- REGROUPEMENT DES SOUS-PARTIES DES ITEMS COURTS ---------------------------------------------------------
// Un item scindé en sous-parties coûte une séquence complète par sous-partie. En dessous d'un nombre de mots de
// fiche, l'item est revu en un seul bloc : son découpage part dans subPartsArchive (rétablissable), ses tâches
// à venir sont refaites en une séquence, ses séances faites restent. Les podcasts des sous-parties ne bougent
// pas : la carte du bloc les montre tous.
window.motsItem = function(id) { var f = window.FICHE_STRUCTURE && window.FICHE_STRUCTURE[String(id)]; return f && f.w ? f.w : 0; };
window.regroupCandidats = function(seuil) {
    var s = window.state; seuil = parseInt(seuil, 10) || 0;
    return Object.keys(s.subParts || {}).filter(function(id) { var m = window.motsItem(id); return (s.subParts[id] || []).length > 1 && m > 0 && m < seuil; });
};
// Séquence unique pour un item regroupé : les séances faites sont gardées, les séances à venir (toutes
// sous-parties) sont remplacées par une seule séquence à partir de la première encore à faire.
window.regroupTasks = function(tasks, baseItemId) {
    baseItemId = String(baseItemId);
    var itemDef = window.itemById(baseItemId); if (!itemDef) return tasks;
    var siennes = tasks.filter(function(t) { return String(t.baseItemId || t.itemId) === baseItemId && !t.isDouble; });
    var aFaire = siennes.filter(function(t) { return t.status !== 'done'; });
    if (!aFaire.length) return tasks;
    var depart = window.splitDepart(siennes);
    var reste = tasks.filter(function(t) { return !(String(t.baseItemId || t.itemId) === baseItemId && !t.isDouble && t.status !== 'done'); });
    var stamp = Date.now(), sequence = window.splitSequence(itemDef, baseItemId, baseItemId, itemDef.titre, depart, stamp);
    // un J0 déjà fait sur toutes les sous-parties : pas de nouveau J0, seulement les révisions
    var j0Faits = siennes.filter(function(t) { return t.type === 'J0' && t.status === 'done'; }).length;
    if (j0Faits && j0Faits >= (window.state.subParts[baseItemId] || window.state.subPartsArchive[baseItemId] || []).length) sequence = sequence.filter(function(t) { return t.type !== 'J0'; });
    return reste.concat(sequence);
};
// La garde est un dialogue du design system, jamais un confirm() natif : l'écran « Planifier » (lot B3) d'où part
// ce bouton est un role="dialog" aria-modal, et une fenêtre du navigateur par-dessus lui n'a pas de place. Le corps
// est donc asynchrone. Sans candidat, rien à dire : le bouton porte déjà `disabled` (src/ui/modals/autoplan.js).
window.actions.regrouperSousParties = function(seuil) {
    var s = window.state; seuil = parseInt(seuil, 10) || s.regroupSeuilMots || 0;
    var ids = window.regroupCandidats(seuil);
    if (!ids.length) return;
    window.dialogue.confirmer({
        titre: 'Regrouper ' + ids.length + (ids.length > 1 ? ' items scindés ?' : ' item scindé ?'),
        message: (ids.length > 1 ? 'Ces items de moins de ' : 'Cet item de moins de ') + seuil + ' mots ' + (ids.length > 1 ? 'seront revus' : 'sera revu') + ' en un seul bloc.\n\nLeur découpage est gardé en mémoire (« Rétablir les découpages »), leurs podcasts restent, leurs séances faites aussi ; leurs séances à venir sont refaites en une seule séquence.',
        ok: 'Regrouper', danger: true
    }).then(function(ok) {
        if (!ok) return;
        var taches = s.tasks, cartes = 0;
        ids.forEach(function(id) {
            var parts = [].concat(s.subParts[id]);
            s.subPartsArchive[id] = parts;
            delete s.subParts[id];
            // Les flashcards déjà créées pour ces sous-parties rejoignent le paquet de l'item entier, avec leur
            // historique de révision : sans ça, elles restaient dans des paquets qu'on ne pouvait plus ouvrir.
            if (window.fusionnerDecksSousParties) cartes += window.fusionnerDecksSousParties(id, parts);
            taches = window.regroupTasks(taches, id);
        });
        if (cartes) window.saveLearning();
        s.regroupSeuilMots = seuil;
        window.storageSet('edn_subparts_archive', JSON.stringify(s.subPartsArchive));
        window.actions.saveSubParts();
        window.planningAction('Sous-parties regroupées (' + ids.length + ' items)');
        window.syncWithServer('save_tasks', { tasks: taches }, function() { window.renderApp(); });
        window.renderApp();
        window.undoMessage(ids.length + ' item' + (ids.length > 1 ? 's regroupés' : ' regroupé') + ' en un seul bloc · découpage gardé en mémoire' + (cartes ? ' · ' + cartes + ' flashcard' + (cartes > 1 ? 's versées' : ' versée') + ' dans le paquet de l\'item' : ''));
    });
};
window.actions.retablirSousParties = function() {
    var s = window.state, ids = Object.keys(s.subPartsArchive || {});
    if (!ids.length) return;
    window.dialogue.confirmer({
        titre: 'Rétablir ' + (ids.length > 1 ? 'les ' + ids.length + ' découpages ?' : 'le découpage ?'),
        message: (ids.length > 1 ? 'Ces ' + ids.length + ' items regroupés retrouvent leurs' : 'Cet item regroupé retrouve ses') + ' sous-parties, replanifiées à partir de la première séance encore à faire.',
        ok: 'Rétablir', danger: true
    }).then(function(ok) {
        if (!ok) return;
        var taches = s.tasks, cartes = 0;
        ids.forEach(function(id) {
            var parts = s.subPartsArchive[id]; delete s.subPartsArchive[id];
            if (!parts || parts.length < 2) return;
            s.subParts[id] = parts;
            // Chaque flashcard versée au regroupement retourne dans la sous-partie d'où elle vient.
            if (window.separerDecksSousParties) cartes += window.separerDecksSousParties(id, parts);
            var nt = window.splitRebuildTasks(taches, id, parts); if (nt) taches = nt;
        });
        if (cartes) window.saveLearning();
        window.storageSet('edn_subparts_archive', JSON.stringify(s.subPartsArchive));
        window.actions.saveSubParts();
        window.planningAction('Découpages rétablis (' + ids.length + ' items)');
        window.syncWithServer('save_tasks', { tasks: taches }, function() { window.renderApp(); });
        window.renderApp();
        window.undoMessage(ids.length + ' découpage' + (ids.length > 1 ? 's rétablis' : ' rétabli') + (cartes ? ' · ' + cartes + ' flashcard' + (cartes > 1 ? 's rendues' : ' rendue') + ' à leur sous-partie' : ''));
    });
};
window.actions.supprimerDecoupagesLot = function() {
    var ids = window.splitLotsActifs();
    if (!ids.length) return;
    confirmerPuis({
        titre: 'Supprimer ' + ids.length + ' découpage(s) en lot ?',
        message: "Chaque item retrouvera une séance unique, au jour de sa première sous-partie encore à faire. Les items scindés à la main ou un par un avec l'IA ne sont pas touchés. « Revenir en arrière » annule tout d'un coup.",
        ok: 'Supprimer', danger: true,
    }, function() { supprimerDecoupagesLotSuite(ids); });
};
function supprimerDecoupagesLotSuite(ids) {
    var taches = window.state.tasks, cartes = 0;
    ids.forEach(function(id) {
        // Même règle qu'au regroupement : les flashcards des sous-parties suivent l'item, elles ne restent pas
        // dans des paquets devenus inatteignables.
        if (window.fusionnerDecksSousParties) cartes += window.fusionnerDecksSousParties(id, window.state.subParts[id] || []);
        delete window.state.subParts[id];
        delete window.state.subPartSections[id];
        delete window.state.splitLots[id];
        var nt = window.splitUndoTasks(taches, id);
        if (nt) taches = nt;
    });
    if (cartes) window.saveLearning();
    window.storageSet('edn_subpart_sections', JSON.stringify(window.state.subPartSections));
    window.storageSet('edn_split_lots', JSON.stringify(window.state.splitLots));
    window.actions.saveSubParts();
    window.planningAction('Découpages en lot supprimés (' + ids.length + ' items)');
    window.syncWithServer('save_tasks', { tasks: taches }, function() { window.renderApp(); });
    window.renderApp();
    window.undoMessage(ids.length + ' découpage' + (ids.length > 1 ? 's supprimés' : ' supprimé') + ' · les items sont regroupés' + (cartes ? ' · ' + cartes + ' flashcard' + (cartes > 1 ? 's versées' : ' versée') + ' dans le paquet de l\'item' : ''));
};
// Découpages en attente, tous lots confondus : ce que le bandeau du tableau de bord propose d'appliquer.
window.lotsDecoupagesEnAttente = function() {
    return (window.state.lots.list || []).filter(function(b) { return b.kind === 'split' && b.status === 'ended' && b.ok > b.applied; });
};
window.lotsDecoupagesNb = function() {
    return window.lotsDecoupagesEnAttente().reduce(function(n, b) { return n + (b.ok - b.applied); }, 0);
};
// Bouton du tableau de bord : applique d'un coup tous les découpages en attente, sans passer par l'écran des
// lots. Chaque item scindé est aussitôt replanifié à partir du jour de l'item d'origine.
window.actions.lotAppliquerDecoupages = function() {
    var L = window.state.lots;
    // Un envoi de paquet est en cours : appliquer maintenant lirait un lot à moitié écrit. On le DIT, au lieu
    // de ne rien faire — un bouton qui ne réagit pas passe pour cassé.
    if (L.busy) { L.error = 'Un envoi est en cours : réessaie dans quelques secondes.'; window.renderContent(); return; }
    var lots = window.lotsDecoupagesEnAttente();
    if (!lots.length) return;
    confirmerPuis({
        titre: 'Appliquer ' + window.lotsDecoupagesNb() + ' découpage(s) ?',
        message: 'Chaque item scindé est replanifié à partir du jour où il était prévu. « Revenir en arrière » annule tout d\'un coup.',
        ok: 'Appliquer',
    }, function() { appliquerDecoupagesSuite(L, lots); });
};
function appliquerDecoupagesSuite(L, lots) {
    L.busy = true; window.renderContent();
    var cibles = [], reste = lots.length;
    lots.forEach(function(b) {
        window.lotApi('batch_get', { id: b.id }, function(d) {
            if (d && d.success) (d.items || []).forEach(function(it) {
                if (it.result && it.result.ok && !it.applied && (it.result.data.parts || []).length >= 2) cibles.push({ batchId: b.id, kind: 'split', it: it });
            });
            if (--reste) return;
            L.busy = false;
            if (!cibles.length) { L.error = 'Aucun découpage à appliquer.'; window.renderContent(); return; }
            window.lotApplique(cibles, 'Découpages en lot appliqués au planning ({n} items)', function(faits, echecs) {
                window.actions.lotsRefresh();
                window.undoMessage(faits + ' découpage' + (faits > 1 ? 's appliqués' : ' appliqué') + ' au planning' + (echecs.length ? ' · ' + echecs.length + ' en échec' : ''));
            });
        });
    });
};
// Tout appliquer depuis l'écran d'un lot : même moteur, restreint au lot ouvert.
// Appliquer d'un coup les résultats de TOUS les lots revenus, sans ouvrir chacun : le moteur lotApplique accepte
// des cibles venues de lots différents (chaque cible porte son batchId). On lit d'abord le détail de chaque lot
// — la liste ne porte que des compteurs, pas les résultats —, puis on applique la collecte en une seule fois,
// donc un seul enregistrement et un seul « Revenir en arrière ».
window.actions.lotApplyTous = function() {
    var L = window.state.lots;
    if (L.busy) return;
    var lots = (L.list || []).filter(function(b) { return b.status === 'ended' && b.ok > b.applied; });
    if (!lots.length) return;
    var total = lots.reduce(function(n, b) { return n + (b.ok - b.applied); }, 0);
    confirmerPuis({
        titre: 'Tout appliquer ?',
        message: total + ' résultat' + (total > 1 ? 's' : '') + ' encore non appliqué' + (total > 1 ? 's' : '') + ', dans ' + lots.length + ' lot' + (lots.length > 1 ? 's' : '') + '. Ils sont portés au planning ; « Revenir en arrière » annule tout d\'un coup.',
        ok: 'Tout appliquer',
    }, function() {
        L.busy = true; L.error = ''; L.progress = { fait: 0, total: lots.length, lecture: true };
        window.renderModal();
        var cibles = [], echecs = [], i = 0;
        var suivant = function() {
            if (i >= lots.length) {
                L.busy = false; L.progress = null;
                if (!cibles.length) {
                    L.error = echecs.length ? 'Aucun lot lisible : ' + echecs.slice(0, 3).join(' ; ') : 'Aucun résultat à appliquer.';
                    window.renderModal(); return;
                }
                if (echecs.length) L.error = echecs.length + ' lot(s) illisible(s) : ' + echecs.slice(0, 3).join(' ; ');
                // L'index des podcasts n'est relu que si un lot de podcast est passé : sinon c'est une requête pour rien.
                var podcasts = cibles.some(function(c) { return c.kind === 'podcast_script' || c.kind === 'podcast_fiche'; });
                window.lotApplique(cibles, 'Lots appliqués ({n} résultats)', function() {
                    if (podcasts) window.loadPodcastIndex(function() { window.renderModal(); });
                    window.actions.lotsRefresh();
                });
                return;
            }
            var b = lots[i++];
            window.lotApi('batch_get', { id: b.id }, function(d) {
                if (d && d.success) {
                    (d.items || []).forEach(function(it) {
                        if (it.result && it.result.ok && !it.applied) cibles.push({ batchId: b.id, kind: b.kind, it: it });
                    });
                } else echecs.push((window.LOT_KINDS[b.kind] || {}).titre || b.kind);
                L.progress = { fait: i, total: lots.length, lecture: true };
                window.renderModal();
                suivant();
            });
        };
        suivant();
    });
};
window.actions.lotApplyAll = function() {
    var L = window.state.lots, D = L.detail;
    if (!D || L.busy) return;
    var kind = D.batch.kind, batchId = D.batch.id;
    var tousUtilisables = (D.items || []).filter(function(x) { return x.result && x.result.ok; });
    var restants = tousUtilisables.filter(function(x) { return !x.applied; });
    var rejeu = !restants.length;
    if (rejeu) { // tout est marqué appliqué : proposer de rejouer (cas d'une application interrompue)
        if (!tousUtilisables.length) return;
        restants = tousUtilisables;
    }
    confirmerPuis(rejeu
        ? { titre: 'Tout réappliquer ?', message: 'Les ' + tousUtilisables.length + " résultats sont déjà marqués appliqués. Les rejouer est utile si une application précédente s'est interrompue.", ok: 'Réappliquer' }
        : { titre: 'Appliquer ' + restants.length + ' résultat(s) ?', message: 'Ils sont portés au planning ; « Revenir en arrière » annule tout d\'un coup.', ok: 'Appliquer' },
    function() {
        var cibles = restants.map(function(it) { return { batchId: batchId, kind: kind, it: it }; });
        window.lotApplique(cibles, window.LOT_KINDS[kind].titre + ' en lot ({n}' + (rejeu ? ' réappliqués)' : ' appliqués)'), function() {
            if (kind === 'podcast_script' || kind === 'podcast_fiche') window.loadPodcastIndex(function() { window.renderModal(); });
            window.actions.lotsRefresh();
        });
    });
};


window.actions = window.actions || {};
window.actions.saveSubParts = function() {
    window.storageSet('edn_subparts_global', JSON.stringify(window.state.subParts));
    window.savePrefs();
};

// --- PRÉFÉRENCES SYNCHRONISÉES (sous-parties scindées, dates de partiels) ---
// Les sous-parties n'étaient gardées que dans le navigateur : régénérer un planning depuis un autre appareil
// (ou après vidage du cache) les perdait. Elles sont maintenant aussi enregistrées sur le serveur et fusionnées au démarrage.


// --- DÉCOUPAGES RESTAURÉS : sous-parties perdues lors d'une régénération (avant la synchronisation serveur),
// réinjectées une seule fois pour les items qui n'en ont pas encore. Un item délibérément « dé-scindé » ensuite n'est pas rétabli.
window.RESTORED_SUBPARTS = {
    '110': ['GÉNÉRALITÉS : LE SOMMEIL NORMAL', "L'INSOMNIE CHRONIQUE DE L'ADULTE", "TRS DE L'ADULTE", 'SOMNOLENCE DIURNE EXCESSIVE (SDE)', "HYPERSOMNIES D'ORIGINE CENTRALE", 'TROUBLES DU RYTHME CIRCADIEN', 'PARASOMNIES', 'MOUVEMENTS ANORMAUX'],
    '151': ['Pour comprendre et clinique', 'Ponction lombaire (Geste, CI, Complication)', 'Ponction lombaire (Analyse)', 'Imagerie cerebrale et EEG', 'Le Bilan Biologique "Hors-LCS"', 'Germes selon terrain et PL', 'Purpura fulminas et Abces cerebral', 'Herpes meningo encephalitis', 'Autres causes de méningites vir a LCS clair', 'Meningite a Meningocoque', 'Meningite a Pneumocoque', 'Meningite a Listeria', 'Meningite tuberculose', 'Meningite subaigue chronique', 'Meningite a E.Coli', 'Prise en charge en TT'],
    '154': ['PAC diag et orientation', 'Profil détaillé des agents infectieux des PAC', 'Antibiothérapie, Suivi et Prévention des PAC', 'La bronchite aiguë du sujet sain'],
    '155': ["Infection de l'epiderme", 'Folliculite superficielle', 'Furoncle', 'Furonculose', 'Abces', 'Candida (General)', 'Intertrigo', 'Ungueale', 'Candidose buccale', 'Candidose digestive extra buccale', 'Mycose genitale', 'Dermatophytose (Generalité)', 'Dermatophytose (Peau glabre)', 'Dermatophytose (Teigne)', 'Malassezia FURFUR', 'Infection dentaires (Physiopathologie)', 'Carrie', 'Pulpopathie', 'Parodontites', 'Parodontopahtie', 'Cellulite de la face (Generalité et physio)', 'Cellulite aigue et chronique (Clinique)', 'Cellulite de la face (signes de gravité)', 'Cellulite de la face (Paraclinique)', 'Cellulite de la face (Traitement)', 'Complication (SMOD)', 'Complication autres'],
    '157': ['Bases pour comprendre', 'Hémocultures', 'Sepsis et choc septique', 'CAT devant suspicion', 'Traitements et surveillance', 'Bacterimie a S.Aureus', 'Point sur Fongemie', 'Infection sur KT'],
    '161': ['Definition, physiopath et microbiologie', 'STRATÉGIE DIAG & EXAMENS', 'Prise en charge thérapeutique des cystites', 'PEC PNA', 'IU Masculine', 'Situation particulière et RHG'],
    '170': ['Épidémiologie, transmission et parasite', 'Le diagnostic (Clinique, biologie et urgence)', "L'accès grave et les terrains à risque", 'La prise en charge thérapeutique', 'La prévention'],
    '188': ['Asthme (Epidemio, Def, FDR, signes, physio)', 'Asthme (Diagnostique et Paraclinique)', 'Asthme (Prise en charge, TT suivi, adressage)', 'Exacerbation (Definition, Clinique, gravité)', 'Exacerbation (FDR)', 'Exacerabation (Paraclinique)', 'Exacerbation (TT et Suivi)', 'Asthme pro et allergene', 'Rhinite allergique'],
    '224': ['Epidemio, et FDRCV', 'Physiologique', 'Clinique, Mesures positive et paraclinique', 'TT(Mesures, Instauration,medoc,Suivi)', 'Pediatrie', 'Complications (Neuro,Cardio,Renale,Vasc)', 'Complications (Ophtalmo)', 'Urgence Hypertensive', 'HTA secondaire (Renale)', 'HTA secondaire (Endocriniennes)', 'HTA + HypoK', 'HTA secondaire (Grossesse,Aorte,iatro,SAOS)'],
    '239': ['Raynaud', 'Acrocyanose', 'Erythermalgie', 'Engelure', 'Necrose Digitale'],
    '247': ['Diabete de Type 1', 'Diabete de Type 2', 'Rétinopathie diabétique et complication gén', 'Néphropathie diabétique', 'Neuropathie diabétique', 'Macroangiopathie', 'Suivi', 'Acidocétose et Coma acidocetosique', 'Hyperosmolarité et coma hyperosmo', 'Hypoglycémie', 'Diagnostic', 'Pediatrie', 'Thérapeutique'],
    '306': ['Generalité et principaux types de tumeurs', 'Anapath', 'Tumeurs bénignes (Epidemio, FDR, clinique)', 'Tumeurs bénignes (Paraclinique)', 'Tumeurs bénignes (Complications)', 'Tumeurs malignes (Epidemio, clinique)', 'Tumeurs malignes (Imagerie)', 'Tumeurs malignes (Anapath + bio)', 'Tumeurs malignes (PEC)'],
    '312': ['Partie 1', 'Partie 2', 'Partie 3', 'Partie 4'],
    '329': ['Epidemiologies, Distributes, Le don', 'Hemovigilance, et controle et compo', 'Caractéristiques des PSL', 'Groupes sanguin erythrocytaires', 'Compatibilité', 'Transfusion', 'Indication transfusion CGR', 'Indication transfusion CP', 'Indication transfusion PFC', 'Indication transfusion CGA ou MCGST', 'Transformation des PSL (Irradiation)', 'Transformation des PSL (Deplasmatisation)', 'Transformation des PSL (Phenotypage)', 'Transformation des PSL (Compatibilité)', 'Transformation des PSL (CMV et VHE)', 'Protocoles Trans spé (transfu massive)', 'Protocoles Trans spé (Transfu en urgence)', 'Trans spé (Drepanocytose et thalassemie)', 'Protocoles Trans spé (AHAI, MAT et valve)', 'Protocoles Trans spé (Vieux et enfant)', 'Complications Aigue (Immunologies)', 'Complication retardée (immunologiques)', 'Complication infectieuses', 'Complications de surcharges et métaboliques', 'Epargnes transfu'],
    '330': ['ITEM 330 - Antiagrégants', 'ITEM 330 - AVK', 'ITEM 330 - AOD', 'ITEM 330 - Antihypertenseurs', 'ITEM 330 - Héparines', 'ITEM 330 - Diurétiques', 'ITEM 330 - Hypolipémiants', 'ITEM 330 - AINS', 'ITEM 330 - Corticoïdes', 'ITEM 330 - Psychotropes et antiépileptiques'],
    '337': ['Toxicologie générale & Enquête clinique', 'PEC & Les Antidotes', 'Syndrome Opioïde', 'Syndrome de Myorelaxation', 'Syndrome Anticholinergique / Atropinique', 'Syndrome Sérotoninergique', 'Syndrome Adrénergique / Sympathomimétique', 'Effet Stabilisateur de Membrane (ESM)', 'Intoxications médicamenteuses', 'Intoxications non médicamenteuses', 'Syndrome de Sevrages'],
    '351': ['Agitation (Epidemio, Definition et Diag)', 'Agitation (Diag étiologique chez vieux)', 'Agitation (Diag étio chez jeune et psy)', 'Agitation (PEC)', 'Delire aigue (Def et diag)', 'Delire aigue (Diag Etiologique)', 'Delire aigue (PEC)'],
    '353': ['Ingestion de caustique', "repérage d'une crise suicidaire selon age", 'Définitions et Épidémiologie', "Évaluation de la crise (L'échelle RUD)", "Les spécificités selon l'âge", 'Prise en charge psychiatrique', "L'ingestion de caustiques"]
};
window.restoreLostSubParts = function() {
    if (localStorage.getItem('edn_subparts_restored_v1')) return;
    var added = 0;
    Object.keys(window.RESTORED_SUBPARTS).forEach(function(k) {
        if (!window.state.subParts[k] || !window.state.subParts[k].length) { window.state.subParts[k] = [].concat(window.RESTORED_SUBPARTS[k]); added++; }
    });
    localStorage.setItem('edn_subparts_restored_v1', '1');
    if (added) window.actions.saveSubParts();
};

// --- DÉCOUPAGE IA : sections du plan de la fiche regroupées par chaque partie (posé par aiSplitSuggest) ---
window.fichePartNodes = function(itemId, tree, partName) {
    var map = window.state.subPartSections[String(itemId)];
    var secs = map && map[partName];
    if (!secs || !secs.length || !tree) return null;
    var nodes = [], w = 0;
    secs.forEach(function(t) {
        var nt = window.normalizeTitle(t);
        var node = null;
        for (var i = 0; i < tree.length; i++) { if (window.normalizeTitle(tree[i].t) === nt) { node = tree[i]; break; } }
        if (!node) node = window.findFichePart(tree, t);
        if (node && nodes.indexOf(node) === -1) { nodes.push(node); w += node.w || 0; }
    });
    return { nodes: nodes, w: w, sections: secs };
};
window.buildFichePlanText = function(itemId, structure) {
    var item = (structure || {})[String(itemId)]; if (!item || !item.tree) return { plan: '', words: 0 };
    var lines = [];
    item.tree.forEach(function(nd, i) {
        var rang = nd.r === 'A' ? ' [rang A]' : (nd.r === 'B' ? ' [rang B]' : '');
        lines.push((i + 1) + '. ' + (nd.t || '').trim() + rang + (nd.w ? ' (≈ ' + nd.w + ' mots)' : ''));
        (nd.c || []).forEach(function(ch) { var r2 = ch.r === 'A' ? ' [rang A]' : (ch.r === 'B' ? ' [rang B]' : ''); lines.push('   - ' + (ch.t || '').trim() + r2); });
    });
    return { plan: lines.join('\n'), words: item.w || 0 };
};
// Item concerné par la modale Scinder (depuis le catalogue : itemId ; depuis une tâche : taskId → item de base)
window.splitModalItemId = function(c) {
    if (!c) return null;
    var itemId = c.itemId;
    if (!itemId && c.taskId) { var tk = window.state.tasks.find(function(t){ return t.id === c.taskId; }); if (tk) itemId = tk.baseItemId || tk.itemId; }
    return itemId ? String(itemId) : null;
};
// Les propositions de l'IA sont mémorisées par item (5 dernières) : elles restent consultables et réutilisables après fermeture
window.splitProposalsFor = function(itemId) { return (window.state.splitProposals[String(itemId)] || []); };
window.rememberSplitProposal = function(itemId, proposal) {
    var list = window.splitProposalsFor(itemId).slice();
    list.unshift(proposal);
    window.state.splitProposals[String(itemId)] = list.slice(0, 5);
    window.storageSet('edn_split_proposals', JSON.stringify(window.state.splitProposals));
    window.savePrefs();
};
window.applySplitProposal = function(c, itemId, proposal, idx, fillInput) {
    // Une proposition mémorisée par une version antérieure peut être dépourvue de `parts` : on la traite comme vide
    // plutôt que de lever (le cadre rouge #crash-box) à chaque ouverture de la fenêtre « Découper ».
    var parts = Array.isArray(proposal && proposal.parts) ? proposal.parts : [];
    c.aiParts = parts; c.aiSource = proposal.source; c.aiIndex = idx; c.aiFromMemory = !fillInput;
    if (fillInput) {
        c.inputValue = parts.map(function(pt){ return pt.name; }).join('\n');
        var map = {}; parts.forEach(function(pt) { if (pt.sections && pt.sections.length) map[pt.name] = pt.sections; });
        window.state.subPartSections[itemId] = map;
        window.storageSet('edn_subpart_sections', JSON.stringify(window.state.subPartSections));
        window.savePrefs();
    }
};
window.attachSplitHistory = function(c) {
    var itemId = window.splitModalItemId(c); if (!itemId) return;
    var hist = window.splitProposalsFor(itemId);
    if (hist.length) window.applySplitProposal(c, itemId, hist[0], 0, false);
};
window.actions.splitUseProposal = function(idx) {
    var c = window.state.modalConfig; var itemId = window.splitModalItemId(c); if (!itemId) return;
    var prop = window.splitProposalsFor(itemId)[idx]; if (!prop) return;
    window.applySplitProposal(c, itemId, prop, idx, true);
    window.renderModal();
};
window.actions.splitShowProposal = function(idx) {
    var c = window.state.modalConfig; var itemId = window.splitModalItemId(c); if (!itemId) return;
    var prop = window.splitProposalsFor(itemId)[idx]; if (!prop) return;
    window.applySplitProposal(c, itemId, prop, idx, false);
    window.renderModal();
};
window.actions.splitForgetProposal = function(idx) {
    var c = window.state.modalConfig; var itemId = window.splitModalItemId(c); if (!itemId) return;
    var list = window.splitProposalsFor(itemId).slice(); list.splice(idx, 1);
    if (list.length) window.state.splitProposals[itemId] = list; else delete window.state.splitProposals[itemId];
    window.storageSet('edn_split_proposals', JSON.stringify(window.state.splitProposals));
    window.savePrefs();
    c.aiParts = null; c.aiIndex = null;
    if (list.length) window.applySplitProposal(c, itemId, list[0], 0, false);
    window.renderModal();
};
window.actions.aiSplitSuggest = function() {
    var c = window.state.modalConfig; if (!c || c.aiBusy) return;
    var itemId = window.splitModalItemId(c);
    if (!itemId) return;
    var itemDef = window.itemById(itemId);
    var sel = document.getElementById('ai-split-n');
    var wanted = sel ? parseInt(sel.value, 10) || 0 : 0;
    var current = (c.inputValue || '').split('\n').map(function(x){ return x.trim(); }).filter(Boolean);
    c.aiBusy = true; c.aiError = null; window.renderModal();
    window.loadFicheStructure(function(structure) {
        var planInfo = window.buildFichePlanText(itemId, structure);
        fetch('api.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'ai_split', itemNumber: itemId, itemTitle: itemDef ? itemDef.titre : '', plan: planInfo.plan, totalWords: planInfo.words, parts: wanted, currentParts: current }) })
            .then(function(r) { return r.json(); })
            .then(function(res) {
                c.aiBusy = false;
                if (!res.success) { c.aiError = res.needs_api_key ? 'Clé API Anthropic non configurée dans api.php.' : (res.message || 'Échec de la proposition IA'); window.renderModal(); return; }
                // Une réponse « success » sans découpage utilisable est un échec : la mémoriser empoisonnait
                // durablement l'historique (localStorage edn_split_proposals) et rendait la fenêtre inouvrable.
                if (!Array.isArray(res.parts) || !res.parts.length) { c.aiError = 'La proposition IA est revenue vide.'; window.renderModal(); return; }
                var proposal = { t: Date.now(), wanted: wanted, source: res.source, parts: res.parts };
                window.rememberSplitProposal(itemId, proposal);
                window.applySplitProposal(c, itemId, proposal, 0, true);
                window.renderModal();
            })
            .catch(function(e) { c.aiBusy = false; c.aiError = 'Erreur réseau : ' + e.message; window.renderModal(); });
    });
};

// --- PODCASTS : script à un narrateur rédigé par Claude d'après la fiche, voix Voxtral TTS, fichiers sur le serveur ---
// (edn_data/podcasts/, servis par api.php). Rien n'est gardé dans le navigateur : inventaire, vitesse, position de
// lecture et voix choisies viennent du serveur (podcast_index / préférences). Un seul lecteur, en bas de page,
// survit aux re-rendus et aux changements d'onglet.
window.loadPodcastIndex = function(cb) {
    window.syncWithServer('podcast_index', {}, function(d) {
        if (d && d.success) { window.state.podcasts = (d.items && !Array.isArray(d.items)) ? d.items : {}; window.state.podcastsConfigured = !!d.configured; }
        if (cb) cb(d);
    });
};
window.podcastNorm = function(p) { return String(p || '').trim().replace(/\s+/g, ' ').toLowerCase(); };
// Périmètre d'une tâche : l'item, ou la sous-partie lue dans le titre « Titre [Partie] »
window.taskPodcastScope = function(task) {
    var n = String(task.baseItemId || task.itemId), part = '';
    var isBis = !!(task.isDouble || (task.id || '').includes('_bis'));
    if (!isBis && task.baseItemId) { var m = (task.titre || '').match(/\[(.+)\]$/); if (m) part = m[1].trim(); }
    var item = window.itemById(n);
    var title = item ? item.titre : (task.titre || '').replace(/\s*\[.+\]$/, '');
    var matieres = [task.matiere].concat(item ? item.collegesSecondaires : []).filter(Boolean);
    return { n: n, part: part, pedia: isBis, matieres: matieres, itemTitle: title, label: '#' + n + ' ' + title + (part ? ' · ' + part : '') + (isBis ? ' · renforcement pédiatrie' : '') };
};
// variante : (item | sous-partie | renforcement pédiatrie) × (révision | explicatif = fiche + collège)
window.podcastFor = function(n, part, pedia, explicatif) {
    var list = window.state.podcasts[String(n)] || [], key = window.podcastNorm(part);
    for (var i = 0; i < list.length; i++) {
        var p = list[i];
        if (!!p.pedia !== !!pedia || !!p.explicatif !== !!explicatif) continue;
        if (pedia || window.podcastNorm(p.part) === key) return p;
    }
    return null;
};
window.podcastUpsert = function(lite) {
    if (!lite || !lite.slug) return;
    var n = String(lite.item), list = (window.state.podcasts[n] || []).filter(function(p){ return p.slug !== lite.slug; });
    list.push(lite); window.state.podcasts[n] = list;
};
window.podcastRemove = function(n, slug) { window.state.podcasts[String(n)] = (window.state.podcasts[String(n)] || []).filter(function(p){ return p.slug !== slug; }); };
window.podcastKey = function(n, slug) { return n + '/' + slug; };
window.podcastMinutes = function(pc) { return pc && pc.duration ? Math.max(1, Math.round(pc.duration / 60)) : ((pc && pc.estMin) || 1); };
window.podcastBySlug = function(n, slug) { return (window.state.podcasts[String(n)] || []).find(function(p){ return p.slug === slug; }) || null; };
window.podcastUrl = function(n, slug) { return 'api.php?action=podcast_file&item=' + encodeURIComponent(n) + '&slug=' + encodeURIComponent(slug); };
window.fmtTime = function(sec) {
    if (!isFinite(sec) || sec < 0) sec = 0; sec = Math.floor(sec);
    var h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), x = sec % 60;
    return (h ? h + ':' + String(m).padStart(2, '0') : String(m)) + ':' + String(x).padStart(2, '0');
};
// Une réponse qui n'est pas du JSON (page HTML « délai dépassé » du serveur web, erreur PHP) est nommée pour ce
// qu'elle est, avec le code HTTP et le titre de la page, au lieu de « Unexpected token < ».
window.reponseNonJson = function(status, text) {
    var t = String(text || '');
    var titre = (t.match(/<title[^>]*>([^<]*)<\/title>/i) || [])[1] || '';
    var corps = t.replace(/<script[\s\S]*?<\/script>|<style[\s\S]*?<\/style>/gi, ' ').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    var detail = (titre || corps).trim().slice(0, 160);
    var e = new Error('le serveur a répondu une page au lieu d\'un résultat (HTTP ' + status + (detail ? ' : ' + detail : '') + ')');
    e.httpStatus = status; e.nonJson = true; e.coupure = status === 0 || status === 408 || status === 500 || status === 502 || status === 503 || status === 504 || status === 524 || /time.?out|délai|gateway|unavailable|indisponible/i.test(detail);
    return e;
};
window.podcastApi = function(payload) {
    return fetch('api.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).then(function(r) {
        return r.text().then(function(text) { try { return JSON.parse(text); } catch (e) { throw window.reponseNonJson(r.status, text); } });
    });
};
// Console d'avancement de la fenêtre du podcast : chaque étape, avec l'heure, pour voir que ça avance (ou pas, et où).
window.podcastLog = function(c, msg) {
    if (!c) return;
    c.journal = c.journal || [];
    var d = new Date(), h = String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0') + ':' + String(d.getSeconds()).padStart(2, '0');
    c.journal.push({ t: h, msg: String(msg) });
    if (c.journal.length > 200) c.journal.splice(0, c.journal.length - 200);
    if (window.state.modalConfig === c) window.renderModal();
};
// Pendant un appel long (synthèse), relire la fiche du podcast toutes les 8 s : la progression réplique par réplique
// s'y enregistre côté serveur, on la montre sans attendre la fin de l'appel.
window.podcastSuivi = function(c, on) {
    if (c.suivi) { clearInterval(c.suivi); c.suivi = null; }
    if (!on) return;
    var vu = -1;
    c.suivi = setInterval(function() {
        if (window.state.modalConfig !== c || !c.busy) { clearInterval(c.suivi); c.suivi = null; return; }
        window.podcastApi(Object.assign(window.podcastVariantPayload(c), { action: 'podcast_script_get' })).then(function(res) {
            if (!res.success || !res.podcast) return;
            window.podcastUpsert(res.podcast);
            var pc = res.podcast, k = pc.chunksDone || 0;
            if (k !== vu && pc.status === 'audio') { vu = k; window.podcastLog(c, 'Synthèse : ' + k + ' / ' + (pc.chunksTotal || '?') + ' répliques'); }
            else if (window.state.modalConfig === c) window.renderModal();
        }).catch(function() {});
    }, 8000);
};
// Sonde podcast_script_get toutes les 10 s (8 min au plus) jusqu'au script (créé après « avantCreated »), à l'échec
// gardé par le serveur, ou à l'abandon. cb(erreur) ou cb(null, podcastLite, script).
window.podcastSonderScript = function(charge, avantCreated, cb, debut) {
    debut = debut || Date.now();
    var suite = function() { setTimeout(function() { window.podcastSonderScript(charge, avantCreated, cb, debut); }, 10000); };
    window.podcastApi({ action: 'podcast_script_get', itemNumber: charge.itemNumber, subPartTitle: charge.subPartTitle || '', pedia: !!charge.pedia, explicatif: !!charge.explicatif }).then(function(res) {
        if (res.success && res.podcast && (res.podcast.created || 0) > (avantCreated || 0) && !res.en_cours) { cb(null, res.podcast, res.script || null); return; }
        if (res.erreur) { cb('Rédaction échouée : ' + res.erreur); return; }
        if (!res.en_cours || Date.now() - debut > 8 * 60000) { cb(res.en_cours ? 'Le script n\'est toujours pas là après 8 min : réessaie plus tard.' : 'La rédaction a été interrompue par le serveur (aucun script enregistré) : réessaie, ou passe par un lot (Gestion → Lots), qui n\'a pas cette limite.'); return; }
        suite();
    }).catch(suite);
};
// Après une coupure pendant la rédaction d'un script (page HTML du serveur web au lieu du résultat), PHP continue
// et enregistre le script : on l'attend, en relisant podcast_script_get toutes les 10 s pendant 8 min au plus.
window.podcastAttendreScript = function(c, avantCreated, thenAudio, debut) {
    debut = debut || Date.now();
    c.busy = 'script'; c.error = null; c.attente = 'Le serveur a coupé la connexion avant la fin, mais la rédaction continue : on attend le script (' + Math.round((Date.now() - debut) / 1000) + ' s)…'; window.renderModal();
    if (c.abandonAttente) { c.abandonAttente = false; c.busy = null; c.attente = null; window.podcastLog(c, 'Attente abandonnée.'); window.renderModal(); return; }
    window.podcastApi(Object.assign(window.podcastVariantPayload(c), { action: 'podcast_script_get' })).then(function(res) {
        var neuf = res.success && res.podcast && (res.podcast.created || 0) > (avantCreated || 0) && !res.en_cours;
        if (neuf) {
            c.busy = null; c.attente = null; window.podcastUpsert(res.podcast); c.script = res.script || null;
            window.podcastLog(c, 'Script récupéré : ' + (res.script || []).length + ' répliques');
            window.renderModal(); window.renderContent();
            if (thenAudio) window.actions.podcastGenerateAudio(false);
            return;
        }
        if (res.erreur) { c.busy = null; c.attente = null; c.error = 'Rédaction échouée : ' + res.erreur; window.podcastLog(c, c.error); window.renderModal(); return; }
        if (!res.en_cours || Date.now() - debut > 8 * 60000) {
            c.busy = null; c.attente = null; c.error = res.en_cours ? 'Le script n\'est toujours pas là après 8 min : réessaie plus tard.' : 'La rédaction a été interrompue par le serveur (aucun script enregistré) : réessaie, ou passe par un lot (Gestion → Lots), qui n\'a pas cette limite.';
            window.podcastLog(c, c.error); window.renderModal(); return;
        }
        var depuis = res.debut ? Math.round(Date.now() / 1000 - res.debut) : Math.round((Date.now() - debut) / 1000);
        window.podcastLog(c, 'Toujours en rédaction côté serveur (depuis ' + (depuis >= 60 ? Math.floor(depuis / 60) + ' min ' + (depuis % 60) + ' s' : depuis + ' s') + ')');
        setTimeout(function() { window.podcastAttendreScript(c, avantCreated, thenAudio, debut); }, 10000);
    }).catch(function(e) { window.podcastLog(c, 'Sondage impossible (' + (e && e.message) + '), on réessaie'); setTimeout(function() { window.podcastAttendreScript(c, avantCreated, thenAudio, debut); }, 10000); });
};

// Modale : état du podcast de l'item / de la sous-partie, génération, voix, script
window.actions.openPodcastForTask = function(taskId, explicatif) {
    var task = window.state.tasks.find(function(t){ return t.id === taskId; }); if (!task) return;
    var sc = window.taskPodcastScope(task);
    window.actions.openPodcast(sc.n, sc.part, sc.pedia, sc.matieres, explicatif);
};
window.actions.openPodcast = function(n, part, pedia, matieres, explicatif) {
    var item = window.itemById(n);
    if (!matieres || !matieres.length) matieres = item ? [item.matiere].concat(item.collegesSecondaires || []).filter(Boolean) : [];
    var x = typeof explicatif === 'boolean' ? explicatif : !!window.state.podcastExplicatif;
    // s'il n'existe qu'une des deux variantes, on l'ouvre directement
    if (typeof explicatif !== 'boolean') { var has0 = !!window.podcastFor(n, part, pedia, false), has1 = !!window.podcastFor(n, part, pedia, true); if (has1 && !has0) x = true; else if (has0 && !has1) x = false; }
    window.state.modalConfig = { type: 'podcast', n: String(n), part: (pedia ? '' : part) || '', pedia: !!pedia, matieres: matieres, explicatif: x, itemTitle: item ? item.titre : ('Item ' + n), busy: null, error: null, script: null, showScript: false, fiche: null, showFiche: false };
    window.renderModal();
    if (window.state.podcastsConfigured && !window.state.podcastVoiceList) window.loadPodcastVoices(false);
    window.loadCollegeStatus(String(n), matieres, !!pedia);
};
// extraits de collège disponibles pour l'item (case « Podcast explicatif »)
window.loadCollegeStatus = function(n, matieres, pedia) {
    var key = n + (pedia ? '/ped' : '');
    if (window.state.collegeStatus[key]) return;
    window.podcastApi({ action: 'college_status', itemNumber: n, matieres: matieres, pedia: pedia }).then(function(d) {
        if (d && d.success) { window.state.collegeStatus[key] = d; var c = window.state.modalConfig; if (c && c.type === 'podcast' && c.n === n) window.renderModal(); }
    }).catch(function() {});
};
// Depuis l'attente : abandonner, ou forcer une nouvelle rédaction malgré un marqueur « en cours » (processus mort).
window.actions.podcastAbandonnerAttente = function() { var c = window.state.modalConfig; if (c) { c.abandonAttente = true; } };
// Marqueur « fiche en cours » resté en place alors que le serveur a perdu la rédaction : on repart quand même.
window.actions.podcastForcerFiche = function() {
    var c = window.state.modalConfig; if (!c) return;
    c.abandonAttente = false; c.busy = null; c.attente = null; c.forceFicheEnCours = true;
    window.podcastLog(c, 'Nouvelle rédaction de fiche forcée (le marqueur « en cours » est ignoré).');
    window.actions.podcastFicheGenerate(true);
};
window.actions.podcastForcerRedaction = function(thenAudio) {
    var c = window.state.modalConfig; if (!c) return;
    c.abandonAttente = false; c.busy = null; c.forceEnCours = true; window.podcastLog(c, 'Nouvelle rédaction forcée (le marqueur « en cours » est ignoré).');
    window.actions.podcastGenerateScript(true, !!thenAudio);
};
window.actions.podcastSetExplicatif = function(on) {
    var c = window.state.modalConfig; if (!c || c.type !== 'podcast' || c.busy) return;
    c.explicatif = !!on; c.error = null; c.script = null; c.showScript = false; c.fiche = null; c.showFiche = false;
    window.state.podcastExplicatif = !!on; window.state.podcastExplicatifSet = true; window.savePrefs();
    window.renderModal();
};
window.podcastVariantPayload = function(c) { return { itemNumber: c.n, subPartTitle: c.part, pedia: !!c.pedia, explicatif: !!c.explicatif, matieres: c.matieres || [] }; };
window.loadPodcastVoices = function(force) {
    window.state.podcastVoiceList = window.state.podcastVoiceList || [];
    window.podcastApi({ action: 'podcast_voices', force: !!force }).then(function(d) {
        if (d && d.success) {
            window.state.podcastVoiceList = d.voices || []; window.state.podcastVoiceDefaults = d.defaults || {};
            window.state.podcastFrenchCount = d.french_count || 0;
            window.state.podcastVoiceOrigine = d.origine || ''; window.state.podcastVoiceAvertissement = d.avertissement || '';
        }
        var c = window.state.modalConfig; if (c && c.type === 'podcast') window.renderModal();
        // L'onglet Voix de Gestion affiche la même liste : elle arrive après le dessin de la page.
        if (window.state.activeTab === 'gestion' && window.state.gestion.onglet === 'voix') window.renderContent();
    }).catch(function() {});
};
window.actions.podcastSetVoice = function(which, id) { window.state.podcastVoices[which] = id || ''; window.savePrefs(); window.renderModal(); };
window.actions.podcastGenerateScript = function(force, thenAudio) {
    var c = window.state.modalConfig; if (!c || c.type !== 'podcast' || c.busy) return;
    var n = c.n, part = c.part;
    c.busy = 'script'; c.error = null; c.showScript = false; c.attente = null;
    window.podcastLog(c, (force ? 'Réécriture' : 'Rédaction') + ' du script demandée' + (c.explicatif ? ' (explicatif)' : '') + (thenAudio ? ', puis audio' : ''));
    window.renderModal();
    window.loadFicheStructure(function(structure) {
        var planInfo = window.buildFichePlanText(n, structure), sections = [];
        if (part) { var map = window.state.subPartSections[String(n)]; if (map && map[part]) sections = map[part]; }
        var existant = window.podcastFor(c.n, c.part, c.pedia, c.explicatif), avantCreated = existant ? (existant.created || 0) : 0;
        window.podcastLog(c, 'Envoi au serveur (fiche' + (sections.length ? ', ' + sections.length + ' sections' : '') + ')…');
        window.podcastApi(Object.assign(window.podcastVariantPayload(c), { action: 'podcast_script', itemTitle: c.itemTitle, sections: sections, plan: part ? '' : planInfo.plan, force: !!force, force_encours: !!c.forceEnCours }))
        .then(function(res) {
            c.busy = null; c.forceEnCours = false;
            if (!res.success && res.en_cours) { window.podcastLog(c, res.detache ? 'Le serveur rédige en arrière-plan : on attend le script.' : 'Le serveur dit : ' + (res.message || 'en cours')); window.podcastAttendreScript(c, avantCreated, thenAudio); return; }
            if (!res.success) { window.podcastLog(c, 'Échec : ' + (res.message || 'rédaction refusée')); c.error = res.message || 'Échec de la rédaction du script'; if (res.no_college) { delete window.state.collegeStatus[c.n]; delete window.state.collegeStatus[c.n + '/ped']; window.loadCollegeStatus(c.n, c.matieres, c.pedia); } window.renderModal(); return; }
            window.podcastUpsert(res.podcast); c.script = res.script || null; delete window.state.collegeStatus[c.n]; delete window.state.collegeStatus[c.n + '/ped'];
            window.podcastLog(c, (res.cached ? 'Script déjà écrit' : 'Script reçu') + ' : ' + (res.script || []).length + ' répliques, ≈ ' + ((res.podcast && res.podcast.estMin) || '?') + ' min');
            window.renderModal(); window.renderContent();
            if (thenAudio) window.actions.podcastGenerateAudio(false);
        }).catch(function(e) {
            if (e && e.nonJson) { window.podcastLog(c, 'Connexion coupée par le serveur (' + e.message + ')'); window.podcastAttendreScript(c, avantCreated, thenAudio); return; }
            window.podcastLog(c, 'Erreur réseau : ' + e.message);
            c.busy = null; c.error = 'Erreur réseau : ' + e.message; window.renderModal();
        });
    });
};
// L'audio se fait par tranches côté serveur : on rappelle jusqu'à « ready » (continue même si la modale est fermée)
window.actions.podcastGenerateAudio = function(force) {
    var c = window.state.modalConfig; if (!c || c.type !== 'podcast' || c.busy) return;
    c.busy = 'audio'; c.error = null; window.renderModal();
    var pc = window.podcastFor(c.n, c.part, c.pedia, c.explicatif);
    window.podcastLog(c, (force ? 'Nouvelle synthèse' : 'Synthèse vocale') + ' demandée' + (pc && pc.chunksTotal ? ' (' + (pc.chunksDone || 0) + ' / ' + pc.chunksTotal + ' répliques déjà faites)' : ''));
    if (window.player.key && pc && window.player.key === window.podcastKey(c.n, pc.slug)) window.actions.playerClose();
    window.podcastSuivi(c, true);
    var step = function(first) {
        var v = window.state.podcastVoices || {};
        var t0 = Date.now();
        window.podcastApi(Object.assign(window.podcastVariantPayload(c), { action: 'podcast_audio', voiceA: v.A || '', voiceB: v.B || '', force: !!(force && first) }))
        .then(function(res) {
            if (res.podcast) window.podcastUpsert(res.podcast);
            var pcR = res.podcast, sec = Math.round((Date.now() - t0) / 1000);
            if (pcR && !res.ready && res.success) window.podcastLog(c, 'Appel de ' + sec + ' s : ' + (pcR.chunksDone || 0) + ' / ' + (pcR.chunksTotal || '?') + ' répliques');
            // Une voix refusée par l'API a été remplacée : il faut le dire, sinon le podcast sort avec une autre voix
            // que celle choisie, sans un mot.
            if (res.voix_note) c.voixNote = res.voix_note;
            // Une synthèse tourne déjà (autre onglet, appel d'avant le rechargement) : on attend et on redemande.
            if (!res.success && res.en_cours) { c.attente = res.message || 'Synthèse déjà en cours : on attend.'; window.podcastLog(c, 'Une autre synthèse tient ce podcast : on attend 10 s'); window.renderModal(); setTimeout(function() { step(false); }, 10000); return; }
            if (!res.success) { window.podcastSuivi(c, false); c.busy = null; c.error = res.message || 'Échec de la synthèse vocale'; window.podcastLog(c, 'Échec : ' + c.error); window.renderModal(); window.renderContent(); return; }
            if (res.ready) { window.podcastSuivi(c, false); c.busy = null; c.attente = null; window.podcastLog(c, 'Audio prêt' + (pcR && pcR.duration ? ' : ' + window.fmtTime(pcR.duration) : '') + (res.voix_note ? ' · ' + res.voix_note : '')); window.renderModal(); window.renderContent(); return; }
            c.reprises = 0; c.attente = null; window.renderModal(); step(false);
        }).catch(function(e) {
            // Le serveur web a coupé (page HTML) : les tranches déjà synthétisées sont sur le serveur, on reprend
            // là où on en était, trois fois au plus.
            if (e && e.nonJson && (c.reprises = (c.reprises || 0) + 1) <= 3) { c.voixNote = null; c.attente = 'Connexion coupée par le serveur (' + e.message + ') : reprise de la synthèse là où elle en était (' + c.reprises + '/3)…'; window.podcastLog(c, 'Connexion coupée (' + e.message + ') : reprise ' + c.reprises + '/3 dans 3 s'); window.renderModal(); setTimeout(function() { step(false); }, 3000); return; }
            window.podcastSuivi(c, false);
            c.busy = null; c.error = 'Erreur réseau : ' + e.message + (e && e.nonJson ? ' — le serveur PHP s\'est arrêté en cours de route : regarde Gestion → Diagnostic de la base, « Dernières erreurs PHP ».' : ''); window.podcastLog(c, c.error); window.renderModal();
        });
    };
    c.reprises = 0; c.attente = null;
    step(true);
};
window.actions.podcastToggleScript = function() {
    var c = window.state.modalConfig; if (!c || c.type !== 'podcast') return;
    c.showScript = !c.showScript;
    if (c.showScript && !c.script) {
        window.podcastApi(Object.assign(window.podcastVariantPayload(c), { action: 'podcast_script_get' })).then(function(res) { if (res.success) { c.script = res.script || []; window.renderModal(); } }).catch(function() {});
    }
    window.renderModal();
};
// Fiche à suivre pendant l'écoute : rédigée d'après le script (même ordre), rangée sur le serveur à côté du podcast
// La fiche d'un script long demande plusieurs minutes : le serveur la rédige en arrière-plan et répond « en cours ».
// On la récupère alors par podcast_fiche_get, toutes les 10 s pendant 8 min au plus — comme pour les scripts.
window.podcastAttendreFiche = function(c, debut) {
    debut = debut || Date.now();
    c.busy = 'fiche'; c.error = null;
    c.attente = 'Le serveur rédige la fiche en arrière-plan : on l\'attend (' + Math.round((Date.now() - debut) / 1000) + ' s)…';
    window.renderModal();
    if (c.abandonAttente) { c.abandonAttente = false; c.busy = null; c.attente = null; window.podcastLog(c, 'Attente abandonnée.'); window.renderModal(); return; }
    var suite = function() { setTimeout(function() { window.podcastAttendreFiche(c, debut); }, 10000); };
    window.podcastApi(Object.assign(window.podcastVariantPayload(c), { action: 'podcast_fiche_get' })).then(function(res) {
        if (res.success && res.fiche && !res.en_cours) {
            c.busy = null; c.attente = null; window.podcastUpsert(res.podcast);
            c.fiche = res.fiche; c.showFiche = true; c.showScript = false;
            window.podcastLog(c, 'Fiche récupérée : ' + ((res.fiche.sections || []).length) + ' sections');
            window.renderModal(); window.renderContent(); return;
        }
        if (res.erreur) { c.busy = null; c.attente = null; c.error = 'Rédaction de la fiche échouée : ' + res.erreur; window.podcastLog(c, c.error); window.renderModal(); return; }
        if (!res.en_cours || Date.now() - debut > 8 * 60000) {
            c.busy = null; c.attente = null; c.error = res.en_cours ? 'La fiche n\'est toujours pas là après 8 min : réessaie plus tard.' : 'La rédaction de la fiche a été interrompue par le serveur (aucune fiche enregistrée) : réessaie, ou passe par un lot (Gestion → Lots), qui n\'a pas cette limite.';
            window.podcastLog(c, c.error); window.renderModal(); return;
        }
        var depuis = res.debut ? Math.round(Date.now() / 1000 - res.debut) : Math.round((Date.now() - debut) / 1000);
        window.podcastLog(c, 'Toujours en rédaction côté serveur (depuis ' + (depuis >= 60 ? Math.floor(depuis / 60) + ' min ' + (depuis % 60) + ' s' : depuis + ' s') + ')');
        suite();
    }).catch(function(e) { window.podcastLog(c, 'Sondage impossible (' + (e && e.message) + '), on réessaie'); suite(); });
};
window.actions.podcastFicheGenerate = function(force) {
    var c = window.state.modalConfig; if (!c || c.type !== 'podcast' || c.busy) return;
    c.busy = 'fiche'; c.error = null; c.attente = null; c.abandonAttente = false;
    window.podcastLog(c, (force ? 'Réécriture' : 'Rédaction') + ' de la fiche à suivre demandée'); window.renderModal();
    var charge = Object.assign(window.podcastVariantPayload(c), { action: 'podcast_fiche', itemTitle: c.itemTitle, force: !!force });
    if (c.forceFicheEnCours) { charge.force_encours = true; c.forceFicheEnCours = false; }
    window.podcastApi(charge).then(function(res) {
        // Rédaction lancée en arrière-plan (ou déjà en cours ailleurs) : on attend la fiche au lieu d'échouer.
        if (!res.success && res.en_cours) { window.podcastLog(c, res.detache ? 'Le serveur rédige la fiche en arrière-plan : on attend.' : 'Le serveur dit : ' + (res.message || 'en cours')); window.podcastAttendreFiche(c); return; }
        c.busy = null;
        if (!res.success) { c.error = res.message || 'Échec de la rédaction de la fiche'; window.podcastLog(c, 'Échec : ' + c.error); window.renderModal(); return; }
        window.podcastLog(c, 'Fiche reçue');
        window.podcastUpsert(res.podcast); c.fiche = res.fiche; c.showFiche = true; c.showScript = false;
        window.renderModal(); window.renderContent();
    }).catch(function(e) {
        // Page HTML du serveur web (« 500 Internal Server Error ») au lieu du résultat : PHP continue de rédiger
        // derrière, la fiche sera enregistrée — on l'attend plutôt que d'annoncer un échec.
        if (e && e.nonJson) { window.podcastLog(c, 'Connexion coupée par le serveur (' + e.message + ') : la rédaction continue, on attend la fiche.'); window.podcastAttendreFiche(c); return; }
        c.busy = null; c.attente = null; c.error = 'Erreur réseau : ' + e.message; window.podcastLog(c, c.error); window.renderModal();
    });
};
window.actions.podcastToggleFiche = function() {
    var c = window.state.modalConfig; if (!c || c.type !== 'podcast') return;
    c.showFiche = !c.showFiche; if (c.showFiche) c.showScript = false;
    if (c.showFiche && !c.fiche) {
        window.podcastApi(Object.assign(window.podcastVariantPayload(c), { action: 'podcast_fiche_get' })).then(function(res) { if (res.success) { c.fiche = res.fiche || false; window.renderModal(); } }).catch(function() {});
    }
    window.renderModal();
};
window.podcastFicheMarkdown = function(f, title) {
    var out = ['# ' + (f.titre || title || 'Fiche podcast'), f.intro ? '_' + f.intro + '_' : '', ''];
    (f.sections || []).forEach(function(sec, i) {
        out.push('## ' + (i + 1) + '. ' + sec.titre + (sec.paragraphes ? '  (¶ ' + sec.paragraphes + ')' : ''));
        (sec.points || []).forEach(function(pt) { out.push('- [ ] ' + pt); });
        if ((sec.aRetenir || []).length) { out.push(''); out.push('**À retenir :** ' + sec.aRetenir.join(' · ')); }
        if (sec.piege) out.push('**Piège EDN :** ' + sec.piege);
        out.push('');
    });
    if ((f.recap || []).length) { out.push('## Récap chiffres'); out.push('| Quoi | Valeur |'); out.push('|---|---|'); f.recap.forEach(function(r) { out.push('| ' + r.label + ' | ' + r.valeur + ' |'); }); }
    return out.join('\n');
};
window.actions.podcastFicheCopy = function() {
    var c = window.state.modalConfig; if (!c || !c.fiche) return;
    var md = window.podcastFicheMarkdown(c.fiche, c.itemTitle);
    var done = function() { c.ficheMsg = 'Fiche copiée : colle-la dans Notes, GoodNotes, Notability… sur ton iPad.'; window.renderModal(); setTimeout(function() { if (window.state.modalConfig === c) { c.ficheMsg = null; window.renderModal(); } }, 4000); };
    // Sans presse-papiers (navigateur ancien, page non sécurisée), la fiche est montrée telle quelle, à
    // sélectionner et copier à la main : jamais prompt(), qui fige la page et tronque un texte long.
    var manuelle = function() {
        if (window.dialogue && window.dialogue.alerter) window.dialogue.alerter({ titre: 'Copie manuelle', message: md, ok: 'Fermer' });
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(md).then(done, manuelle);
    else manuelle();
};
window.actions.podcastFichePrint = function() {
    var c = window.state.modalConfig; if (!c || !c.fiche) return;
    var el = document.getElementById('podcast-fiche'); if (!el) return;
    var w = window.open('', '_blank'); if (!w) return;
    w.document.write('<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8"><title>' + window.escapeHtml(c.fiche.titre || c.itemTitle) + '</title><link rel="stylesheet" href="app.css"><style>body{font-family:-apple-system,Helvetica,Arial,sans-serif;padding:24px;max-width:800px;margin:auto} @media print{button{display:none}}</style></head><body>' + el.innerHTML + '</body></html>');
    w.document.close(); setTimeout(function() { w.focus(); w.print(); }, 400);
};
window.actions.podcastDelete = function() {
    var c = window.state.modalConfig; if (!c || c.type !== 'podcast' || c.busy) return;
    var pc = window.podcastFor(c.n, c.part, c.pedia, c.explicatif); if (!pc) return;
    confirmerPuis({
        titre: 'Supprimer ce podcast ?',
        message: 'Le script et l\'audio sont retirés du serveur. Il faudra les refaire pour réécouter cet item.',
        ok: 'Supprimer', danger: true,
    }, function() {
        if (window.player.key === window.podcastKey(c.n, pc.slug)) window.actions.playerClose();
        window.podcastApi(Object.assign(window.podcastVariantPayload(c), { action: 'podcast_delete' })).then(function() {
            window.podcastRemove(c.n, pc.slug); c.script = null; c.showScript = false;
            window.renderModal(); window.renderContent();
            if (window.toast) window.toast('Podcast supprimé du serveur', { icone: 'check' });
        }).catch(function() {});
    });
};
window.actions.podcastPlayFromModal = function() {
    var c = window.state.modalConfig; if (!c || c.type !== 'podcast') return;
    var pc = window.podcastFor(c.n, c.part, c.pedia, c.explicatif); if (!pc || pc.status !== 'ready') return;
    window.actions.playPodcast(c.n, pc.slug, '#' + c.n + ' ' + c.itemTitle + (c.part ? ' · ' + c.part : '') + (c.pedia ? ' · renforcement pédiatrie' : '') + (c.explicatif ? ' · explicatif' : ''));
    window.renderModal();
};

// Lecteur global : lecture/pause, −10 s / +15 s, vitesse (1 → 2×), barre de progression ; position et vitesse enregistrées sur le serveur
window.player = { audio: null, key: null, n: null, slug: null, title: '', error: null, lastSave: 0, metaDuration: 0 };
// durée : celle du navigateur si elle est connue et finie, sinon celle calculée par le serveur (trames comptées)
window.playerDuration = function() { var a = window.player.audio; return (a && isFinite(a.duration) && a.duration > 0) ? a.duration : (window.player.metaDuration || 0); };
// Vitesses proposées. Les ralenties (0,5× et 0,75×) servent autant que les accélérées : réécouter un passage
// dense, ou suivre une énumération de chiffres sans revenir en arrière trois fois.
window.PLAYER_SPEEDS = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
window.playerAudio = function() {
    if (window.player.audio) return window.player.audio;
    var a = new Audio(); a.preload = 'metadata';
    a.addEventListener('loadedmetadata', function() {
        var pos = window.state.podcastPos[window.player.key];
        var d0 = window.playerDuration();
        if (pos && d0 && pos < d0 - 5) { try { a.currentTime = pos; } catch (e) {} }
        window.renderPlayerBar();
    });
    a.addEventListener('durationchange', function() { window.renderPlayerBar(); });
    a.addEventListener('play', function() { window.player.error = null; window.renderPlayerBar(); window.refreshPodcastButtons(); });
    a.addEventListener('pause', function() { window.savePlayerPos(); window.renderPlayerBar(); window.refreshPodcastButtons(); });
    a.addEventListener('ended', function() { if (window.player.key) { window.state.podcastPos[window.player.key] = 0; window.savePrefs(); } window.renderPlayerBar(); window.refreshPodcastButtons(); });
    a.addEventListener('timeupdate', function() {
        window.updatePlayerTime();
        var now = Date.now();
        if (!a.paused && now - window.player.lastSave > 30000) { window.player.lastSave = now; window.savePlayerPos(); }
    });
    a.addEventListener('error', function() { if (window.player.key) { window.player.error = "Le fichier est introuvable ou illisible sur le serveur. Choisis un autre épisode, ou relance la synthèse depuis la fenêtre du podcast."; window.renderPlayerBar(); } });
    window.player.audio = a;
    return a;
};
window.savePlayerPos = function() {
    var a = window.player.audio; if (!a || !window.player.key || !isFinite(a.currentTime)) return;
    window.state.podcastPos[window.player.key] = Math.floor(a.currentTime);
    window.savePrefs();
};
window.actions.playPodcast = function(n, slug, title) {
    var a = window.playerAudio(), key = window.podcastKey(n, slug);
    if (window.player.key === key) { if (a.paused) { a.play().catch(function() {}); } else { a.pause(); } return; }
    if (window.player.key) window.savePlayerPos();
    var meta = window.podcastBySlug(n, slug);
    window.player.key = key; window.player.n = String(n); window.player.slug = slug; window.player.title = title || ('Item ' + n); window.player.error = null; window.player.lastSave = Date.now(); window.player.metaDuration = meta && meta.duration ? meta.duration : 0;
    a.src = window.podcastUrl(n, slug);
    a.playbackRate = window.state.podcastSpeed || 1;
    if (meta) window.autoStartTaskTimer(n, meta.pedia ? '' : (meta.part || ''), !!meta.pedia);
    a.play().catch(function() {});
    window.renderPlayerBar(); window.refreshPodcastButtons();
};
window.actions.playPodcastEl = function(el) { window.actions.playPodcast(el.getAttribute('data-n'), el.getAttribute('data-slug'), el.getAttribute('data-title')); };
window.actions.playerToggle = function() { var a = window.player.audio; if (!a || !window.player.key) return; if (a.paused) { a.play().catch(function() {}); } else { a.pause(); } };
window.actions.playerSkip = function(sec) {
    var a = window.player.audio; if (!a || !window.player.key) return;
    var max = window.playerDuration() || Infinity;
    a.currentTime = Math.max(0, Math.min(max, a.currentTime + sec));
    window.updatePlayerTime();
};
window.actions.playerSpeed = function(v) {
    var cur = window.state.podcastSpeed || 1, idx = window.PLAYER_SPEEDS.indexOf(cur);
    var next = v ? parseFloat(v) : window.PLAYER_SPEEDS[(idx + 1) % window.PLAYER_SPEEDS.length];
    window.state.podcastSpeed = next; window.state.podcastSpeedSet = true;
    if (window.player.audio) window.player.audio.playbackRate = next;
    window.savePrefs(); window.renderPlayerBar();
};
window.actions.playerSeek = function(val) {
    var a = window.player.audio, d = window.playerDuration(); if (!a || !d) return;
    a.currentTime = d * (parseFloat(val) / 1000);
    window.updatePlayerTime();
};
window.actions.playerClose = function() {
    var a = window.player.audio;
    if (a) { window.savePlayerPos(); a.pause(); a.removeAttribute('src'); try { a.load(); } catch (e) {} }
    window.player.key = null; window.player.error = null;
    window.renderPlayerBar(); window.refreshPodcastButtons();
};
// La barre du lecteur, updatePlayerTime et refreshPodcastButtons vivent dans src/ui/components/lecteur.js
// (lot de clôture) : même élément d'accueil (#player-bar), mêmes noms, mêmes actions. La barre sombre à liseré
// ambre est partie avec eux, et le bas de page n'est plus poussé par document.body.style.paddingBottom : la
// barre mesure sa hauteur et la pose en --lecteur-h, c'est le CSS qui réserve la place.

// --- PODCASTS DU JOUR : écrire en série les scripts manquants / générer les audios manquants des items du jour ---
// (tâches en attente d'aujourd'hui et en retard, variante = celle choisie dans la fenêtre Podcast : révision ou explicatif)
window.podcastScopesFor = function(tasks) {
    var seen = {}, out = [];
    (tasks || []).forEach(function(t) {
        if (t.status !== 'pending') return;
        var sc = window.taskPodcastScope(t), k = sc.n + '|' + (sc.pedia ? 'ped' : sc.part);
        if (seen[k]) return; seen[k] = 1; out.push(sc);
    });
    return out;
};
window.podcastBatchStatus = function(tasks) {
    var x = !!window.state.podcastExplicatif, scopes = window.podcastScopesFor(tasks), noScript = [], noAudio = [], ready = 0;
    scopes.forEach(function(sc) {
        var pc = window.podcastFor(sc.n, sc.part, sc.pedia, x);
        if (!pc) { noScript.push(sc); noAudio.push(sc); } else if (pc.status !== 'ready') noAudio.push(sc); else ready++;
    });
    return { scopes: scopes, noScript: noScript, noAudio: noAudio, ready: ready, explicatif: x };
};
window.dayTasksForPodcasts = function() {
    var td = window.todayStr();
    return window.state.tasks.filter(function(t) { return t.status === 'pending' && t.date && t.date <= td; });
};
// Bandeau du tableau de bord : des découpages calculés en lot attendent d'être appliqués. Le bouton les met
// directement dans le planning, sans passer par l'écran des lots — chaque item scindé étant replanifié à
// partir du jour où il était prévu.
// Devis audio : combien coûtera la synthèse de tous les scripts déjà écrits mais pas encore sonorisés.
// Le nombre de caractères est exact (il vient des scripts) ; le barème en crédits est réglable dans api.php,
// parce que le site ne peut pas le lire chez Mistral.
window.actions.podcastDevis = function() {
    var s = window.state;
    if (s.podcastDevisBusy) return;
    s.podcastDevisBusy = true; s.podcastDevis = null; window.renderContent();
    window.lotApi('podcast_estimate', {}, function(d) {
        s.podcastDevisBusy = false;
        s.podcastDevis = (d && d.success) ? d : { erreur: (d && d.message) || 'Devis impossible' };
        window.renderContent();
    });
};
window.actions.podcastDevisFermer = function() { window.state.podcastDevis = null; window.renderContent(); };
window.podcastEnsureScript = function(sc, x, cb) {
    if (window.podcastFor(sc.n, sc.part, sc.pedia, x)) { cb(null, false); return; }
    window.loadFicheStructure(function(structure) {
        var planInfo = window.buildFichePlanText(sc.n, structure), sections = [];
        if (sc.part && !sc.pedia) { var map = window.state.subPartSections[String(sc.n)]; if (map && map[sc.part]) sections = map[sc.part]; }
        var charge = { action: 'podcast_script', itemNumber: sc.n, itemTitle: sc.itemTitle, subPartTitle: sc.pedia ? '' : sc.part, pedia: !!sc.pedia, explicatif: !!x, matieres: sc.matieres || [], sections: sections, plan: (sc.part && !sc.pedia) ? '' : planInfo.plan };
        // Réponse « en cours » (rédaction détachée, ou serveur web qui a coupé) : on attend le script avant de passer au suivant.
        var attendre = function() { window.podcastSonderScript(charge, 0, function(err, pc) { if (err) { cb(err); return; } window.podcastUpsert(pc); cb(null, true); }); };
        window.podcastApi(charge)
        .then(function(res) { if (!res.success && res.en_cours) { attendre(); return; } if (!res.success) { cb(res.message || 'échec du script'); return; } window.podcastUpsert(res.podcast); cb(null, true); })
        .catch(function(e) { if (e && e.nonJson) { attendre(); return; } cb('réseau : ' + e.message); });
    });
};
window.podcastEnsureAudio = function(sc, x, cb) {
    var pc = window.podcastFor(sc.n, sc.part, sc.pedia, x);
    if (pc && pc.status === 'ready') { cb(null, false); return; }
    var step = function() {
        var v = window.state.podcastVoices || {};
        window.podcastApi({ action: 'podcast_audio', itemNumber: sc.n, subPartTitle: sc.pedia ? '' : sc.part, pedia: !!sc.pedia, explicatif: !!x, voiceA: v.A || '', voiceB: v.B || '' })
        .then(function(res) {
            if (res.podcast) window.podcastUpsert(res.podcast);
            if (!res.success && res.en_cours) { setTimeout(step, 10000); return; } // une synthèse tourne déjà : on attend
            if (!res.success) { cb(res.message || 'échec de la synthèse'); return; }
            if (res.ready) { cb(null, true); return; }
            window.renderContent(); step();
        })
        .catch(function(e) { if (e && e.nonJson && (reprises++ < 3)) { setTimeout(step, 3000); return; } cb('réseau : ' + e.message); });
    };
    var reprises = 0;
    step();
};
window.actions.podcastBatch = function(kind) {
    if (window.state.podcastBatch) return;
    var st = window.podcastBatchStatus(window.dayTasksForPodcasts());
    var list = kind === 'script' ? st.noScript : st.noAudio;
    if (!list.length) return;
    if (kind === 'audio') {
        confirmerPuis({
            titre: 'Générer ' + list.length + ' podcast' + (list.length > 1 ? 's' : '') + (st.explicatif ? ' explicatif' + (list.length > 1 ? 's' : '') : '') + ' ?',
            message: 'La synthèse vocale Voxtral consomme des crédits ; les scripts manquants seront écrits d\'abord.',
            ok: 'Générer',
        }, function() { podcastBatchSuite(kind, st, list); });
        return;
    }
    podcastBatchSuite(kind, st, list);
};
function podcastBatchSuite(kind, st, list) {
    var b = window.state.podcastBatch = { kind: kind, total: list.length, done: 0, ok: 0, errors: [], current: null, phase: '', stop: false };
    window.state.podcastBatchLast = null;
    var i = 0;
    var finish = function() { window.state.podcastBatchLast = { kind: kind, ok: b.ok, errors: b.errors, stopped: b.stop && b.done < b.total, at: Date.now() }; window.state.podcastBatch = null; window.renderContent(); };
    var next = function() {
        if (b.stop || i >= list.length) { finish(); return; }
        var sc = list[i++]; b.current = sc.label; b.phase = 'script'; window.renderContent();
        window.podcastEnsureScript(sc, st.explicatif, function(err) {
            if (err) { b.errors.push(sc.label + ' : ' + err); b.done++; next(); return; }
            if (kind === 'script') { b.ok++; b.done++; next(); return; }
            b.phase = 'audio'; window.renderContent();
            window.podcastEnsureAudio(sc, st.explicatif, function(err2) { if (err2) b.errors.push(sc.label + ' : ' + err2); else b.ok++; b.done++; next(); });
        });
    };
    next();
};
window.actions.podcastBatchStop = function() { if (window.state.podcastBatch) { window.state.podcastBatch.stop = true; window.renderContent(); } };

// Ordre d'une journée : séance rattrapée d'abord, puis ce qui reste à faire, puis les partiels qui approchent,
// puis le moins bien réussi. Le tri lui-même est dans window.trierSeancesDuJour (src/domain/tasks.js) ; ici on
// ne fait que lui donner accès au partiel d'une séance et à la maîtrise de son item.
// Le repère `rattrape` porte l'horodatage du rattrapage ; il ne sert qu'au tri et disparaît au cochage.
window.sortTasksForExams = function(list) {
    var table = window.computeMastery ? window.computeMastery() : null;
    var rienAClasser = !list.some(function(t) { return t.rattrape; }) && !window.activeExams().length
        && (!table || !Object.keys(table).length);
    if (rienAClasser) return list;   // aucune observation, aucun partiel, aucun rattrapage : rien à réordonner
    return window.trierSeancesDuJour(list, window.examForTask, function(t) {
        // La maîtrise est tenue par item, pas par sous-partie : deux séances du même item se départagent donc
        // par leur ordre d'origine, ce qui est le bon comportement par défaut.
        return window.prioriteReussite(table ? table[String(t.baseItemId || t.itemId)] : null);
    });
};

window.initApp = function() {
    window.stopperAvertissementJs();
    window.routeInit(); // l'onglet de départ vient de l'adresse, avant le premier rendu
    var warn = document.getElementById('fallback-loading');
    if (warn) warn.style.display = 'none';
    document.getElementById('app-shell').style.display = 'block';

    window.purgerCopiesLocales(); // les anciennes copies de secours du navigateur ne servent plus : effacées
    window.state.plannings = window.loadPlanningsMetaLocal();
    window.state.currentPlanningId = localStorage.getItem('edn_current_planning_id') || window.state.plannings[0].id;

    // Ordre strict : liste des plannings → préférences (planning ouvert en dernier, sur n'importe quel appareil) → tâches.
    // Auparavant get_tasks partait en parallèle avec l'identifiant mémorisé par CE navigateur (« default » sur un
    // appareil neuf) : la liste serveur corrigeait l'identifiant trop tard et le planning s'affichait vide.
    var loadTasksForCurrentPlanning;
    window.chargerMoi();   // en parallèle : rôle et abonnement, pour n'afficher que ce qu'on peut faire
    if (window.PAGE === 'abonnement') window.abonnementRetour();
    // La liste des plannings et les préférences ne dépendent pas l'une de l'autre : elles partent ENSEMBLE, et les
    // tâches partent quand les deux sont là — c'est le seul ordre qui compte (l'identifiant du planning ouvert vient
    // des préférences, et doit exister dans la liste). Avant, les trois s'enchaînaient : un aller-retour de plus à
    // chaque ouverture, sur un hébergement où chacun coûte une centaine de millisecondes.
    var listeRecue = false, prefsRecues = null, tachesLancees = false;
    var quandLesDeux = function() {
        if (!listeRecue || prefsRecues === null || tachesLancees) return;
        tachesLancees = true;
        var pd = prefsRecues;
        var pref = pd && pd.success && pd.prefs ? pd.prefs.currentPlanningId : null;
        if (pref && pref !== window.state.currentPlanningId && window.state.plannings.some(function(p){ return p.id === pref; })) {
            window.state.currentPlanningId = pref;
            localStorage.setItem('edn_current_planning_id', pref);
            window.renderPlanningBar();
        }
        // Sous-parties perdues autrefois : réinjectées une seule fois, APRÈS les préférences du serveur (sinon,
        // l'état étant vide au départ, tous les items les recevraient).
        if (pd && pd.success) window.restoreLostSubParts();
        loadTasksForCurrentPlanning();
    };
    window.syncWithServer('list_plannings', {}, function(data) {
        if (data.plannings && Array.isArray(data.plannings) && data.plannings.length) {
            window.state.plannings = data.plannings;
            window.savePlanningsMetaLocal(window.state.plannings);
            if (!window.state.plannings.some(function(p){ return p.id === window.state.currentPlanningId; })) {
                window.state.currentPlanningId = window.state.plannings[0].id;
                localStorage.setItem('edn_current_planning_id', window.state.currentPlanningId);
            }
        } else if (data.logged_in !== false) {
            // Pas encore de planning référencé côté serveur : on enregistre celui par défaut.
            window.syncWithServer('create_planning', { planning_id: window.state.currentPlanningId, name: (window.state.plannings[0] && window.state.plannings[0].name) || 'Planning 1' });
        }
        window.renderPlanningBar();
        listeRecue = true; quandLesDeux();
    });
    window.loadPrefsFromServer(function(pd) { prefsRecues = pd || {}; quandLesDeux(); });

    loadTasksForCurrentPlanning = function() {
    window.syncWithServer('get_tasks', {}, function(data) {
        window.state.isLoading = false;
        // Lecture impossible alors que la session est ouverte : réponse refusée (planning illisible en base),
        // erreur PHP (mémoire, délai) ou serveur injoignable sans copie déjà à l'écran. L'écran ne doit ni montrer
        // un planning vide comme si c'était la vérité, ni renvoyer à l'écran de connexion : il dit ce qui se passe
        // et bloque tout enregistrement jusqu'au prochain rechargement réussi.
        var sessionOuverte = data.logged_in === true || (data.logged_in !== false && (data.php_error || data.offline) && localStorage.getItem('edn_logged_in') === 'true');
        var lectureRatee = sessionOuverte && (data.success === false || data.php_error || !Array.isArray(data.tasks) || (data.offline && !(window.state.tasks || []).length));
        if (lectureRatee) {
            window.state.isAuthenticated = true;
            window.state.planningIndisponible = data.offline ? 'serveur injoignable' : (data.message || 'réponse du serveur incomplète');
            window.state.tasks = [];
            window.messageServeur('Le planning n\'a pas pu être chargé : ' + window.state.planningIndisponible + ' — rien n\'est perdu sur le serveur, recharge la page.', true);
            window.renderApp();
            return;
        }
        if(data.logged_in) {
            window.state.isAuthenticated = true;
            window.state.planningIndisponible = null;
            var loadedTasks = window.assainirTaches(data.tasks);

            var uniqueMap = {};
            var cleanedTasks = [];
            var cleaned = false;
            loadedTasks.forEach(function(t) {
                var bId = t.baseItemId || t.itemId;
                var key = t.isDouble ? (bId + "_" + t.type + "_bis") : (t.itemId + "_" + t.type + "_main");
                if(!uniqueMap[key]) {
                    uniqueMap[key] = true;
                    cleanedTasks.push(t);
                } else {
                    cleaned = true;
                }
            });

            window.state.tasks = cleanedTasks;
            if(cleaned) {
                window.syncWithServer('save_tasks', { tasks: cleanedTasks });
            }
            if(window.initLearning) window.initLearning();
            // Lots en cours ou terminés : la pastille du bouton « Lots » doit être juste dès l'ouverture.
            // Chacune de ces réponses redessine le contenu ; regroupées dans une même image (renderContentBientot), la
            // page ne clignote pas trois fois de suite à l'ouverture.
            window.lotApi('batch_list', {}, function(d) { if (d && d.success) { window.state.lots.list = d.batches || []; window.renderHeader(); window.renderContentBientot(); } });
            window.loadPodcastIndex(function() { window.renderContentBientot(); });
            window.loadFicheStructure(function() { window.renderContentBientot(); });
            setTimeout(function() { if (window.anyTimerRunning()) window.ensureTimerTick(); }, 2500);
        }
        window.renderApp();
    });
    };

};

window.actions.calPlusDeJours = function(n) { window.state.calJours += (n || 7); window.renderContent(); };
window.actions.calTogglePasses = function() { window.state.calPasses = !window.state.calPasses; window.renderContent(); window.calAllerAAujourdhui(); };


window.actions.openManageSubParts = function(itemId) {
    var itemDef = window.itemById(itemId);
    if(!itemDef) return;
    var currentParts = window.state.subParts[itemId] ? window.state.subParts[itemId].join('\n') : '';
    var suggested = false;
    if (!currentParts) {
        var fd0 = window.getFicheData(itemId);
        if (fd0 && fd0.parts && fd0.parts.length >= 2) {
            currentParts = fd0.parts.join('\n');
            suggested = true;
        }
    }
    window.state.modalConfig = {
        type: 'manage_subparts',
        title: 'Gérer les sous-parties',
        // Une phrase, puis le détail sous le champ : la fenêtre du système ne s'ouvre pas sur un pavé gris.
        message: 'Chaque sous-partie de « ' + itemDef.titre + ' » sera planifiée sur un jour différent. Si l\'item est déjà au planning, ses séances sont remplacées et étalées jour par jour.',
        suggestion: suggested ? "Répartition proposée d'après les grandes parties de la fiche — modifie-la librement." : '',
        inputValue: currentParts,
        itemId: itemId,
        onConfirm: function(val) {
            var parts = val.split('\n').map(function(s){return s.trim();}).filter(function(s){return s.length > 0;});
            if(parts.length > 0) {
                window.actions.executeSplit(itemId, parts);
            } else {
                if (window.fusionnerDecksSousParties && window.fusionnerDecksSousParties(itemId, window.state.subParts[itemId] || [])) window.saveLearning();
                delete window.state.subParts[itemId];
                window.actions.saveSubParts();
                window.state.modalConfig = null;
                window.renderModal();
                if(window.state.activeTab === 'catalogue') window.renderCatalogueList();
            }
        }
    };
    window.renderModal();
};

window.actions.openSplitPromptFromTask = function(taskId) {
    var task = window.state.tasks.find(function(t){ return t.id === taskId; });
    if(!task) return;
    var baseItemId = task.baseItemId || task.itemId;
    var currentParts = window.state.subParts[baseItemId] ? window.state.subParts[baseItemId].join('\n') : '';
    var suggested = false;
    if (!currentParts) {
        var fd0 = window.getFicheData(baseItemId);
        if (fd0 && fd0.parts && fd0.parts.length >= 2) {
            currentParts = fd0.parts.join('\n');
            suggested = true;
        }
    }

    window.state.modalConfig = {
        type: 'split',
        title: 'Scinder l\'item',
        message: 'Chaque sous-partie de « ' + task.titre + ' » sera planifiée sur un jour différent.',
        suggestion: suggested ? "Répartition proposée d'après les grandes parties de la fiche — modifie-la librement." : '',
        inputValue: currentParts,
        taskId: task.id,
        onConfirm: function(val) {
            var parts = val.split('\n').map(function(s){return s.trim();}).filter(function(s){return s.length > 0;});
            // La garde parle par un toast et laisse la saisie en place : un alert() figeait la page et faisait
            // perdre le curseur au milieu d'une liste de parties.
            if(parts.length < 2) {
                if (window.toast) window.toast('Il faut au moins deux sous-parties, une par ligne', { type: 'danger', icone: 'warning-circle' });
                var zone = document.getElementById('split-parties'); if (zone) zone.focus();
                return;
            }
            window.actions.executeSplit(baseItemId, parts);
        }
    };
    window.renderModal();
};

// Reconstruit la séquence de révisions d'un item scindé : une séance J0 par sous-partie (décalées d'un jour),
// puis les révisions de la règle d'espacement. Fonction pure : elle rend un nouveau tableau de tâches et ne
// touche à rien — c'est l'appelant qui enregistre, ce qui permet d'appliquer plusieurs items d'un lot en un
// seul enregistrement, donc en une seule annulation.
// Jour où repart la séquence d'un item : sa première séance ENCORE À FAIRE. Prendre la toute première date
// renverrait dans le passé pour un item déjà entamé, et les nouvelles séances naîtraient en retard ; un départ
// passé est donc ramené à aujourd'hui. Un item sans aucune séance part d'aujourd'hui.
window.splitDepart = function(sequenceTasks) {
    var aFaire = sequenceTasks.filter(function(t) { return t.status !== 'done'; });
    var depart = (aFaire.length ? aFaire : sequenceTasks).map(function(t) { return t.date; }).sort()[0] || window.todayStr();
    return depart < window.todayStr() ? window.todayStr() : depart;
};
// Une séance J0 au jour donné, puis ses révisions selon la règle d'espacement du score.
// depuisJ (facultatif) : les révisions à partir de ce J ne sont pas engendrées ici (elles le sont en un bloc pour
// l'item entier, voir splitBlocTardif) ; sansJ0 : révisions seulement, pour le bloc.
window.splitSequence = function(itemDef, baseItemId, pId, pTitre, dateStr, stamp, depuisJ, sansJ0) {
    var out = [], pDate = window.parseDateLocal(dateStr);
    var rule = window.regleEspacement(itemDef.score);
    var base = { itemId: pId, baseItemId: baseItemId, titre: pTitre, matiere: itemDef.matiere, score: itemDef.score, status: 'pending', isDouble: false };
    if (!sansJ0) out.push(Object.assign({ id: pId + "_J0_" + stamp, type: 'J0', date: window.toYYYYMMDD(pDate) }, base));
    rule.forEach(function(d) {
        if (depuisJ && d >= depuisJ) return;
        if (d > window.state.maxJLimit && !window.state.isLoopMode) return;
        var nD = new Date(pDate); nD.setDate(nD.getDate() + d);
        var tType = d > window.state.maxJLimit ? 'Loop' : 'J' + d;
        out.push(Object.assign({ id: pId + "_" + tType + "_" + stamp, type: tType, date: window.toYYYYMMDD(nD) }, base));
    });
    return out;
};
window.splitRebuildTasks = function(tasks, baseItemId, partsArray) {
    baseItemId = String(baseItemId);
    var itemDef = window.itemById(baseItemId);
    if (!itemDef) return null;
    var sequenceTasks = tasks.filter(function(t) { return String(t.baseItemId || t.itemId) === baseItemId && !t.isDouble; });
    // La première sous-partie prend la place de l'item d'origine, les suivantes s'enchaînent un jour après
    // l'autre, chacune avec ses révisions.
    var stDate = window.parseDateLocal(window.splitDepart(sequenceTasks));
    var newTasks = tasks.filter(function(t) { return !(String(t.baseItemId || t.itemId) === baseItemId && !t.isDouble); });
    var stamp = Date.now();
    var depuisJ = (partsArray.length > 1 && window.state.blocDepuisJ > 0) ? window.state.blocDepuisJ : 0;
    var pas = window.state.pasJ0 === 2 ? 2 : 1;
    partsArray.forEach(function(partName, idx) {
        var pDate = new Date(stDate); pDate.setDate(pDate.getDate() + idx * pas);
        newTasks = newTasks.concat(window.splitSequence(itemDef, baseItemId, baseItemId + "_p" + stamp + idx, itemDef.titre + " [" + partName + "]", window.toYYYYMMDD(pDate), stamp, depuisJ));
    });
    if (depuisJ) newTasks = newTasks.concat(window.splitBlocTardif(itemDef, baseItemId, stDate, partsArray.length, depuisJ, stamp, pas));
    return newTasks;
};
// Révisions tardives en un seul bloc : à partir de depuisJ, une tâche pour l'item entier, datée depuis le J0 de la
// dernière sous-partie (toutes ont alors eu leurs premières révisions).
window.splitBlocTardif = function(itemDef, baseItemId, stDate, nParts, depuisJ, stamp, pas) {
    var derniere = new Date(stDate); derniere.setDate(derniere.getDate() + (nParts - 1) * (pas === 2 ? 2 : 1));
    var rule = window.regleEspacement(itemDef.score), out = [];
    rule.forEach(function(d) {
        if (d < depuisJ) return;
        if (d > window.state.maxJLimit && !window.state.isLoopMode) return;
        var nD = new Date(derniere); nD.setDate(nD.getDate() + d);
        var tType = d > window.state.maxJLimit ? 'Loop' : 'J' + d;
        out.push({ id: baseItemId + "_" + tType + "_bloc_" + stamp, itemId: baseItemId, baseItemId: baseItemId, titre: itemDef.titre, matiere: itemDef.matiere, score: itemDef.score, type: tType, date: window.toYYYYMMDD(nD), status: 'pending', isDouble: false, bloc: true });
    });
    return out;
};
// Opération inverse : les sous-parties disparaissent, l'item retrouve UNE séquence, à partir du jour de la
// première sous-partie encore à faire (donc sans rien perdre de sa place dans le planning).
window.splitUndoTasks = function(tasks, baseItemId) {
    baseItemId = String(baseItemId);
    var itemDef = window.itemById(baseItemId);
    if (!itemDef) return null;
    var sequenceTasks = tasks.filter(function(t) { return String(t.baseItemId || t.itemId) === baseItemId && !t.isDouble; });
    if (!sequenceTasks.length) return tasks; // rien de planifié : il n'y a que les sous-parties à oublier
    var depart = window.splitDepart(sequenceTasks);
    var newTasks = tasks.filter(function(t) { return !(String(t.baseItemId || t.itemId) === baseItemId && !t.isDouble); });
    return newTasks.concat(window.splitSequence(itemDef, baseItemId, baseItemId, itemDef.titre, depart, Date.now()));
};
window.actions.executeSplit = function(baseItemId, partsArray) {
    baseItemId = String(baseItemId);
    if (!window.itemById(baseItemId)) return;
    window.state.subParts[baseItemId] = partsArray;
    // Validé depuis la modale Scinder : le découpage est désormais celui de l'étudiant, plus celui d'un lot.
    if (window.state.splitLots[baseItemId]) { delete window.state.splitLots[baseItemId]; window.storageSet('edn_split_lots', JSON.stringify(window.state.splitLots)); }
    window.actions.saveSubParts();
    var newTasks = window.splitRebuildTasks(window.state.tasks, baseItemId, partsArray);
    window.state.tasks = newTasks;
    window.planningAction('Découpe d\'un item en sous-parties');
    window.syncWithServer('save_tasks', { tasks: newTasks }, function() {
        window.state.modalConfig = null;
        window.renderContent();
        window.renderModal();
        if(window.state.activeTab === 'catalogue') window.renderCatalogueList();
    });
};

// Lier un audio externe (lot B12) : une saisie dans le dialogue du système, jamais prompt(), qui fige la page,
// ignore la charte et tronque une URL longue. Renoncer rend null ; pour retirer un lien, le menu de la séance a
// son entrée « Retirer l'audio lié » (removePodcastLink).
window.actions.openPodcastPrompt = function(itemId) {
    var curr = window.state.tasks.find(function(t){ return t.itemId === itemId.toString(); });
    window.dialogue.demander({
        titre: 'Lier un audio externe',
        message: 'Colle le lien du fichier ou de la note : il s\'ouvrira depuis la séance.',
        label: 'Lien Google Drive ou NotebookLM',
        placeholder: 'https://…',
        valeur: (curr && curr.podcastLink) || '',
        ok: 'Lier cet audio',
    }).then(function(link) {
        if (link === null) return;
        var updated = window.state.tasks.map(function(t) {
            if(t.itemId === itemId.toString()) t.podcastLink = link.trim() || null;
            return t;
        });
        window.planningAction('Ajout d\'un lien de podcast');
        window.syncWithServer('save_tasks', { tasks: updated }, function() { window.renderContent(); });
        if (window.toast) window.toast('Audio externe lié à cette séance', { icone: 'check' });
    });
};

// ==========================================
// SOMMAIRE NOTEBOOKLM : consigne courte (≤ 500 caractères, champ « Personnaliser ») +
// sommaire détaillé (à coller comme source texte) construits à partir de la structure
// des fiches (fiche_structure.json, plan sur 3 niveaux avec rangs A/B et nombre de mots,
// issu de l'outil « Volumétrie des fiches EDN »). Tout se fait côté navigateur.
// ==========================================
window.FICHE_STRUCTURE = null;
window.loadFicheStructure = function(cb) {
    if (window.FICHE_STRUCTURE) { cb(window.FICHE_STRUCTURE); return; }
    fetch('fiche_structure.json').then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
    }).then(function(j) {
        window.FICHE_STRUCTURE = j || {};
        cb(window.FICHE_STRUCTURE);
    }).catch(function() {
        window.FICHE_STRUCTURE = {}; // fichier absent : on retombe sur les grandes parties de FICHE_DATA
        cb(window.FICHE_STRUCTURE);
    });
};

window.normalizeTitle = function(s) {
    return (s || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[’‘`]/g, "'").replace(/[^a-z0-9]+/g, ' ').trim();
};

// Retrouve la section de la fiche correspondant au nom d'une sous-partie (titres modifiables
// par l'utilisateur : comparaison normalisée, exacte puis par inclusion, puis au niveau 2).
window.findFichePart = function(tree, subPartTitle) {
    var target = window.normalizeTitle(subPartTitle);
    if (!target) return null;
    var i, j, n;
    for (i = 0; i < tree.length; i++) {
        if (window.normalizeTitle(tree[i].t) === target) return tree[i];
    }
    var best = null, bestLen = 0;
    for (i = 0; i < tree.length; i++) {
        n = window.normalizeTitle(tree[i].t);
        if (!n) continue;
        if (n.indexOf(target) !== -1 || target.indexOf(n) !== -1) {
            var len = Math.min(n.length, target.length);
            if (len > bestLen) { best = tree[i]; bestLen = len; }
        }
    }
    if (best) return best;
    for (i = 0; i < tree.length; i++) {
        var c = tree[i].c || [];
        for (j = 0; j < c.length; j++) {
            if (window.normalizeTitle(c[j].t) === target) return c[j];
        }
    }
    return null;
};

// Lignes du plan : "1. Titre [rang A]" puis "   - Sous-titre", sur maxDepth niveaux.
window.outlineLines = function(nodes, maxDepth, depth) {
    depth = depth || 0;
    var lines = [], i = 0;
    (nodes || []).forEach(function(node) {
        var title = (node.t || '').trim();
        if (!title) return;
        i++;
        var rank = node.r === 'A' ? ' [rang A]' : (node.r === 'B' ? ' [rang B]' : '');
        lines.push((depth === 0 ? (i + '. ') : (new Array(depth + 1).join('   ') + '- ')) + title + rank);
        if (depth + 1 < maxDepth && node.c && node.c.length) {
            lines = lines.concat(window.outlineLines(node.c, maxDepth, depth + 1));
        }
    });
    return lines;
};

// Consigne pour le champ « Personnaliser » de NotebookLM (500 caractères max) : le titre de
// l'item est raccourci en premier si nécessaire, puis la fin des consignes.
window.buildConsigne = function(itemId, itemTitle, subPartTitle, pediatricFocus, maxLen) {
    var scope;
    if (pediatricFocus) scope = 'le versant PÉDIATRIQUE de l\'item EDN n°' + itemId + '{T} : nourrisson, enfant, adolescent, différences avec l\'adulte';
    else if (subPartTitle) scope = 'la partie « ' + subPartTitle + ' » de l\'item EDN n°' + itemId + '{T} : uniquement cette partie, exhaustivement';
    else scope = 'l\'item EDN n°' + itemId + '{T} en entier';
    var core = 'Podcast le plus long et complet possible sur ' + scope + '. Cours dense pour les EDN, sans bavardage ni résumé. Suis intégralement le plan de la source « Sommaire », point par point, sans rien sauter : définitions, physiopathologie, clinique, examens, seuils et chiffres clés, traitements et posologies, surveillance, pièges. Rang A indispensable, rang B aussi traité.';
    // Le titre est inséré sous la forme ' « Titre »' (4 caractères d'habillage) et raccourci si nécessaire ;
    // s'il ne reste pas au moins ~12 caractères utiles, on l'omet plutôt que d'afficher des guillemets vides.
    var budget = maxLen - (core.length - 3) - 4;
    var title = itemTitle || '';
    if (title.length > budget) title = budget >= 12 ? title.slice(0, budget - 1).trim() + '…' : '';
    var consigne = core.replace('{T}', title ? ' « ' + title + ' »' : '');
    if (consigne.length > maxLen) consigne = consigne.replace(' Rang A indispensable, rang B aussi traité.', '');
    if (consigne.length > maxLen) consigne = consigne.slice(0, maxLen - 1) + '…';
    return consigne;
};

window.buildSommaire = function(itemId, itemTitle, subPartTitle, pediatricFocus, structure) {
    var item = (structure || {})[itemId.toString()] || null;
    var tree = (item && item.tree) || [];
    var fd = window.getFicheData(itemId);
    if (!tree.length && fd && fd.parts) {
        tree = fd.parts.map(function(t) { return { t: t }; });
    }

    var subject, header = [], lines = [], note = null;
    if (pediatricFocus) {
        subject = 'Renforcement pédiatrie';
        var ped = tree.filter(function(n) { return /pediatr|enfant|nourrisson|adolescent|neonat|nouveau ne/.test(window.normalizeTitle(n.t)); });
        header.push('SOMMAIRE — Item EDN n°' + itemId + ' : ' + itemTitle);
        header.push('Sujet du podcast : RENFORCEMENT PÉDIATRIE (uniquement les aspects pédiatriques : nourrisson, enfant, adolescent, différences avec l\'adulte).');
        if (ped.length) {
            lines = window.outlineLines(ped, 3);
        } else {
            note = 'La fiche n\'a pas de section pédiatrique dédiée : extraire les aspects pédiatriques de chaque section du plan ci-dessous.';
            lines = window.outlineLines(tree, 2);
        }
    } else if (subPartTitle) {
        subject = subPartTitle;
        var node = window.findFichePart(tree, subPartTitle);
        var pn = window.fichePartNodes(itemId, tree, subPartTitle);
        header.push('SOMMAIRE — Item EDN n°' + itemId + ' : ' + itemTitle);
        if (pn && pn.nodes.length) {
            header.push('Partie à traiter : ' + subPartTitle + ' — sections de la fiche : ' + pn.sections.join(' ; ') + (pn.w ? ' (≈ ' + pn.w + ' mots)' : ''));
            lines = window.outlineLines(pn.nodes, 3);
        } else if (node && node.c && node.c.length) {
        header.push('Partie à traiter : ' + subPartTitle + (node && node.w ? ' (≈ ' + node.w + ' mots dans la fiche)' : ''));
            lines = window.outlineLines(node.c, 3);
        } else if (node) {
            header.push('Partie à traiter : ' + subPartTitle + (node.w ? ' (≈ ' + node.w + ' mots dans la fiche)' : ''));
            note = 'Cette partie n\'a pas de sous-sections dans la fiche : la développer intégralement.';
        } else {
            header.push('Partie à traiter : ' + subPartTitle);
            note = 'Partie non retrouvée telle quelle dans le plan de la fiche : s\'appuyer sur le plan complet ci-dessous et ne traiter que ce qui concerne « ' + subPartTitle + ' ».';
            lines = window.outlineLines(tree, 2);
        }
    } else {
        subject = 'Fiche complète';
        header.push('SOMMAIRE — Item EDN n°' + itemId + ' : ' + itemTitle + (item && item.w ? ' (≈ ' + item.w + ' mots)' : ''));
        header.push('Sujet du podcast : la fiche complète, dans l\'ordre du plan.');
        lines = window.outlineLines(tree, 3);
        if (!lines.length) note = 'Plan détaillé indisponible pour cet item : suivre l\'ordre de la fiche.';
    }
    header.push('Consigne : couvrir chaque point ci-dessous, dans l\'ordre, sans en omettre aucun. Rang A = indispensable, rang B = à connaître aussi. Pour chaque point : définitions, épidémiologie, physiopathologie, clinique, examens et critères diagnostiques, seuils et chiffres clés, traitements et posologies, surveillance, complications, pièges EDN.');

    var sommaire = header.concat(note ? ['', note] : [], lines.length ? ['', 'PLAN :'].concat(lines) : []).join('\n');
    return { subject: subject, consigne: window.buildConsigne(itemId, itemTitle, subPartTitle, pediatricFocus, 500), sommaire: sommaire };
};

window.fallbackCopy = function(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
};

// Copier un texte, et le dire. Le bouton porte ses deux libellés dans son balisage (.pl-copier) : on ne fait que
// poser data-copie le temps de le montrer, au lieu de lui réécrire son contenu — rien ne saute, rien ne se perd.
window.actions.copyToClipboard = function(text, btn) {
    var done = function() {
        if (window.toast) window.toast('Copié dans le presse-papiers', { icone: 'check' });
        if (!btn || !btn.setAttribute) return;
        btn.setAttribute('data-copie', '');
        clearTimeout(btn.__copieTimer);
        btn.__copieTimer = setTimeout(function() { btn.removeAttribute('data-copie'); }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function() { window.fallbackCopy(text); done(); });
    } else { window.fallbackCopy(text); done(); }
};

// partEnc : nom de la sous-partie encodé (encodeURIComponent) ou '' pour l'item entier.
window.actions.openSommaire = function(itemId, partEnc, pediatricFocus) {
    var itemDef = window.itemById(itemId);
    if (!itemDef) return;
    var subPartTitle = partEnc ? decodeURIComponent(partEnc) : null;
    window.loadFicheStructure(function(structure) {
        var r = window.buildSommaire(itemId, itemDef.titre, subPartTitle, !!pediatricFocus, structure);
        window.state.modalConfig = {
            type: 'sommaire',
            title: 'Sommaire NotebookLM — n°' + itemId,
            subtitle: '#' + itemId + ' ' + itemDef.titre + ' · ' + r.subject + '. Colle la consigne dans « Personnaliser » (500 caractères max) et le sommaire comme source « Texte copié » du notebook pour que le podcast suive tout le plan.',
            consigne: r.consigne,
            sommaire: r.sommaire,
            // Contexte conservé pour le bouton « Améliorer avec l'IA » (api.php, action ai_sommaire)
            itemId: itemId.toString(),
            itemTitle: itemDef.titre,
            subPartTitle: subPartTitle,
            pediatricFocus: !!pediatricFocus,
            baseConsigne: r.consigne,
            baseSommaire: r.sommaire,
            aiApplied: false,
            aiBusy: false,
            aiNote: null
        };
        window.renderModal();
    });
};

window.actions.openSommaireForTask = function(taskId) {
    var task = window.state.tasks.find(function(t){ return t.id === taskId; });
    if (!task) return;
    var searchId = task.baseItemId || task.itemId;
    var isPediatricBoost = !!(task.isDouble || task.id.includes('_bis'));
    var subPart = null;
    if (!isPediatricBoost && task.baseItemId) {
        var m = task.titre.match(/\[(.+)\]$/);
        if (m) subPart = m[1];
    }
    window.actions.openSommaire(searchId, subPart ? encodeURIComponent(subPart) : '', isPediatricBoost);
};

// L'échec de la génération se dit dans le dialogue du système, jamais dans un alert() : il nomme le problème et
// la reprise, et il n'emporte pas la fenêtre du sommaire, qui reste ouverte sur sa version standard.
function echecSommaireIA(titre, message) {
    if (window.dialogue && window.dialogue.alerter) { window.dialogue.alerter({ titre: titre, message: message }); return; }
    if (window.toast) window.toast(titre, { type: 'danger', icone: 'warning-circle' });
}

// « Améliorer avec l'IA » : api.php (action ai_sommaire) fait rédiger par l'API Claude une consigne
// optimisée (≤ 500 caractères) et un sommaire enrichi des notions clés EDN, à partir de la version standard.
window.actions.improveSommaireWithAI = function() {
    var c = window.state.modalConfig;
    if (!c || c.type !== 'sommaire' || c.aiBusy) return;
    c.aiBusy = true;
    window.renderModal();
    fetch('api.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            action: 'ai_sommaire',
            itemNumber: c.itemId,
            itemTitle: c.itemTitle,
            subPartTitle: c.subPartTitle,
            pediatricFocus: c.pediatricFocus,
            consigne: c.baseConsigne,
            sommaire: c.baseSommaire
        })
    }).then(function(r) { return r.json(); }).then(function(data) {
        var cur = window.state.modalConfig;
        if (!cur || cur.type !== 'sommaire') return;
        cur.aiBusy = false;
        if (data.success) {
            cur.consigne = data.consigne;
            cur.sommaire = data.sommaire;
            cur.aiApplied = true;
            cur.aiNote = (data.model || '') + (data.cached ? ' · en cache' : '');
        } else if (data.needs_api_key) {
            echecSommaireIA('Clé API Anthropic non configurée', 'Renseigne $anthropic_api_key en haut de api.php (console.anthropic.com > API keys), puis recommence.');
        } else {
            var detail = data.debug ? ('\n\nDétail : ' + (typeof data.debug === 'string' ? data.debug : JSON.stringify(data.debug))) : '';
            echecSommaireIA('Génération impossible', (data.message || 'Erreur inconnue') + detail);
        }
        window.renderModal();
    }).catch(function() {
        var cur = window.state.modalConfig;
        if (cur && cur.type === 'sommaire') { cur.aiBusy = false; window.renderModal(); }
        echecSommaireIA('Serveur injoignable', "La demande de génération n'a pas pu partir. Le sommaire standard reste utilisable tel quel.");
    });
};

window.actions.revertSommaireAI = function() {
    var c = window.state.modalConfig;
    if (!c || c.type !== 'sommaire') return;
    c.consigne = c.baseConsigne;
    c.sommaire = c.baseSommaire;
    c.aiApplied = false;
    c.aiNote = null;
    window.renderModal();
};

window.actions.removePodcastLink = function(itemId) {
    var updated = window.state.tasks.map(function(t) {
        if(t.itemId === itemId.toString()) t.podcastLink = null;
        return t;
    });
    window.planningAction('Retrait d\'un lien de podcast');
    window.syncWithServer('save_tasks', { tasks: updated }, function() { window.renderContent(); });
};


window.actions.doublePediatrie = function() {
    var added = 0;
    var newT = [].concat(window.state.tasks);
    var uIds = Array.from(new Set(window.state.tasks.map(function(t){return t.baseItemId || t.itemId;})));
    
    uIds.forEach(function(baseId) {
        var info = window.itemById(baseId);
        if(!info) return;
        // Un item dont la pédiatrie est la matière principale est déjà « pédiatrique » : pas de renforcement
        if(info.matiere !== 'Pédiatrie' && info.collegesSecondaires.includes('Pédiatrie')) {
            var hasGlobalDouble = newT.some(function(t){ return (t.baseItemId || t.itemId) === baseId && t.isDouble; });
            
            if(!hasGlobalDouble) {
                var tasksOfItem = newT.filter(function(t){ return (t.baseItemId || t.itemId) === baseId && !t.isDouble; });
                if(tasksOfItem.length > 0) {
                    var earliestDateStr = tasksOfItem.map(function(t){return t.date;}).sort()[0];
                    var stDate = window.parseDateLocal(earliestDateStr);
                    var rule = window.regleEspacement(info.score);
                    
                    newT.push({
                        id: baseId + "_J0_bis_" + Date.now() + Math.random().toString().substr(2,5),
                        itemId: baseId,
                        baseItemId: baseId,
                        titre: info.titre,
                        matiere: info.matiere,
                        score: info.score,
                        type: 'J0',
                        date: window.toYYYYMMDD(stDate),
                        status: 'pending',
                        isDouble: true
                    });
                    
                    rule.forEach(function(d) {
                        var nD = new Date(stDate); nD.setDate(nD.getDate() + d);
                        var typ = d > window.state.maxJLimit ? 'Loop' : 'J'+d;
                        if (d <= window.state.maxJLimit || window.state.isLoopMode) {
                            newT.push({
                                id: baseId + "_" + typ + "_bis_" + Date.now() + Math.random().toString().substr(2,5),
                                itemId: baseId,
                                baseItemId: baseId,
                                titre: info.titre,
                                matiere: info.matiere,
                                score: info.score,
                                type: typ,
                                date: window.toYYYYMMDD(nD),
                                status: 'pending',
                                isDouble: true
                            });
                        }
                    });
                    added++;
                }
            }
        }
    });
    if(added > 0) {
        window.state.tasks = newT;
        window.planningAction('Doublage des items de pédiatrie');
        window.syncWithServer('save_tasks', { tasks: newT }, function() { window.renderContent(); window.toast(added + ' item' + (added > 1 ? 's' : '') + ' de pédiatrie renforcé' + (added > 1 ? 's' : '')); });
    } else {
        window.toast('Aucun nouvel item de pédiatrie à renforcer');
    }
};

// Déplacer à la main (glisser-déposer, « Déplacer à une autre date ») : la séance va à la date choisie et toute
// la suite de sa séquence (window.memeSuite : sa sous-partie, ses révisions en bloc, pas le renforcement pédiatrie)
// recule ou avance du même nombre de jours. Les écarts entre J sont conservés.
window.actions.moveSelectedTasksToDate = function(targetDateStr) {
    var ids = window.state.selectedTaskIds;
    if(ids.length === 0) return;
    var tDate = window.parseDateLocal(targetDateStr);
    // Une référence par suite : la plus ancienne séance sélectionnée de cette suite donne le décalage.
    var refs = {};
    ids.forEach(function(id) {
        var tk = window.state.tasks.find(function(x){return x.id===id;});
        if (!tk) return;
        var cle = (tk.isDouble ? 'bis:' : '') + String(tk.itemId);
        if (!refs[cle] || tk.date < refs[cle].date) refs[cle] = tk;
    });
    var updated = window.state.tasks.slice(), bouge = {};
    Object.keys(refs).map(function(k) { return refs[k]; }).sort(function(a, b) { return a.date.localeCompare(b.date); }).forEach(function(ref) {
        var diffDays = Math.round((tDate.getTime() - window.parseDateLocal(ref.date).getTime()) / 86400000);
        if (diffDays === 0) return;
        updated = updated.map(function(t) {
            // une séance ne bouge qu'une fois, même si deux suites sélectionnées la réclament (sous-partie + bloc)
            if (bouge[t.id] || t.date < ref.date || !window.memeSuite(ref, t)) return t;
            bouge[t.id] = true;
            var dd = window.parseDateLocal(t.date); dd.setDate(dd.getDate() + diffDays);
            return Object.assign({}, t, { date: window.toYYYYMMDD(dd) });
        });
    });
    window.state.selectedTaskIds = [];
    window.planningAction('Déplacement de révisions');
    window.syncWithServer('save_tasks', { tasks: updated }, function() { window.renderContent(); });
};


// Cœur du lissage, sans effet de bord : rend la liste lissée à partir de dateDebut (jour par jour, l'excédent est
// décalé d'un jour avec toutes les révisions suivantes de l'item). Sert au bouton Lissage et à l'ordonnanceur.
window.actions.executeLissage = function(limit, priority) {
    var paliers = Array.isArray(limit) ? window.lissagePaliersNormalises(limit) : [{ jusquau: '', limite: Math.max(1, parseInt(limit, 10) || 1) }];
    // la journée finit à 4 h du matin : le lissage suit la même règle que le reste du site
    var tasks = window.lisserTaches(window.actions.fixJ0Collisions(window.state.tasks), paliers, priority, window.toYYYYMMDD(window.todayLogical()));
    tasks = window.actions.fixJ0Collisions(tasks);
    window.state.modalConfig = null;
    window.planningAction('Lissage du planning');
    window.syncWithServer('save_tasks', { tasks: tasks }, function() {
        window.renderContent();
        window.renderModal();
    });
};


// depuis : jour de départ du remplissage (AAAA-MM-JJ). Les jours antérieurs ne sont pas touchés, et rien ne
// remonte avant lui. Absent ou antérieur à aujourd'hui, on part d'aujourd'hui : remonter une séance dans le
// passé la rendrait en retard à l'instant même, ce que personne ne demande en intensifiant.
window.actions.executeIntensify = function(target, priority, depuis) {
    var tasks = window.actions.fixJ0Collisions(window.state.tasks);
    var maxIterations = 365;
    var aujourdhui = window.todayLogical(); // la journée finit à 4 h du matin, comme partout sur le site
    var currDateObj = aujourdhui;
    if (/^\d{4}-\d{2}-\d{2}$/.test(depuis || '')) {
        var choisi = window.parseDateLocal(depuis);
        if (choisi > aujourdhui) currDateObj = choisi;
    }
    var depart = window.toYYYYMMDD(currDateObj);

    while(maxIterations > 0) {
        var currDateStr = window.toYYYYMMDD(currDateObj);
        var tasksOnDate = tasks.filter(function(t){ return t.date === currDateStr && t.status === 'pending'; });
        var shortfall = target - tasksOnDate.length;

        if (shortfall > 0) {
            var futureTasks = tasks.filter(function(t) { return t.date.localeCompare(currDateStr) > 0 && t.status === 'pending'; });
            if (futureTasks.length === 0) break;

            var itemEarliest = {};
            futureTasks.forEach(function(t) {
                if (!itemEarliest[t.itemId] || t.date.localeCompare(itemEarliest[t.itemId].date) < 0) {
                    itemEarliest[t.itemId] = t;
                }
            });

            var candidates = Object.values(itemEarliest);
            candidates.sort(function(a, b) {
                // « Partiels » : les items des matières d'un partiel à venir passent devant, le partiel le plus proche
                // d'abord ; à partiel égal, les J0 (découvertes) avant les révisions, puis la date prévue.
                if (priority === 'partiels') {
                    var aEx = window.examForTask(a, currDateStr), bEx = window.examForTask(b, currDateStr);
                    if (!!aEx !== !!bEx) return aEx ? -1 : 1;
                    if (aEx && bEx && aEx.date !== bEx.date) return aEx.date.localeCompare(bEx.date);
                    var aN = a.type === 'J0' ? 0 : 1, bN = b.type === 'J0' ? 0 : 1;
                    if (aN !== bN) return aN - bN;
                }
                if (priority === 'new') {
                    var aJ0 = a.type === 'J0' ? 0 : 1;
                    var bJ0 = b.type === 'J0' ? 0 : 1;
                    if (aJ0 !== bJ0) return aJ0 - bJ0;
                } else if (priority === 'review') {
                    var aRev = a.type !== 'J0' ? 0 : 1;
                    var bRev = b.type !== 'J0' ? 0 : 1;
                    if (aRev !== bRev) return aRev - bRev;
                } else if (priority === 'score') {
                    if (a.score !== b.score) return b.score - a.score;
                }
                return a.date.localeCompare(b.date);
            });

            var j0BaseIdsToday = {};
            tasksOnDate.forEach(function(t) {
                if(t.type === 'J0' && !t.isDouble) {
                    var bId = t.baseItemId || t.itemId;
                    j0BaseIdsToday[bId] = true;
                }
            });

            // Une révision (J>0) ne remonte jamais trop près de la séance précédente de son item : au moins la moitié
            // de l'écart prévu est gardée (un J3 reste à 2 jours au moins de son J0). Sans ce garde-fou, remplir les
            // trous jour après jour ramenait le J3 au lendemain du J0 — la courbe de l'oubli était brisée.
            var plusTotPour = function(cand) {
                if (cand.type === 'J0') return null;
                var prev = null;
                tasks.forEach(function(t) { if (t.itemId === cand.itemId && t.id !== cand.id && t.date < cand.date && (!prev || t.date > prev.date)) prev = t; });
                if (!prev) return null;
                var ecart = Math.round((window.parseDateLocal(cand.date) - window.parseDateLocal(prev.date)) / 86400000);
                var d = window.parseDateLocal(prev.date); d.setDate(d.getDate() + Math.max(1, Math.ceil(ecart / 2)));
                return window.toYYYYMMDD(d);
            };
            var selectedCandidates = [];
            for(var i=0; i<candidates.length && selectedCandidates.length < shortfall; i++) {
                var candidate = candidates[i];
                var bId = candidate.baseItemId || candidate.itemId;
                
                if (candidate.type === 'J0' && !candidate.isDouble && j0BaseIdsToday[bId]) {
                    continue; 
                }
                var pasAvant = plusTotPour(candidate);
                if (pasAvant && pasAvant > currDateStr) continue;
                
                selectedCandidates.push(candidate);
                if (candidate.type === 'J0' && !candidate.isDouble) {
                    j0BaseIdsToday[bId] = true;
                }
            }

            selectedCandidates.forEach(function(refTask) {
                var refDate = window.parseDateLocal(refTask.date);
                var diffDays = Math.round((currDateObj.getTime() - refDate.getTime()) / (1000 * 3600 * 24));

                tasks = tasks.map(function(t) {
                    if (t.itemId === refTask.itemId && t.date.localeCompare(refTask.date) >= 0 && t.status === 'pending') {
                        var tDate = window.parseDateLocal(t.date);
                        tDate.setDate(tDate.getDate() + diffDays);
                        return Object.assign({}, t, { date: window.toYYYYMMDD(tDate) });
                    }
                    return t;
                });
            });
        }

        currDateObj.setDate(currDateObj.getDate() + 1);
        var maxDate = tasks.reduce(function(max, t){ return (t.status === 'pending' && t.date > max) ? t.date : max; }, "");
        if (window.toYYYYMMDD(currDateObj) > maxDate) break;
        maxIterations--;
    }

    tasks = window.actions.fixJ0Collisions(tasks);
    window.state.modalConfig = null;
    window.planningAction('Intensification du planning' + (depart !== window.todayStr() ? ' à partir du ' + window.formatDateFr(depart) : ''));
    window.syncWithServer('save_tasks', { tasks: tasks }, function() {
        window.renderContent();
        window.renderModal();
    });
};


// --- RENDERERS HTML DE L'INTERFACE ---


// --- CHARTE, NAVIGATION, ACCUEIL -----------------------------------------------------------------------------
// La mise en page « Quantro / Apple » : barre de navigation sombre et translucide, barre d'outils claire, pages
// en cartes très arrondies sur fond gris, sections sombres en fondu pour les moments forts, un seul accent.
// Deux modes, jour et nuit : les jetons sont dans app.css, theme.css rejoue dessus les classes du moteur.


// Après le rendu : les anneaux se remplissent, les blocs .reveal apparaissent en entrant à l'écran, les
// compteurs [data-count] comptent jusqu'à leur valeur. Sans support (ou mouvement réduit), tout est simplement là.
// Les animations ne jouent qu'à la PREMIÈRE peinture d'une page. Un redessin (réponse du serveur, case cochée,
// index des podcasts reçu) reconstruit le HTML : sans cette garde, anneaux, compteurs et cartes rejouaient leur
// entrée à chaque fois — c'était le « glitch » à l'arrivée sur Catalogue, Statistiques ou Aujourd'hui. Poser la
// valeur finale dans la même tâche que l'insertion du HTML ne déclenche aucune transition.
window.__premierRenduFait = false;
// Les anneaux, eux, entrent une fois PAR PAGE et non une fois par session : arriver sur Statistiques depuis
// Aujourd'hui, c'est bien arriver sur Statistiques pour la première fois, et le drapeau global __premierRenduFait
// (vrai dès la première peinture de n'importe quelle page) leur volait leur entrée. La garde est donc la route.
window.__entreeJouee = {};
window.animerAnneaux = function() {
    var els = document.querySelectorAll('.anneau-val[data-offset]');
    if (!els.length) return;
    var poser = function() { els.forEach(function(el) { el.style.strokeDashoffset = el.getAttribute('data-offset'); }); };
    var route = (window.state && window.state.activeTab) || '';
    if (window.__entreeJouee[route]) { poser(); return; }
    window.__entreeJouee[route] = true;
    requestAnimationFrame(function() { requestAnimationFrame(poser); });
};
window.animerReveal = function() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.reveal:not(.in)'));
    if (!els.length) return;
    if (window.__premierRenduFait || !('IntersectionObserver' in window)) { els.forEach(function(e) { e.classList.add('in'); }); return; }
    if (!window.__revealObs) window.__revealObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(en) { if (en.isIntersecting) { en.target.classList.add('in'); window.__revealObs.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function(e) { window.__revealObs.observe(e); });
};
window.animerCompteurs = function() {
    var reduit = false;
    try { reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    document.querySelectorAll('[data-count]').forEach(function(el) {
        var fin = parseFloat(el.getAttribute('data-count')) || 0, suffixe = el.getAttribute('data-suffixe') || '';
        if (reduit || fin === 0 || window.__premierRenduFait) { el.textContent = fin + suffixe; return; }
        var t0 = null, duree = 900;
        (function pas(t) {
            if (t0 === null) t0 = t;
            var k = Math.min(1, (t - t0) / duree), e = 1 - Math.pow(1 - k, 3);
            el.textContent = Math.round(fin * e) + suffixe;
            if (k < 1) requestAnimationFrame(pas);
        })(performance.now());
    });
};
window.animerContenu = function() {
    window.animerAnneaux(); window.animerReveal(); window.animerCompteurs();
    if (!window.__premierRenduFait) {
        var c = document.getElementById('main-content');
        if (c && c.children.length) {
            window.__premierRenduFait = true;
            // body.rendu coupe aussi les fondus CSS (.fade-in) des redessins, une fois le premier fondu joué
            setTimeout(function() { document.body.classList.add('rendu'); }, 450);
        }
    }
};

// ---------------------------------------------------------------- onglet Gestion (administrateur)
// Ce que le serveur détient : les collèges et les fiches EDN, ce qui a déjà été passé à l'OCR, et ce que ça coûte.
// Toutes les actions sont longues : elles avancent par tranches de pages, et la page montre l'avancement.
window.octets = function(o) {
    if (!o) return '—';
    if (o < 1024 * 1024) return Math.round(o / 1024) + ' Ko';
    return (o / 1024 / 1024).toFixed(1) + ' Mo';
};
window.actions.gestionCharger = function(force) {
    var g = window.state.gestion;
    if (g.chargement || (g.etat && !force)) return;
    g.chargement = true; g.erreur = null;
    window.syncWithServer('gestion_etat', {}, function(d) {
        g.chargement = false;
        if (d && d.success) g.etat = d; else g.erreur = (d && d.message) || 'État indisponible';
        window.renderContent();
        if (d && d.success && !g.lots) window.actions.gestionLotsEtat();   // les lots en cours, une fois l'inventaire là
    });
};
// OCR d'un document, tranche par tranche : on rappelle le serveur tant qu'il n'a pas fini.
window.actions.gestionOcr = function(genre, cle) {
    var g = window.state.gestion;
    if (g.busy) return;
    g.busy = genre + ':' + cle; g.erreur = null; g.message = null; g.progres = { fait: 0, total: 0 };
    window.renderContent();
    var tour = function() {
        var charge = genre === 'fiche' ? { genre: 'fiche', item: cle } : { genre: 'college', nom: cle };
        window.syncWithServer('ocr_document', charge, function(d) {
            if (!d || !d.success) {
                g.busy = ''; g.progres = null;
                g.erreur = (d && d.message) || "L'OCR n'a pas abouti";
                window.renderContent(); return;
            }
            g.progres = { fait: d.fait, total: d.total, cout: d.cout };
            if (!d.complet) { window.renderContent(); tour(); return; }
            g.busy = ''; g.progres = null;
            g.message = d.nom + ' : ' + d.fait + ' pages lues (' + (d.cout || 0).toFixed(3) + ' $)';
            g.etat = null; window.actions.gestionCharger(true);
        });
    };
    tour();
};
// Mode lot : tous les documents encore à lire partent d'un coup, à moitié prix, sans limite de temps.
window.actions.gestionLotCreer = function(genre) {
    var g = window.state.gestion;
    if (g.busy) return;
    g.busy = 'lot:' + genre; g.erreur = null; g.message = null; g.lotFerme = null; window.renderContent();
    window.syncWithServer('ocr_lot_creer', { genre: genre }, function(d) {
        g.busy = '';
        // Réponse incomplète (success sans `lot`) = échec : on l'annonce dans l'écran plutôt que de lever,
        // ce que window.onerror transformait en cadre rouge #crash-box sur toute la page.
        if (d && d.success && d.lot) { g.message = 'Lot envoyé : ' + d.lot.documents + ' document(s), moitié prix. Le résultat arrive tout seul, reviens plus tard.'; window.actions.gestionLotsEtat(); }
        else {
            // L'API par lots fermée sur le compte n'est pas une panne : le travail reste faisable, document par
            // document. On le dit, et on propose de le faire.
            if (d && d.lot_indisponible) g.lotFerme = { genre: genre, message: d.message };
            else g.erreur = (d && d.message) || "Le lot n'a pas pu partir";
            window.renderContent();
        }
    });
};
// Repli quand les lots ne sont pas ouverts : les documents encore à lire, un par un, à la file. Plein tarif — donc
// le prix est annoncé avant de commencer.
window.actions.gestionOcrTout = function(genre) {
    var g = window.state.gestion, e = g.etat;
    if (g.busy || !e) return;
    var liste = (genre === 'fiche' ? (e.fiches || []) : (e.colleges || []))
        .filter(function(x) { return !x.complet; })
        .map(function(x) { return genre === 'fiche' ? x.item : x.nom; });
    if (!liste.length) { g.message = 'Tout est déjà lu.'; window.renderContent(); return; }
    var prix = e.prix_1000_pages || 4;
    confirmerPuis({
        titre: 'Lire ' + liste.length + ' document(s) un par un ?',
        message: 'Au plein tarif (' + prix + ' $ les 1 000 pages — le lot les aurait passés à moitié prix). La lecture reprend où elle s\'arrête : tu peux quitter la page et revenir.',
        ok: 'Lancer la lecture',
    }, function() { gestionOcrToutSuite(g, genre, liste); });
};
function gestionOcrToutSuite(g, genre, liste) {
    g.erreur = null; g.message = null; g.lotFerme = null;
    var i = 0, coutTotal = 0;
    var suivant = function() {
        if (i >= liste.length) {
            g.busy = ''; g.progres = null;
            g.message = liste.length + ' document(s) lus, ' + coutTotal.toFixed(2) + ' $ au total.';
            g.etat = null; window.actions.gestionCharger(true); return;
        }
        var cle = liste[i];
        g.busy = genre + ':' + cle;
        var tour = function() {
            var charge = genre === 'fiche' ? { genre: 'fiche', item: cle } : { genre: 'college', nom: cle };
            window.syncWithServer('ocr_document', charge, function(d) {
                if (!d || !d.success) {
                    g.busy = ''; g.progres = null;
                    g.erreur = 'Arrêté sur « ' + cle + '  » : ' + ((d && d.message) || "l'OCR n'a pas abouti") +
                        (i ? ' — les ' + i + ' document(s) précédents sont lus.' : '');
                    g.etat = null; window.actions.gestionCharger(true); return;
                }
                g.progres = { fait: d.fait, total: d.total, doc: i + 1, docs: liste.length };
                if (!d.complet) { window.renderContent(); tour(); return; }
                coutTotal += (d.cout || 0); i++; window.renderContent(); suivant();
            });
        };
        window.renderContent(); tour();
    };
    suivant();
};
window.actions.gestionLotsEtat = function() {
    var g = window.state.gestion;
    window.syncWithServer('ocr_lot_etat', {}, function(d) {
        if (d && d.success) {
            var avant = JSON.stringify(g.lots || []);
            g.lots = d.lots || [];
            // Un lot vient d'être appliqué : l'inventaire a changé, on le relit.
            if (JSON.stringify(g.lots) !== avant && g.lots.some(function(l) { return l.statut === 'APPLIQUÉ'; })) { g.etat = null; window.actions.gestionCharger(true); return; }
        }
        window.renderContent();
    });
};
window.actions.gestionMiseEnForme = function(item, titre) {
    var g = window.state.gestion;
    if (g.busy) return;
    g.busy = 'forme:' + item; g.erreur = null; g.message = null; window.renderContent();
    window.syncWithServer('fiche_mise_en_forme', { item: item, titre: titre || '' }, function(d) {
        g.busy = '';
        // Idem : sans `fiche`, la réponse est inexploitable — message d'erreur métier, pas de cadre rouge.
        if (d && d.success && d.fiche) { g.message = 'Item ' + item + ' : ' + (d.fiche.sections || []).length + ' sections, ' + d.fiche.mots + ' mots'; g.etat = null; window.actions.gestionCharger(true); }
        else { g.erreur = (d && d.message) || 'Mise en forme impossible'; window.renderContent(); }
    });
};
window.actions.gestionOnglet = function(nom) {
    window.state.gestion.onglet = nom; window.state.gestion.erreur = null; window.state.gestion.message = null;
    if (nom === 'voix' && !(window.state.podcastVoiceList || []).length) window.loadPodcastVoices(false);
    if (nom === 'comptes' && !window.state.gestion.comptesCharges) window.actions.comptesCharger();
    window.renderContent();
};

// --- comptes utilisateurs (administrateur)
// Ce que l'administrateur voit de ses utilisateurs, et les deux gestes qu'il peut faire : couper ou rendre
// l'accès, et fabriquer un lien de réinitialisation. Jamais de mot de passe : il est haché, le clair n'existe
// nulle part (voir admin_lien_reset dans api.php).
window.actions.comptesCharger = function() {
    var g = window.state.gestion;
    g.busy = 'comptes'; g.erreur = null;
    window.syncWithServer('admin_comptes', {}, function(d) {
        g.busy = ''; g.comptesCharges = true;
        if (d && d.success) { g.comptes = d.comptes || []; g.moi = d.moi; }
        else g.erreur = (d && d.message) || 'Lecture des comptes impossible';
        window.renderContent();
    });
};
window.actions.compteOuvrir = function(id) {
    var g = window.state.gestion;
    if (g.compteOuvert === id) { g.compteOuvert = null; window.renderContent(); return; }
    g.compteOuvert = id;
    if (g.compteDetail[id]) { window.renderContent(); return; }
    g.busy = 'detail-' + id; window.renderContent();
    window.syncWithServer('admin_compte_detail', { user_id: id }, function(d) {
        g.busy = '';
        if (d && d.success) g.compteDetail[id] = d.plannings || [];
        else g.erreur = (d && d.message) || 'Détail illisible';
        window.renderContent();
    });
};
window.actions.compteStatut = function(id, statut) {
    var g = window.state.gestion;
    var c = (g.comptes || []).find(function(x) { return x.id === id; });
    if (!c) return;
    var couper = statut === 'suspendu';
    window.dialogue.confirmer({
        titre: couper ? 'Révoquer l\'accès de ' + c.email + ' ?' : 'Rendre l\'accès à ' + c.email + ' ?',
        message: couper
            ? 'Cette personne ne pourra plus se connecter, et sa session en cours tombera à sa prochaine action. Rien n\'est supprimé : son planning, son journal et son abonnement restent intacts, et tu peux lui rendre l\'accès quand tu veux.'
            : 'Cette personne pourra de nouveau se connecter avec son mot de passe habituel.',
        ok: couper ? 'Révoquer' : 'Rendre l\'accès', danger: couper,
    }).then(function(ok) {
        if (!ok) return;
        g.busy = 'statut-' + id; window.renderContent();
        window.syncWithServer('admin_compte_statut', { user_id: id, statut: statut }, function(d) {
            g.busy = '';
            if (d && d.success) { c.statut = d.statut; window.toast(couper ? 'Accès révoqué' : 'Accès rendu'); }
            else g.erreur = (d && d.message) || 'Changement impossible';
            window.renderContent();
        });
    });
};
window.actions.compteLienReset = function(id) {
    var g = window.state.gestion;
    g.busy = 'reset-' + id; g.lienReset = null; window.renderContent();
    window.syncWithServer('admin_lien_reset', { user_id: id }, function(d) {
        g.busy = '';
        if (d && d.success) g.lienReset = { email: d.email, lien: d.lien, minutes: d.expire_dans_min || 60 };
        else g.erreur = (d && d.message) || 'Lien impossible à produire';
        window.renderContent();
    });
};
window.actions.compteFermerLien = function() { window.state.gestion.lienReset = null; window.renderContent(); };
window.actions.compteCopierLien = function() {
    var l = window.state.gestion.lienReset;
    if (!l || !navigator.clipboard) return;
    navigator.clipboard.writeText(l.lien).then(function() { window.toast('Lien copié'); }, function() {});
};
// L'extrait est lu DANS LE NAVIGATEUR puis envoyé en base64 : pas de formulaire multipart, pas de fichier déposé
// sur le serveur — il ne fait que transiter vers l'API.
window.actions.gestionVoixFichier = function(input) {
    var g = window.state.gestion, f = input.files && input.files[0];
    if (!f) return;
    // Un MP3 de 25 s pèse environ 400 Ko : au-delà de 1,5 Mo, c'est que l'extrait est trop long ou trop lourd, et
    // l'envoi serait de toute façon refusé par le serveur.
    if (f.size > 1536 * 1024) { g.erreur = 'Extrait trop lourd (' + window.octets(f.size) + ') : garde 5 à 25 secondes — un MP3 de 25 secondes pèse environ 400 Ko. Raccourcis-le ou réencode-le plus léger.'; g.message = null; window.renderContent(); return; }
    var lecteur = new FileReader();
    lecteur.onload = function() {
        var r = String(lecteur.result || ''), i = r.indexOf('base64,');
        g.voixBrouillon.audio = i >= 0 ? r.slice(i + 7) : '';
        g.voixBrouillon.fichier = f.name; g.voixBrouillon.octets = f.size;
        if (!g.voixBrouillon.nom) g.voixBrouillon.nom = f.name.replace(/\.[^.]+$/, '').slice(0, 60);
        g.erreur = null; window.renderContent();
    };
    lecteur.onerror = function() { g.erreur = 'Extrait illisible.'; window.renderContent(); };
    lecteur.readAsDataURL(f);
};
window.actions.gestionVoixCloner = function() {
    var g = window.state.gestion, b = g.voixBrouillon;
    if (g.busy) return;
    // Les champs du formulaire ne sont lus qu'ici : un renderContent() à chaque frappe ferait perdre le curseur.
    var champ = function(id) { var el = document.getElementById(id); return el ? el.value : ''; };
    b.nom = champ('voix-nom').trim() || b.nom; b.genre = champ('voix-genre'); b.langues = champ('voix-langues') || 'fr';
    if (!b.audio) { g.erreur = 'Choisis d\'abord un extrait sonore.'; g.message = null; window.renderContent(); return; }
    if (!b.nom) { g.erreur = 'Donne un nom à la voix.'; g.message = null; window.renderContent(); return; }
    g.busy = 'voix'; g.erreur = null; g.message = null; window.renderContent();
    window.syncWithServer('voix_cloner', { nom: b.nom, genre: b.genre, langues: b.langues.split(/[,\s]+/).filter(Boolean), fichier: b.fichier, audio: b.audio }, function(d) {
        g.busy = '';
        if (d && d.success) {
            g.message = 'Voix « ' + (d.voix.name || d.voix.id) + ' » créée (' + d.voix.id + '). Elle est désormais proposée dans la fenêtre Podcast.';
            g.voixBrouillon = { nom: '', genre: '', langues: 'fr', fichier: '', audio: '', octets: 0 };
            window.loadPodcastVoices(true);
        } else { g.erreur = (d && d.message) || 'Création de la voix impossible'; }
        window.renderContent();
    });
};
// Diagnostic de la base : ce que voit api.php, et la réparation des colonnes trop petites depuis le site.
window.actions.gestionBase = function(reparer, viderErreurs) {
    var g = window.state.gestion;
    if (g.busy) return;
    g.busy = reparer ? 'base:reparer' : 'base'; g.erreur = null; g.message = null; window.renderContent();
    window.syncWithServer('gestion_base', reparer ? { reparer: true } : (viderErreurs ? { vider_erreurs: true } : {}), function(d) {
        g.busy = '';
        if (d && d.success) {
            g.base = d;
            if (reparer && d.reparation) {
                if (d.reparation.refus.length) g.erreur = 'MySQL a refusé : ' + d.reparation.refus.join(' ; ');
                else g.message = d.reparation.faits.length ? 'Réparé : ' + d.reparation.faits.join(', ') : 'Rien à réparer : toutes les colonnes sont assez grandes.';
            }
        } else { g.base = { sans_base: !!(d && d.sans_base) }; g.erreur = (d && d.message) || 'Diagnostic impossible'; }
        window.renderContent();
    });
};
window.actions.gestionVoixDiagnostic = function() {
    var g = window.state.gestion;
    if (g.busy) return;
    g.busy = 'diag'; g.erreur = null; g.message = null; window.renderContent();
    window.syncWithServer('voix_diagnostic', {}, function(d) {
        g.busy = '';
        if (d && d.success) g.voixDiag = d;
        else g.erreur = (d && d.message) || 'Diagnostic impossible';
        window.renderContent();
    });
};
window.actions.gestionVoixSupprimer = function(id, nom) {
    var g = window.state.gestion;
    if (g.busy) return;
    confirmerPuis({
        titre: 'Supprimer la voix « ' + (nom || id) + ' » ?',
        message: 'Les podcasts déjà sonorisés ne changent pas ; la voix ne sera plus proposée pour les prochaines synthèses.',
        ok: 'Supprimer', danger: true,
    }, function() {
        g.busy = 'voix:' + id; g.erreur = null; g.message = null; window.renderContent();
        window.syncWithServer('voix_supprimer', { id: id }, function(d) {
            g.busy = '';
            if (d && d.success) { g.message = 'Voix supprimée.'; window.loadPodcastVoices(true); }
            else { g.erreur = (d && d.message) || 'Suppression impossible'; }
            window.renderContent();
        });
    });
};
// Aperçu de la fiche remise en forme : le corps est mis en forme par le serveur (même rendu que la page
// imprimable), l'écran ne fait que l'afficher.
window.actions.gestionApercu = function(item, titre) {
    window.state.modalConfig = { type: 'fiche_planner', item: item, titre: titre || '', html: null, fiche: null, erreur: null };
    window.renderModal();
    window.syncWithServer('fiche_planner', { item: item }, function(d) {
        var c = window.state.modalConfig;
        if (!c || c.type !== 'fiche_planner' || c.item !== item) return;
        if (d && d.success) { c.html = d.html || ''; c.fiche = d.fiche || null; }
        else { c.erreur = (d && d.message) || 'Fiche introuvable'; }
        window.renderModal();
    });
};
// Le PDF passe par l'impression de la page autonome : c'est la seule voie qui marche partout, iPad compris,
// et elle donne un vrai PDF avec l'en-tête du site.
window.actions.gestionFichePdf = function(item) {
    window.open('api.php?action=fiche_planner_page&item=' + encodeURIComponent(item), '_blank', 'noopener');
};
// ---- Couverture du livre (Gestion → Couverture) ---------------------------------------------------------------
// L'image est lue DANS LE NAVIGATEUR puis envoyée en base64, comme l'extrait sonore des voix : pas de formulaire
// multipart à gérer côté serveur. C'est api.php qui vérifie que les octets sont bien ceux d'une image.
window.actions.gestionCouvertureCharger = function() {
    var g = window.state.gestion;
    if (g.couvChargee) return;
    g.couvChargee = true;
    window.syncWithServer('livre_couverture', {}, function(d) {
        if (d && d.success) { g.couvs = d.couvertures || {}; window.renderContent(); }
    });
};
window.actions.gestionCouvertureFichier = function(input, livre) {
    var g = window.state.gestion, f = input.files && input.files[0];
    if (!f) return;
    if (f.size > 12 * 1024 * 1024) { g.erreur = 'Image trop lourde (' + window.octets(f.size) + ') : 12 Mo au plus.'; g.message = null; window.renderContent(); return; }
    var lecteur = new FileReader();
    lecteur.onload = function() {
        g.busy = 'couverture'; g.erreur = null; g.message = null; window.renderContent();
        window.syncWithServer('livre_couverture', { livre: livre, fichier: f.name, image: String(lecteur.result || '') }, function(d) {
            g.busy = '';
            if (d && d.success) { g.couvs = d.couvertures || {}; g.message = d.message || 'Couverture enregistrée.'; }
            else { g.erreur = (d && d.message) || 'Envoi refusé.'; }
            window.renderContent();
        });
    };
    lecteur.onerror = function() { g.erreur = 'Image illisible.'; window.renderContent(); };
    lecteur.readAsDataURL(f);
};
window.actions.gestionCouvertureRetirer = function(livre) {
    var g = window.state.gestion;
    if (g.busy) return;
    confirmerPuis({
        titre: 'Retirer cette couverture ?',
        message: 'Le livre reprendra la couverture dessinée par le site tant qu\'aucune image ne sera déposée.',
        ok: 'Retirer', danger: true,
    }, function() {
        g.busy = 'couverture'; g.erreur = null; g.message = null; window.renderContent();
        window.syncWithServer('livre_couverture', { livre: livre, supprimer: true }, function(d) {
            g.busy = '';
            if (d && d.success) { g.couvs = d.couvertures || {}; g.message = d.message || 'Couverture retirée.'; }
            else { g.erreur = (d && d.message) || 'Suppression refusée.'; }
            window.renderContent();
        });
    });
};

// ---------------------------------------------------------------- pied de page


// ---------------------------------------------------------------- pages publiques, compte, pages légales
// Certaines pages se lisent sans être connecté : mot de passe oublié, réinitialisation, mentions légales,
// confidentialité, CGU/CGV, page introuvable. Elles ont la même barre, sans les boutons du compte.
window.PAGES_PUBLIQUES = ['mot-de-passe-oublie', 'reinitialiser', 'mentions-legales', 'confidentialite', 'cgv', '404'];
window.SITE = window.SITE || {};

window.actions.motDePasseOublie = function() {};
window.actions.reinitialiser = function() {};
window.actions.changerMotDePasse = function() {};
window.actions.supprimerCompte = function() {};


// Un seul redessin par image, même si plusieurs réponses du serveur arrivent d'un coup.
// Sans serveur, plus rien à montrer d'un planning qu'on ne peut pas lire : on le dit, et on propose de réessayer.
// Le serveur ne répond pas : l'état vide du système, et rien d'autre. Un écran d'erreur n'a pas besoin d'un
// dessin à lui — le même bloc centré que « Aucun partiel à venir » ou « Planning vide », avec son icône en
// encre 3, son titre, sa phrase et son unique bouton.
window.renderServeurInjoignable = function() {
    return String(window.html`<div class="vide">
        ${window.ico('cloud-slash', { taille: 32 })}
        <h2>Serveur injoignable</h2>
        <p>Ton planning est enregistré sur le serveur, qui ne répond pas pour le moment. Rien n'est perdu : réessaie dans un instant.</p>
        <!-- Pas d'icône dans ce bouton : .vide peint toute icône qu'il contient en encre 3 et à 32 px (c'est la
             règle du glyphe d'état), et le glyphe du bouton en ressortait gris et démesuré sur l'aplat cobalt. -->
        <button type="button" class="btn btn-primaire" data-action="rechargerPage">Réessayer</button>
    </div>`);
};
window.actions.rechargerPage = function() { location.reload(); };
// Les surfaces où l'on tape un mot de passe (lot B10). Ce qui y est saisi est gardé d'un redessin à l'autre, mais
// ne doit pas survivre au départ de la page : changer d'onglet ne recharge plus le document (pushState), donc rien
// ne remettrait ces valeurs à zéro et champ() reposerait le mot de passe en clair à la visite suivante.
// Voir compteOublierTout, src/ui/pages/compte.js.
var SURFACES_SENSIBLES = { compte: 1, 'mot-de-passe-oublie': 1, reinitialiser: 1 };
var surfaceRendue = null;
window.renderContent = function() {
    var c = document.getElementById('main-content');
    if(!c) return;
    // Quelle surface ce rendu vise : la page publique quand il y en a une, sinon l'onglet courant.
    var surface = (window.PAGE && window.PAGES_PUBLIQUES && window.PAGES_PUBLIQUES.indexOf(window.PAGE) !== -1)
        ? window.PAGE : (window.state && window.state.activeTab);
    if (surface !== surfaceRendue) {
        if (SURFACES_SENSIBLES[surfaceRendue] && window.compteOublierTout) window.compteOublierTout();
        surfaceRendue = surface;
    }
    // Page publique (mentions légales, CGV…) : son contenu est dessiné par renderPagePublique ; une réponse du
    // serveur (rôle, index) qui redessine « l'onglet courant » ne doit pas la remplacer par le tableau de bord.
    if (window.PAGE && window.PAGES_PUBLIQUES && window.PAGES_PUBLIQUES.indexOf(window.PAGE) !== -1) { window.renderPagePublique(); return; }
    var s = window.state;
    // Tant que le planning n'est pas lu, un squelette à la forme du contenu : on ne montre jamais « aucune séance »
    // alors que le serveur n'a pas encore répondu.
    if (s.isLoading) { c.innerHTML = String(s.activeTab === 'calendrier' && window.squeletteCalendrier ? window.squeletteCalendrier() : (s.activeTab === 'methode' && window.squeletteMethode ? window.squeletteMethode() : window.squelettePage())); return; }
    var html = '';
    var tdStr = window.todayStr();

    if(s.activeTab === 'dashboard') {
        html = String(window.renderAujourdhui());   // src/ui/pages/aujourdhui.js
    }

    else if(s.activeTab === 'accueil') {
        html = window.renderAccueil();
    }
    else if(s.activeTab === 'abonnement') {
        html = window.renderAbonnement();
    }
    else if(s.activeTab === 'gestion') {
        html = window.renderGestion();
    }
    else if(s.activeTab === 'lca') {
        html = window.renderLcaTab ? window.renderLcaTab() : '';
    }
    else if(s.activeTab === 'compte') {
        html = window.renderCompte();
    }
    else if(s.activeTab === 'calendrier') {
        html = String(window.renderCalendrier());   // src/ui/pages/calendrier.js
    }
    
    else if(s.activeTab === 'catalogue') {
        html = String(window.renderCatalogue());   // lot B6
        // Première peinture : le cadre d'abord, les lignes à l'image suivante. Redessin : les lignes tout de suite
        // (voir la fin de renderContent), sinon le tableau se vidait le temps d'une image.
        if (!window.__premierRenduFait) setTimeout(window.renderCatalogueList, 0);
    }
    
    else if(s.activeTab === 'qcm' || s.activeTab === 'training') {
        // Module QCM (et Training, qui en réutilise le moteur de séance) / statistiques / flashcards / active recall : voir qcm.js
        // Sans le moteur de QCM, l'onglet le dit dans l'état vide du système plutôt que dans un encart rouge
        // à classes de palette — c'était la dernière de src/legacy/app.js.
        html = window.renderQcmTab ? window.renderQcmTab() : String(window.html`<div class="vide">
            ${window.ico('warning-circle', { taille: 32 })}
            <h2>Moteur de QCM absent</h2>
            <p>Le module des QCM n'a pas été chargé. Recharge la page ; si l'onglet reste vide, c'est le fichier du site qui manque.</p>
            <button type="button" class="btn btn-primaire" data-action="rechargerPage">${window.ico('arrow-clockwise', { taille: 16 })}Recharger</button>
        </div>`);
    }

    else if(s.activeTab === 'stats') {
        html = window.renderStats();
    }
    else if(s.activeTab === 'methode') {
        html = String(window.renderMethode());   // lot B11
    }

    c.innerHTML = html;
    if(s.activeTab === 'catalogue' && window.__premierRenduFait) window.renderCatalogueList();
    if((s.activeTab === 'qcm' || s.activeTab === 'training') && window.afterRenderQcm) window.afterRenderQcm();
    window.animerContenu();
};


// Écran « Lots » : à gauche ce qu'on peut envoyer, en dessous les lots en cours et terminés, et le détail
// d'un lot terminé avec un bouton par item — rien n'est appliqué sans un clic.
// L'état d'un lot, en toutes lettres. Le champ `cls` qui accompagnait ce texte — trois jeux de classes de
// palette Tailwind — est parti au lot de clôture : la fenêtre des Lots choisit son aimant elle-même
// (aimantEtat, src/ui/modals/lots.js) et ne l'a jamais lu. C'est le mot qui porte l'état, pas la teinte.
window.lotStatutTexte = function(b) {
    if (b.status === 'in_progress') return { txt: 'en cours' + (b.counts ? ' · ' + ((b.counts.succeeded || 0) + (b.counts.errored || 0)) + '/' + b.total + ' traités' : '') };
    if (b.status === 'canceling') return { txt: 'annulation en cours' };
    if (b.status === 'ended') return { txt: b.done ? ('terminé · ' + b.ok + '/' + b.total + ' réussis' + (b.applied ? ' · ' + b.applied + ' appliqué' + (b.applied > 1 ? 's' : '') : '')) : 'terminé · résultats à récupérer' };
    return { txt: b.status || '?' };
};
window.lotsEnCours = function() { return (window.state.lots.list || []).filter(function(b) { return b.status === 'in_progress' || b.status === 'canceling'; }).length; };
window.lotsAAppliquer = function() { return (window.state.lots.list || []).filter(function(b) { return b.status === 'ended' && b.ok > b.applied; }).length; };

// Fenêtres refaites : un rendu par type de modalConfig, posé par son module (src/ui/modals/*). Le reste est historique.
window.MODALES = window.MODALES || {};
window.renderModal = function() {
    var m = document.getElementById('modal-root');
    if(!m) return;
    var s = window.state;

    if (s.lots.open) { m.innerHTML = String(window.renderLotsModal()); return; }
    // L'écran « Planifier » (lot B3) vit dans src/ui/modals/autoplan.js, chargé après ce fichier : la fenêtre
    // historique (quinze contrôles à 90vh, gestionnaires inline, palette Tailwind) est partie avec lui.
    if (s.showAutoPlanModal) {
        if (window.renderAutoplanModal) { m.innerHTML = String(window.renderAutoplanModal()); return; }
        s.showAutoPlanModal = false;   // sans le module, on ne laisse pas l'état bloqué sur une fenêtre absente
        m.innerHTML = '';
        return;
    }
    if (s.modalConfig) {
        var c = s.modalConfig;
        if (window.MODALES[c.type]) { m.innerHTML = String(window.MODALES[c.type](c)); return; }   // fenêtres refaites (src/ui/modals/*)

        // Toutes les fenêtres du produit passent désormais par la table ci-dessus : le livre des QCM
        // (window.MODALES['livre-qcm'], src/ui/pages/qcm.js), la fenêtre Podcast (src/ui/modals/podcast.js) et,
        // depuis le lot de clôture, les quatre dernières fenêtres historiques — partiels, sommaire NotebookLM,
        // fiche de séance, scindage — reprises dans src/ui/modals/planning.js. La cascade est vide : il ne reste
        // que le garde-fou, qui refuse de laisser l'état bloqué sur une fenêtre dont le module n'a pas été chargé.
        // Les types génériques 'confirm', 'prompt_date' et 'prompt_text' sont partis avec elle : plus rien ne les
        // posait (window.dialogue et ouvrirFormulaire les ont remplacés), et leur branche ne s'ouvrait plus.
        if (window.signalerErreur) window.signalerErreur(new Error('Fenêtre sans rendu : ' + c.type), 'modal');
        s.modalConfig = null;
        m.innerHTML = '';
    } else {
        m.innerHTML = '';
    }
};

// L'ossature de l'application : deux rails, le contenu, le pied, la barre basse. Posée une fois, puis remplie.
window.poserOssature = function() {
    var r = document.getElementById('app-shell');
    if (!r) return;
    r.innerHTML = '<div class="app">' +
        '<div class="rails">' +
            '<header id="app-header" class="rail-haut"></header>' +
            '<div id="planning-bar" class="rail-outils"></div>' +
        '</div>' +
        '<main id="main-content" class="contenu"></main>' +
        '<footer id="app-footer" class="pied"></footer>' +
        '<nav id="mobile-nav" class="barre-basse" aria-label="Onglets"></nav>' +
    '</div>';
};

window.renderApp = function() {
    var r = document.getElementById('app-shell');
    var s = window.state;

    if (window.PAGE && window.PAGES_PUBLIQUES.indexOf(window.PAGE) !== -1) { window.renderPagePublique(); return; }

    var fallback = document.getElementById('fallback-loading');
    if(fallback) fallback.style.display = 'none';
    r.style.display = 'block';

    // Chargement en cours : si ce navigateur était connecté à sa dernière visite, la coquille s'affiche tout de
    // suite et le contenu attend en squelette. Sinon on attend la réponse (écran de connexion ou application).
    if(s.isLoading) {
        var etaitConnecte = false; try { etaitConnecte = localStorage.getItem('edn_logged_in') === 'true'; } catch (e) {}
        if (!etaitConnecte) return;
        if(!document.getElementById('app-header')) window.poserOssature();
        window.renderHeader(); window.renderContent(); window.renderFooter();
        return;
    }

    // L'écran de connexion est celui du module src/ui/pages/connexion.js (lot B8), chargé avec le reste du
    // bundle : la façade historique qui lui servait de repli (héros sombre en Tailwind, icônes Font Awesome,
    // onclick et onkeydown inline) ne pouvait plus être atteinte et a été retirée. On garde tout de même la
    // garde : sur un bundle évalué à moitié, elle dit quoi faire au lieu de lever sur un nom absent.
    if(!s.isAuthenticated) {
        if (window.renderConnexion) r.innerHTML = String(window.renderConnexion());
        else r.innerHTML = '<p class="etat-vide">Chargement incomplet — recharge la page.</p>';
        return;
    }

    if(!document.getElementById('app-header')) window.poserOssature();

    window.renderPlanningBar();
    window.renderHeader();
    window.renderContent();
    window.renderFooter();
    window.renderModal();
};

// Lancement : l'écouteur DOMContentLoaded est posé à la toute fin de src/main.js, une fois TOUS les modules
// évalués. Le poser ici l'armait dès l'évaluation de ce fichier : si un module de src/ui/ levait à l'import,
// l'IIFE du bundle s'interrompait mais initApp partait quand même, sur des noms encore absents.

    
